export const MANUAL_DIMMING_RUNTIME_STRINGS = {
    RESPONSE_SUCCESS_HEX: 'ef5c0300',
    RESPONSE_FAIL_SAFE_HEX: 'ef5c03ad',
    RESPONSE_SUCCESS_SUFFIX: '00',
    RESPONSE_FAIL_SAFE_SUFFIX: 'ad',
    SET_RTC_TIMEOUT_MESSAGE: 'No response received from firmware for SetRTC command within timeout.',
    FAIL_SAFE_POPUP_TITLE: 'Process could not be completed.',
    FAIL_SAFE_POPUP_DESCRIPTION: 'Device is Under Fail Safe Mode',
    INVALID_LIGHT_INTENSITY_KEYWORD: 'invalid light intensity',
    FAIL_SAFE_MODE_KEYWORD: 'fail safe mode',
};

const resources: any = {
    translation: {
        SCAN_CONSTANT: {
            NO_DEVICE_FOUND: 'No Device Found Near By. Scan Again',
            SCAN_AGAIN: 'Scan Again',
            CANCEL_ADDING_DEVICES_TITLE: 'Cancel Adding Devices?',
            CANCEL_ADDING_DEVICES_SUBTITLE: 'Leaving now may interrupt the device setup process.',
            QUIT_NOW: 'Quit Now',
            STAY: 'Stay',
        },
        MESH_CONSTANT: {
            ZONES_HEADER_ACCESSIBILITY: 'Zones Header Section',
            ADD_NEW_ZONE_ACCESSIBILITY: 'Add New Zone',
            ZONES_LIST_ACCESSIBILITY: 'Zones List',
            NO_ZONES_EMPTY_ACCESSIBILITY: 'No Zones Empty State',
            NO_ZONES_EMPTY_ACCESSIBILITY_HINT: 'No zones found in this mesh, shows option to add first zone',
            ADD_FIRST_ZONE_ACCESSIBILITY: 'Add First Zone',
            ADD_FIRST_ZONE_ACCESSIBILITY_HINT: 'Create the first zone in this mesh network',
            MESH_NETWORK_ACCESSIBILITY: 'Mesh Network Information',
            AVAILABLE_STATUS: 'Available',
            STOP_OTA_LABEL: 'Stop OTA',
            STOP_OTA_ACCESSIBILITY_HINT: 'Stops the current firmware upgrade operation for this mesh',
            SYNC: 'Sync',
            SYNC_FIRMWARE: 'Sync',
            UPDATE_REQUIRED: 'Update Required',
            ENTITLEMENT_SYNC: 'Entitlements Sync',
            FIRMWARE_STATUS: 'Firmware Status',
            FIRMWARE_UPGRADE: 'Firmware Update',
            FIRMWARE_SCHEDULED: 'Scheduled',
            FIRMWARE_VERSION_SYNC: 'Firmware Version Sync',
            NEW_ZONE: 'New Zone',
            TIME_SYNC: 'Time Sync',
            DAYLIGHT_SAVING_ACTIVE: 'Daylight Saving Active',
            NO_ZONES_LABEL: 'No Zones Have Been Added.',
            ZONES_HEADER_ACCESSIBILITY_HINT: 'Header containing zones title, device count, and add zone button',
            ZONES_COUNT_ACCESSIBILITY_LABEL: 'Zones: {{count}} zones total',
            ZONES_COUNT_ACCESSIBILITY_HINT: 'Shows the number of zones in this mesh network',
            DEVICE_COUNT_ACCESSIBILITY_HINT: 'Shows total device count and their working status',
            ADD_NEW_ZONE_ACCESSIBILITY_HINT: 'Navigate to add zone screen to create a new zone in this mesh',
            ZONES_LIST_ACCESSIBILITY_HINT: 'List of {{count}} zones in this mesh network',
            ZONE_ITEM_ACCESSIBILITY_LABEL: 'Zone: {{name}}',
            ZONE_ITEM_ACCESSIBILITY_HINT: 'Navigate to zone details for {{name}} with {{deviceCount}} devices',
            LIGHTS: 'Lights',
            SUMMARY_TAB: 'Summary',
            CONTROLS_TAB: 'Controls',
        },
        ADD_ZONE_DEFAULT_MESH: 'Mesh Device',
        bluiRegistration: {
            USER_MENU: {
                CONTACT_US: 'Contact us',
            },
            CONTACT_SUPPORT: {
                GENERAL_QUESTIONS: 'General questions',
                SUPPORT_MESSAGE: 'For feedback questions or support please email us at',
                EMERGENCY_SUPPORT: 'Emergency Support',
                TECHNICAL_ASSISTANCE: 'For immediate support during business hours',
            },

            SELF_REGISTRATION: {
                INSTRUCTIONS:
                    'To register for an Eaton account. You will need to verify your email address to continue.',
                VERIFY_EMAIL: {
                    MESSAGE:
                        'A verification code has been sent to the provided email address. Click the link or enter the code below to continue. This code is valid for 30 minutes.',
                    VERIFICATION_CODE_PROMPT: 'Didn’t receive a code?',
                    VERIFICATION: 'Verification Code',
                },
            },
            REGISTRATION: {
                EULA: {
                    LICENSE_AGREEMENT: 'License Agreement & Privacy Policy',
                    OTHER_LANG: 'Other language EULA',
                    AGREE_TERMS:
                        'I read and hereby accept the terms of the Eaton Brightlayer Remote Monitoring EULA and the Privacy Notice.',
                    LOADING: 'Loading End User License Agreement',
                },
                STEPS: {
                    COMPLETE: 'Registration Completed',
                    LICENSE: 'License Agreement',
                    CREATE_ACCOUNT: 'Create an Account',
                    VERIFY_EMAIL: 'Verify Email',
                    ACCOUNT_DETAILS: 'Account Details',
                },
                INSTRUCTIONS: {
                    ACCOUNT_DETAILS: 'Enter your details below to complete account creation.',
                },
                AREA_CODE: 'Area Code',
                COUNTRY_CODE: 'Country Code',
                PHONE_NUMBER: 'Phone Number',
                MULTIFACTOR_AUTH_TEXT: 'Enable Two-factor Authentication',
                MULTIFACTOR_EXTRA_PROTECTION_TEXT:
                    'We’ll ask for your password and then a login code when we notice an unusual login request for your account.',
            },
            MULTIFACTOR_SMS_TEXT: 'A code will be sent to you via SMS Message or Email.',
            MULTIFACTOR_TITLE: 'Secure Your Account With Two-Factor Authentication',
            PREVENT_UNAUTHORIZED_ACCESS_FOR_YOUR_ACCOUNT:
                'Prevent unauthorized access for your account by adding an additional layer of security. When you sign in, two-factor authentication helps make sure your information remains safe, private and secure.',
            COMMON: {
                COUNTRY: 'Country',
            },
            FORMS: {
                FIRST_NAME: 'First Name',
                LAST_NAME: 'Last Name',
            },
            LABELS: {
                NEED_ACCOUNT: 'Need an Account?',
                EMAIL: 'Email Address',
            },
            LOGIN: {
                BTN_LABEL: 'Log In',
                BTN_LABEL_OKTA: 'Log In with Okta',
                WELCOME: 'Welcome {{name}}!',
                LOGIN_WITH:
                    'Your account has been successfully created. Please log in with your Okta account email and password',
                EMAIL_CREATION_SUCCESS_TXT: 'Your user account has been successfully created with the email',
                AUTHENTICATION_FAILED: 'Authentication Failed!',
                DONT_HAVE_AN_ACCOUNT: 'Don‘t have an account?',
            },
            MESSAGES: {
                VERIFICATION_CODE_SENT: '{{field}} verification code sent.',
                CONTACT: 'Need Help?',
                PRIVACY: 'Brightlayer Privacy Notice',
                EU_DATA_ACT_POLICY: 'EU Data Act Notice',
                REMOTE_MONITORING: 'Remote Monitoring',
                CONTACT_EMAIL: 'BLSupport@eaton.com',
                CONTACT_PHONE: '1-877-ETN-CARE',
                CONTACT_PHONE_LINK: '1-877-ETN-CARE',
                EMAIL_ENTRY_ERROR: 'Please enter a valid email.',
                ERROR: 'Error',
                SIGN_UP: 'Sign up',
            },
            ACCEPT_TOS_PRIVACY: {
                TOS: 'Terms of Service for Brightlayer Cloud Services',
                PRIVACY: 'Brightlayer Privacy Notice',
            },
            LOGIN_SUCCESS: {
                WELCOME: 'Welcome {{name}}',
            },
            ERROR_PAGE: {
                BACK_TO_HOME_LABEL: 'Back to Home',
                DESCRIPTION: {
                    DEFAULT: 'Please activate your account before accepting invite.',
                    REALM_NOT_EXIST: `The Realm you're looking for does not exists`,
                    SUSPEND_REALM: 'Please contact your Administrator!',
                    ACTION_EXPIRED: 'Please login again',
                },
                ACTION_EXPIRED: 'Action Expired!',
                REALM_SUSPENDED: 'Realm Suspended!',
                REALM_DOES_NOT_EXISTS: 'Realm Does Not Exists!',
                INACTIVE_ACCOUNT: 'Inactive Account!',
                ACTIONS: {
                    CREATE_ACCOUNT: 'Sign Up',
                    OKAY: 'Ok',
                },
            },
            PRIVACY_POLICY_CONTENT:
                '<0> <0>Privacy notice / your privacy rights</0> <br/> Brightlayer remote monitoring dashboard <br />(BRMD Services)</0><1>  This Notice contains details about how Eaton collects and uses information from you and the entity you represent (collectively, the “Authorized Party”) when the Authorized Party uses the BRMD Services.</1><1>Whenever you download, install or operate the BRMD Services Application or use the BRMD Services in any other way, you represent that you are an agent or representative of an Authorized Party, and that you have the authority to use the Services on behalf of such Authorized Party.</1> <1> This Notice covers only the Services identified above, and does not apply to information which the Authorized Party may send us by other means. Other Eaton sites, applications and other online services or locations may have their own privacy policies, and the Authorized Party should consult those accordingly. </1> <1> Please read this Notice carefully to understand our practices regarding the Authorized Party’s information and how we will treat it. If the Authorized Party does not agree with our policies and practices, do not download, install or operate the BRMD Services and do not interact with any other part of the Services. By using the Services, the Authorized Party agrees to the terms of this Notice. </1> <1> This Notice is effective as of: ……………. </1> <2> Notice Changes </2> <1> Eaton may update this Notice from time to time. Any changes to this Notice will be posted for a period of thirty (30) days and will be effective when posted (see https……. ). The changes will also be immediately incorporated into this Notice. </1> <1> Continued use of the Services by the Authorized Party after any changes are made to this Notice constitutes the Authorized Party’s acceptance of the changes, so please check this Notice periodically for updates. If any of the changes are unacceptable to the Authorized Party, the Authorized Party should cease using the Services </1> <1> If any changes to this Notice materially affect how Eaton treats or handles personal data that the Authorized Party has already provided to Eaton or that has otherwise been collected by us, we will notify the Authorized Party by email (if we have a valid email address to use) and give the Authorized Party thirty (30) days to opt-in to the changes as they pertain to the Authorized Party’s information. If the Authorized Party does not opt-in, its information will continue to be used in a manner that is consistent with the version of this Notice under which it was collected, or the information will be deleted.</1> <2> Personal data (“Personal Data”) is generally defined as information that may be able to identify a natural person, information that could reasonably be linked to such person, or information that may be used to get access to personal accounts. Personal Data could include, but is not limited to, name, address, telephone number, email address, username and password, IP address or other online identifiers, credit/debit card number or other financial information, professional or employment-related information, office address and other business information, etc.</2> <2> There are certain parts of the Services where the Authorized Party may be asked to provide Eaton with Personal Data, or where such Personal Data or other information may be collected from the Authorized Party in an automated manner. For example, Eaton may collect Personal Data (and other related information) such as name, title, residential and/or business address(es), email address(es), personal and/or business telephone number(s), and employer information when the Authorized Party: </2><3> - Process the Authorized Party’s account registration on the Site and/or in connection with the BRMD Service; <br /> - Administer the Authorized Party’s account in connection with the Services; <br /> - Provide the Services, its contents and related information to the Authorized Party; <br /> - Maintain proper business records and other relevant records; <br /> - Provide ongoing technical support related to the Authorized Party’s account; <br /> - Contact the Authorized Party if there are issues with content that was uploaded or posted through the Services; <br /> - Respond to questions and comments; <br /> - Communicate with the Authorized Party regarding additional uses of the Personal Data it provides which go beyond the scope of this list; <br /> - Process and catalog the Authorized Party’s responses to surveys or questionnaires; <br /> - Evaluate and improve the content and general administration of the Services; <br /> - Perform internal operations related to the Services; <br /> - Troubleshoot software issues and operational problems with the Services; <br /> - Conduct data analysis and testing; and/or <br /> - Monitor usage patterns for the Services. </3><2> The Site or BRMD Services may use cookies. Cookies are files that are transmitted to the Authorized Party’s computer when the Authorized Party visits the Site or uses the BRMD Services. Cookies allow Eaton to recognize the Authorized Party’s browser when it subsequently returns to the Site or uses the BRMD Services again. Cookies may also collect the Authorized Party’s user preferences when  visiting the Site or using the BRMD Services. Eaton uses cookies to manage acceptance of Eaton’s Terms of Use/Legal Notice/End-User License Agreement for the Services and this Notice. The Authorized Party may be able to disable the cookies by consulting the relevant browser and/or computer instructions. Please note that disabling cookies could affect how the Site and/or BRMD Services appear and/or operate for the Authorized Party.</2>',
            HELP_SCREEN_CONTENT:
                '<0>General Questions </0> <1>  For feedback, questions, or support please email us at<0> {{email}}</0>.</1> <0>Emergency Support </0> <1>For immediate support during business hours, <br /> <0>{{number}}</0>, Option 2, Option 9.',
            ACTIONS: {
                CLOSE: 'Close',
                CREATE_ACCOUNT: 'Sign Up',
                NEXT: 'Next',
                BACK: 'Back',
                RESEND: 'Send Again',
                OKAY: 'Ok',
                DONT_HAVE_ACCOUNT: "Don't have an account?",
            },
            CLOSE: 'Close',
            QRCODE: {
                INSTRUCTIONS:
                    'To provision your device you can either download the app or launch it in your web browser.',
                DOWNLOAD_BTN_LBL: 'Download the Mobile Application',
                LAUNCH_BTN_LBL: 'Launch the Application in a browser',
                EXPLORE_BTN_LBL: 'Explore Eaton-Brightlayer Enabled UPS Line',
            },
            primaryauth: {
                title: 'Sign In',
            },
            oform: {
                next: 'Next',
            },
            oie: {
                remember: 'Keep me signed in',
            },
            RESEND: 'Resend',
        },
        MFA: {
            REQUEST_CODE_MSG: 'Request a Security Code',
            SENT_CODE_MSG: 'We Sent A Code!',
            SELECT_CODE_DEST_MSG: 'Select where you would like the security code sent.',
            CHECK_DEST_MSG: 'Check {{field}} for a code and enter it below',
            GET_NEW_CODE_LABEL: 'Send Again',
            VERIFY_CODE_FAIL_MSG: 'Verification code incorrect.',
            TRY_AGAIN: 'Please try again.',
            VERIFICATION_CODE_SENT: '{{field}} verification code sent.',
            VERIFY_TRIES_LEFT_MSG: 'You have {{field}} more attempt(s).',
            NO_VERIFY_TRIES_LEFT_MSG: "Error, you've exceeded your ten attempts. Send new code.",
        },
        ACCEPT_EULA: {
            WEB_LICENSE_AGREEMENT: 'License Agreement & Privacy Policy',
            LICENSE_AGREEMENT: 'License Agreement',
            ACCEPT_BTN: 'Accept',
            CONTINUE_BTN: 'Continue',
            CANCEL_BTN: 'Cancel',
            BACK_BTN: 'Back',
            NEXT_BTN: 'Next',
            EULA_UPDATE_NOTE: 'We Updated Our License Agreement & Privacy Policy',
            EULA_CHECKBOX_TEXT:
                'I read and hereby accept the terms of the Eaton Brightlayer Remote Monitoring EULA and the Privacy Notice.',
            EULA_UPDATE_CHECKBOX_TEXT:
                'I read and hereby accept the terms of the Eaton Brightlayer Remote Monitoring Terms of service and the Privacy Notice.',
        },
        COMMON: {
            COMMENT_SUBMITTED_SUCCESS: 'Comment submitted successfully.',
            COMMENT_SUBMIT_ERROR: 'An error occurred while saving the comment.',
            COMMENT_SUBMIT_FORBIDDEN:
                'You are not entitled to add comments for this device’s organization. Contact an administrator if you believe this is an error.',
            MORE_LABEL: 'More ',
            MORE_OPTIONS: 'More Options',
            PLEASE_DO_NOT_CLOSE_THE_WINDOW: 'Please do not close the window',
            NO_INTERNET_TITLE: 'No Internet',
            NO_INTERNET_MESSAGE:
                'It seems you are not connected to the internet. Please check your network settings and try again.',
            RETRY: 'Retry',
            ACTIONS: 'Actions',
            ALERTS: 'Alerts',
            OFFLINE_DEVICES: 'Offline Devices',
            SUB_GROUP: 'Sub Group',
            EDIT: 'Edit',
            EDIT_DETAILS: 'Edit Details',
            EDIT_DEVICE_NAME: 'Edit Device Name',
            EDIT_DEVICE_NAME_SUBTITLE: 'Device Name',
            ACTIVATE: 'Activate',
            DUPLICATE: 'Duplicate',
            SAVE_LABEL: 'Save',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            SEARCH_PLACEHOLDER: 'Search',
            DATE: 'Date',
            NAME: 'Name',
            OF: 'of',
            DEVICE: 'Device',
            ZONE: 'Zone',
            API_ERROR: 'API error',
            PROXY_DEVICE_NOT_FOUND: 'Proxy device not found',
            DAYLIGHT_SAVING_INVALID_RESPONSE: 'Invalid response from device',
            DAYLIGHT_SAVING_PAYLOAD_ERROR: 'Unable to sync daylight saving settings',
            DAYLIGHT_SAVING_NETWORK_ERROR: 'Network error while updating daylight saving',
            DAYLIGHT_SAVING_DEVICE_ERROR: 'Device rejected daylight saving update (Error: {{errorCode}})',
            DAYLIGHT_SAVING_START_ERROR: 'Failed to start daylight saving update',
            SURE_DEVICE: 'Devices',
            DEVICES: 'Device(s)',
            DEVICE_MODELS: 'Device Models',
            TYPE: 'Type',
            MODEL: 'Model',
            GROUP: 'Group',
            ALERT: 'Alert',
            TAGS: 'Tags',
            SERIAL: 'Serial #',
            DETAILS: 'Details',
            PREVIEW: 'Preview',
            UPCOMMING: 'Upcoming',
            UPLOAD: 'Upload',
            STATUS: 'Status',
            SEVERITY: 'Severity',
            CLEAR_FILTER: 'Clear All Filters',
            MANAGE_REALMS: 'Manage Realms',
            ADD_AN_ORGANIZATION: 'Add an Organization',
            EVENTS: 'Events',
            USERS: 'Users',
            USERS_SERVICE_ACCOUNTS: 'Users / Service Accounts',
            SERVICE_ACCOUNTS: 'Service Accounts',
            NOTIFICATION_TYPES: 'Notification Types',
            ENABLED: 'Enabled',
            AUTOMATION_NAME: 'Automation Name',
            TRIGGERS: 'Triggers',
            TRIGGER: 'Trigger',
            ACTION: 'Action',
            DESCRIPTION: 'Description',
            REALM_LABEL: 'Realm',
            COPY_SUCCESS: 'Copied successfully',
            GROUPS_AND_DEVICES: 'Groups & Devices',
            GROUPS: 'Groups',
            IP_ADDRESS: 'IP Address',
            ASSIGNMENT: 'Assignment',
            LAST_MODIFICATION: 'Last Modification',
            USED_ON: 'Used on',
            RENAME: 'Rename',
            CLONE: 'Clone',
            ASSOCIATE_DEVICES: 'Associate Devices',
            DEFAULT: 'Default',
            APPLY: 'Apply',
            SUBSCRIPTION: 'Subscription',
            LICENSE_NAME: 'License Name',
            NEXT: 'Next',
            MODIFIED: 'Modified',
            DATA_SOURCE: 'Data Source',
            OPEN_ORG: 'Open Organization',
            VIEW_REALM: 'View Realm',
            MOVE: 'Move',
            SHOW_MORE: 'Show More...',
            LOADING: 'Loading...',
            COMMENTS: 'Comments',
            LOADING_TIMEOUT_MESSAGE: 'Loading is taking longer than expected',
            LOADING_TIMEOUT_INSTRUCTIONS_MSG:
                'An error may have occurred. Please try closing and restarting the application.',
            SUMMARY: 'Summary',
            CUSTOMIZE: 'Customization',
            REALM_ORGS: 'Realms & Orgs',
            ORGANIZATIONS: 'Organizations',
            DASHBOARDS: 'Dashboards',
            AUDIT_LOGS: 'Audit Logs',
            WIDGETS: 'Widgets',
            ORG_LABEL: 'Organization',
            JOIN_ORG: 'Join an Organization',
            ORG_NAME: 'Organization Name',
            OPEN: 'Open',
            ASSIGN_ROLE: 'Assign Role',
            PREVIOUS: 'Previous',
            SELECT_ALL: 'Select All',
            UNSELECT_ALL: 'Unselect All',
            EXPANDED: 'Expanded',
            COLLAPSED: 'Collapsed',
            CHANNELS: 'Channels',
            TO: 'to',
            OK: 'Ok',
            SEND_BY_MAIL: 'Send By Email',
            // Time-related translations
            TODAY: 'Today',
            YESTERDAY: 'Yesterday',
            JUST_NOW: 'just now',
            AT: 'at',
            MIN_AGO: '{{count}} min ago',
            HRS_AGO: '{{count}} hr ago',
            HRS_AGO_PLURAL: '{{count}} hrs ago',
            DAYS_AGO: '{{count}} day ago',
            DAYS_AGO_PLURAL: '{{count}} days ago',
            MONTHS_AGO: '{{count}} month ago',
            MONTHS_AGO_PLURAL: '{{count}} months ago',
            YEARS_AGO: '{{count}} year ago',
            YEARS_AGO_PLURAL: '{{count}} years ago',
            SYNC_TO_FETCH_LATEST: 'sync to fetch latest values',
            TIMELINE: 'Timeline',
            UPCOMING: 'Upcoming',
            LOADS: 'Loads',
            PROPERTIES: 'Properties',
            GATEWAY_DEVICES: 'Gateway Devices',
            VIRTUAL_LOADS: 'Virtual Loads',
            DEVICE_SNOOZED: 'Device Snoozed',
            DEVICE_PROPERTIES: 'Device Properties',
            ASSET_NAME_TAG: 'Asset Name',
            REPORTS: 'Reports',
            DOCUMENTS: 'Documents',
            MONTHLY_REPORTS: 'Monthly Reports',
            CLOSE: 'Close',
            REQUEST_SERVICE: 'Service Request Form',
            SETTINGS: 'Settings',
            TRENDS: 'Trends',
            SUBMIT_CHANGES: 'Submit Changes',
            ENTER_LOCATION: 'Enter your location or search using latitude and longitude.',
            DISCARD: 'Discard',
            DISCARD_CHANGES: 'Discard Changes',
            DISCARD_CHANGES_MODAL_TITLE: 'Discard Changes?',
            CONTINUE: 'Continue',
            ACTION_UNDONE_WARNING_DEVICE: `Select 'Continue' to discard your changes or 'Go Back' to save your changes.`,
            ACTION_UNDONE_WARNING: 'This action cannot be undone.',
            EMAIL_ADDRESS: 'Email Address',
            SMS: 'SMS',
            PHONE: 'phone',
            YOUR_SMS: 'your SMS',
            EMAIL: 'email',
            PHONECALL: 'Phone Call',
            YOUR_EMAIL: 'your email',
            ADD_DEVICE: 'Add Device',
            ADD_ROLE: 'Add Role',
            VERIFY: 'Verify',
            ADD_REALM: 'Add Realm',
            CREATE_REALM: 'Create Realm',
            ADD_ORGANIZATION: 'Add Organization',
            IMAGES: 'Images',
            DELETE_TEXT_FIELD_LABEL: 'Type "delete" to confirm',
            REMOVE_TEXT_FIELD_LABEL: 'Type "remove" to confirm',
            LANGUAGE: 'Language',
            DATE_FORMAT: 'Date Format',
            DELETE_HEADER: 'Delete {{name}} ?',
            ALL_REALMS: 'All Realms',
            ALL_GROUPS: 'All Groups',
            ALL_DEVICES: 'All Devices',
            EMERGENCY_CONTACTS: 'Emergency Contacts',
            ALL_DEVICE_MODELS: 'All Device Models',
            DELETE_DEVICE: 'Delete Device',
            DELETE_DEVICE_FAILED: 'Failed to delete device',
            DELETE_DEVICES_FAILED: 'Failed to delete devices',
            DELETE_DEVICE_TIMEOUT:
                '{{successCount}} of {{totalDevices}} devices deleted. Remaining devices will reappear in scan as orphans.',
            DELETE_DEVICE_TIMEOUT_WITH_ORPHANS:
                '{{successCount}} of {{totalDevices}} devices deleted successfully. {{orphanCount}} orphan device(s) will reappear in scan.',
            DELETE_DEVICE_SUCCESS: '{{successCount}} Device deleted successfully.',
            DELETE_DEVICE_SUCCESS_WITH_NAME: '{{deviceName}} deleted successfully.',
            DELETE_DEVICES_SUCCESS_PLURAL: '{{successCount}} Devices deleted successfully.',
            DELETE_DEVICES_PARTIAL_SUCCESS:
                '{{successCount}} of {{totalDevices}} devices deleted successfully and {{notReachedCount}} device could not be reached.',
            DELETE_DEVICES_PARTIAL_SUCCESS_PLURAL:
                '{{successCount}} of {{totalDevices}} devices deleted successfully and {{notReachedCount}} devices could not be reached.',
            DELETE_DEVICE_WITH_ORPHANS:
                '{{successCount}} device(s) deleted successfully. {{orphanCount}} orphan device will reappear in scan.',
            DELETE_DEVICES_WITH_ORPHANS_PLURAL:
                '{{successCount}} device(s) deleted successfully. {{orphanCount}} orphan devices will reappear in scan.',
            DELETE_DEVICE_SUCCESS_WITH_ORPHAN:
                '{{successCount}} Device deleted successfully. {{orphanCount}} orphan device will reappear in scan.',
            DELETE_DEVICE_SUCCESS_WITH_ORPHANS:
                '{{successCount}} Device deleted successfully. {{orphanCount}} orphan devices will reappear in scan.',
            DELETE_DEVICES_SUCCESS_WITH_ORPHAN:
                '{{successCount}} Devices deleted successfully. {{orphanCount}} orphan device will reappear in scan.',
            DELETE_DEVICES_SUCCESS_WITH_ORPHANS:
                '{{successCount}} Devices deleted successfully. {{orphanCount}} orphan devices will reappear in scan.',
            DELETE_ORPHAN_DEVICE_REAPPEAR: '{{orphanCount}} orphan device will reappear in scan.',
            DELETE_ORPHAN_DEVICES_REAPPEAR: '{{orphanCount}} orphan devices will reappear in scan.',
            DELETE_DEVICE_ERROR:
                '{{successCount}} of {{totalDevices}} devices deleted. Failed devices will reappear in scan as orphans.',
            DELETE_DEVICE_ERROR_WITH_ORPHANS:
                '{{successCount}} of {{totalDevices}} devices deleted successfully. {{orphanCount}} orphan device(s) will reappear in scan.',
            DELETE_DEVICE_NO_DEVICES: 'No devices to delete.',
            DELETE_RESULT_HEADING: 'Delete Device?',
            DELETE_RESULT_HEADING_PLURAL: 'Delete Devices?',
            DELETE_RESULT_TITLE: 'The delete operation was initiated for <b>{{totalDevices}} devices</b>.',
            DELETE_RESULT_SUCCESS: '<b>{{successCount}} device</b> deleted successfully.',
            DELETE_RESULT_SUCCESS_PLURAL: '<b>{{successCount}} devices</b> deleted successfully.',
            DELETE_RESULT_FAILURE: '<b>{{failedCount}} device</b> could not be deleted due to a connection issue.',
            DELETE_RESULT_FAILURE_PLURAL:
                '<b>{{failedCount}} devices</b> could not be deleted due to a connection issue.',
            DELETE_RESULT_FOOTER: 'The failed device will remain visible in the Zone List.',
            DELETE_RESULT_FOOTER_PLURAL: 'The failed devices will remain visible in the Zone List.',
            DELETE_RESULT_FOOTER_ORPHAN:
                'The failed device will remain visible in the Zone List, and it will be identified as orphan device during scanning.',
            DELETE_RESULT_FOOTER_PLURAL_ORPHAN:
                'The failed devices will remain visible in the Zone List, and it will be identified as orphan device during scanning.',
            DELETE_RESULT_FOOTER_PLURAL_ORPHANS:
                'The failed devices will remain visible in the Zone List, and <b>{{orphanCount}}</b> of them identified as orphan devices during scanning.',
            DELETE_DEVICE_FAILED_DEVICE_RETRY: 'Failed to delete {{deviceName}}. Please try again.',
            DELETE_DEVICE_ERROR_RETRY: 'Error deleting {{deviceName}}. Please try again.',
            EDIT_DEVICE: 'Edit Device',
            ADD_GROUP: 'Add Group',
            DELETE_GROUP: 'Delete Group',
            DELETE_ZONE: 'Delete Zone',
            DELETE_AUTOMATIONS: 'Delete Automations',
            DELETE_AUTOMATION: 'Delete Automation',
            OKAY: 'OK',
            MOVE_GROUPS_AND_DEVICES: 'Move Groups & Devices',
            GROUP_MANAGEMENT: 'Group Management',
            SWITCH_ORGS: 'Switch Organization',
            VIEW_IN_CUSTOMER_PORTAL: 'View in Customer Portal',
            DELETE: 'Delete',
            DEVICE_DATA_NOT_AVAILABLE: 'Device data not available',
            DEVICE_NAME_UPDATED_SUCCESSFULLY: 'Device name updated successfully',
            FAILED_TO_UPDATE_DEVICE_NAME: 'Failed to update device name',
            ADD: 'Add',
            APPLY_ALL_ORGS: 'Apply to All Organizations',
            ADD_AUTOMATION: 'Add an Automation',
            ALL_EVENTS: 'All Events',
            CONFIRM: 'Confirm',
            REMOVE: 'Remove',
            APPROVE: 'Approve',
            SOMETHING_WENT_WRONG: 'Something went wrong',
            NOT_APPLICABLE: 'N/A',
            EXPORT: 'Export',
            SUSPENDED: 'Suspended',
            RESTORED: 'Restored',
            DOWNLOAD: 'Download',
            NO_DATA: 'No Data Found',
            GO_BACK: 'Go Back',
            SUBMIT_LABEL: 'Submit',
            CUSTOM_TNC: 'Custom Terms and Conditions',
            SAVE_CHANGES: 'Save Changes',
            MY_PROFILE: 'My Profile',
            REALM_DESCRIPTION: 'Realm Description',
            COUNTRY: 'Country',
            NO_SETTINGS_AVAILABLE: 'No settings available',
            REMOVE_USERS: 'Remove User(s)',
            ASSIGN_TO_GRP: 'Assign to Group',
            SCAN_AGAIN: 'Scan Again',
            PROXY_SETTINGS: 'Proxy Settings',
            ADD_CONFIG_PROFILE: 'Add Configuration Profile',
            ERROR_TITLE: 'Error',
            DELETE_VAL: 'Delete {{name}}?',
            DELETE_TAGS: 'Delete Tag(s) ?',
            UPLOAD_ORG_LOGO: 'Upload Organization Logo',
            JOIN_ANOTHER_ORG: 'Join Another Organization',
            FINISH: 'Finish',
            AWAIT_APPROVAL: 'Awaiting Approval',
            MAX_UPLOAD_SIZE: 'PNG, JPG (300x300px), 2 MB Max.',
            LEAVE_ORG_DESC: 'Once you leave this Organization you will lose all access.',
            LEAVE_ORG: 'Leave Organization',
            ASSIGN_USER_LEAVE_ORG: 'Assign Another User the Organization Admin Role Before Leaving',
            BACK: 'Back',
            PASSWORD: 'Password',
            COPY_TO_CLIPBOARD: 'Copy to Clipboard',
            COPY_GUID_TO_CLIPBOARD: 'Copy GUID to Clipboard',
            COPY_SERIAL_NUMBER_TO_CLIPBOARD: 'Copy Serial# to Clipboard',
            FILTER_BY_SERIAL_NUMBER: 'Filter by Serial #',
            DEVICE_COUNT_CONSUME_MSG: '⚠ Device count will be consumed',
            DEVICE_COUNT_NOT_CONSUME_MSG: '✓ Device count will not be consumed',
            ADD_USER: 'Add User',
            REALMS_AND_ORGS: 'Realms & Organizations',
            STATE: 'State',
            CONTACT_NAME: 'Contact Name',
            LOCATION: 'Location',
            LOCATION_REQUIRED: 'Location Required',
            LOCATION_REQUIRED_BODY:
                'Emergency responders will respond to the location set in the organization or group settings when an emergency notification is sent for devices. Please enter location data in the organization or group settings where you would like to add the emergency contact.',
            LAT: 'Latitude',
            LNG: 'Longitude',
            SERVICE_PORTAL: 'Service Portal',
            NO_CUSTOM_NOTIFICATION: 'No Custom Notifications',
            REQUIRED_LABEL: 'Required',
            TEXT_FIELD_INVALID_CHARS_ERROR:
                "Your input contains characters that aren't allowed. Please update and try again.",
            CREATE_ORG: 'Create an Organization',
            REPLACE: 'Replace',
            REALM_ORG_NAME: 'Realm / Org Name',
            UNITS: 'Units',
            VIEW_FULL_CHART: 'View Full Chart',
            SELECTED_CHANNELS: 'Selected Channels',
            LINK_DEVICES: 'Link to a specific device or devices',
            DISPLAY_VIEW_ALL: 'Display “View All” bar',
            LINK_TO_GRP: 'Link to specific group(s)',
            NOT_LINKED_MSG: 'Not linked to a specific group',
            NOT_LINKED_DESC:
                'This widget will display the immediate child groups of the group dashboard on which the widget is placed.',
            SNOOZED: 'Snoozed',
            DEVICE_TYPE: 'Device type',
            GATEWAY: 'Gateway',
            OFFLINE: 'Offline',
            UPS: 'UPS',
            PDU: 'PDU',
            SENSOR: 'Sensor',
            WARNINGS: 'Warnings',
            SHOW_ALL: 'Show All',
            DISCARD_CHANGES_TITLE: 'Discard Changes?',
            ADD_A_DEVICE: 'Add a Device',
            DISPLAY: 'Display',
            SELECT_GROUP_NO_DESC: 'You can add groups to better organize Devices.',
            USER_ORGS: 'Organization (s)',
            LINK_TO_GRPS_DEVICES: 'Link to specific group(s) or device(s)',
            MOVE_CHILDREN: 'Move Children',
            FILE_DOWNLOAD_SUCCESS: 'File downloaded successfully.',
            ACKNOWLEDGE_SUCCESS_MSG: 'Acknowledged Successfully',
            ACKNOWLEDGE: 'Acknowledge',
            CHANGES_SAVED: 'Changes saved.',
            CHANGES_SAVED_SUCCESS: 'Changes Saved Successfully.',
            SAVING: 'Saving...',
            ACTIVATING: 'Activating...',
            REMOVE_PHOTO: 'Remove Photo',
            MAP: 'Map',
            NO_DEVICES: 'No Devices',
            EDIT_GROUP: 'Edit Group',
            GROUP_FILTER_HEADER: 'Filter by Groups & Devices',
            EXPORT_HEADING: 'Fields marked with an asterisk(*) are required to add a Device.',
            FILE_TYPE: 'File Type *',
            FILE_LOCATION: 'Choose file location *',
            AUTOMATION_SUBHEADING: 'Automation',
            DISABLED: 'Disabled',
            AND: 'and',
            OTHER: 'other',
            DONE: 'Done',
            NOT_LINKED_TO_ANY: 'Not linked to any group or device',
            UPLOAD_A_PHOTO: 'Upload a Photo',
            UPLOAD_BTN_INSTRUCTIONS: 'Use Upload Button or Drag and Drop',
            MAX_FILE_SIZE: 'Maximum file size of 2MB PNG or JPG',
            NO_ORGS: 'No Organization',
            NO_DETAILS: 'No Details Available',
            PRIORITY: 'Priority',
            PRIVILEGES: 'Privileges',
            ROLE: 'Role',
            DELETE_ROLE: 'Delete Role',
            NAME_AND_DESCRIPTION: 'Name & Description',
            ALL_USERS_WITH_ACCESS: 'All Users with Access',
            LAST_UPDATE_RECEIVED: 'Last Update Received',
            TIME_EVENT_CLEARED: 'Time Event Cleared',
            VIEW_MORE: 'View More',
            VIEW_LESS: 'View Less',
            EVENT_NAME: 'Event Name',
            PLEASE_RETRY: 'Please retry',
            ACKNOWLEDGE_NAME: 'Acknowledge',
            AUTHENTICATION_FAILED: 'Authentication Failed !',
            SORT: 'Sort',
            RESET_SORT: 'Reset Sort Order To Default',
            SELECTED_DATE: 'Selected Date',
            TAGS_MAXIMUM_6: '6 tags maximum',
            DONT_ASK_AGAIN: 'Don’t ask again',
            NO_DEVICES_FOUND: 'No Devices found',
            NAVIGATE_TO_OTHER_TABS: "Navigate to other tab's to find your scanned device",
            NO_CURRENT_ORGANIZATION_USERS: 'No Current Organization Users',
            TO_ADD_SERVICE: 'To add a service contact organization users are required.',
            CATEGORY: 'Category',
            DELETE_CONFIRM_USER:
                'To proceed, type ‘delete’ in the text box below and then select the ‘Delete User’ button.',
            DELETE_CONFIRM_USER_DESC_ONE: 'To proceed, type',
            DELETE_CONFIRM_USER_DESC_TWO: ' ‘delete’ ',
            DELETE_CONFIRM_USER_DESC_THREE: 'in the text box below and then select the ‘Delete User’ button.',
            ALL_USERS: 'All users',
            TIMEZONE: 'Timezone',
            SET: 'Set',
            DATE_RANGE: 'Date Range',
            FILE_DOWNLOADED: 'File Downloaded.',
            DOWNLOAD_SUCCESSFULLY: 'Downloaded Successfully',
            DOWNLOAD_FAILED: 'Download failed',
            ERROR_DURING_DOWNLOAD: 'Error during download',
            NO_DATA_AVAILABLE: 'No Data Available',
            EXPORT_METHODS: 'Export Methods',
            MINIMUM: 'Minimum',
            MAXIMUM: 'Maximum',
            NO_MAP_AVAILABLE: 'No Map Available',
            DOWNLOADING: 'Downloading',
            MIME_TYPE: 'No app associated with this mime type',
            NO_GROUPS_AVAILABLE: 'No Groups Available',
            ORGANIZATION_DETAILS_UPDATED: 'Organization Details Updated',
            ADDRESS: 'Address',
            INCORRECT_FILE_FORMAT: 'Incorrect File Format',
            CONTACT_AND_LOCATION_INFORMATION: 'Contact and Location Information',
            NO_SUBSCRIPTION_AVAILABLE: 'No Subscription Available',
            SWITCH_REALM: 'Switch Realm',
            VIEW_ALL: 'View All',
            FREQUENCY: 'Frequency',
            NAMES: 'Name*',
            SENT: 'sent',
            AUDIT_LOGS_TIME: 'Time',
            AUTOMATION_DETAILS_MINIMUM_0_SECONDS_MAXIMUM_600S: 'Minimum 0 seconds, Maximum 600 seconds',
            EXPORT_MODAL_ADVANCED: 'Advanced..',
            SELECT_EVENTS_MIN_0S_MAX_600S: 'Min 0s, Max 600s',
            MANUFACTURER: 'Manufacturer',
            SEGMENT: 'Segment',
            FEATURE_CHANNELS: 'Feature Channels',
            NO_MODELS_FOUND: 'No Models Found',
            MODIFIED_DATE: 'Modified Date',
            DAYS: 'Days',
            MONTHS: 'Month(s)',
            REPEAT_ON: 'Repeat On',
            REPEAT: 'Repeat',
            OCCURRENCES: 'Occurrence(s)',
            ADD_ACTION: 'Add Action',
            ALARM: 'Alarm',
            AGE: 'Age',
            MANUAL: 'Manual',
            WEEKS: 'Week(s)',
            EXCEPTION: 'Exception',
            VIEW: 'View',
            FIRST_NAME: 'First Name',
            LAST_NAME: 'Last Name',
            HAS_BEEN_APPROVED: 'account has been approved.',
            UPDATED: '‘s role has been changed.',
            PROFILE_UPDATED: '‘s profile has been updated.',
            ALL: 'All',
            PERMISSION_ERROR_MSG: 'Error: Permission for Roles is required',
            NO_UPCOMING_FOUND: 'No Upcoming Found',
            NO_UPCOMING_EVENTS: 'No Upcoming Events',
            NO_UPCOMING_EVENTS_DESCRIPTION:
                'Upcoming events are things that may happen in the future. This includes predictions, scheduled service, and more.',
            CHANNELS_CONFIGURED_SUCCESSFULLY: 'Channels configured successfully.',
            HAS_BEEN_ADDED_TO: 'has been added to',
            MOVE_GROUP: 'Move Group',
            DELETING: 'Deleting',
            NO_OPTIONS: 'No options',
            MOVING_THE: 'Moving the',
            GROUP_MAY_AFFECT:
                'group may affect user access rights, information aggregation, historical data, and reports.',
            VIEW_ALL_EVENTS: 'View All Events',
            VIEW_ALL_PROPERTIES: 'View All Properties',
            SORT_BY_ASCENDING: 'Sort by Ascending',
            SORT_BY_DESCENDING: 'Sort by Descending',
            ITEMS_PER_PAGE: 'Items per page:',
            ONE_YEAR: '1 Year',
            SELECT_SERVICE_CONTACTS: 'Select Service Contacts',
            HAS_BEEN_CREATED: 'has been created',
            HAS_BEEN_SAVED: 'has been saved',
            PREVIEW_NODE: 'Preview Node',
            PREVIEW_DEVICE: 'Preview Device',
            ON_SET: 'On Set',
            ON_CLEAR: 'On Clear',
            SUCCESSFULLY: 'Successfully',
            CHANGES_TO: 'Changes to',
            HAVE_BEEN_SAVED: 'have been saved',
            YOU: 'You',
            NAME_REQUIRED: 'Name',
            SELECTED_GROUPS: 'Selected Groups',
            SELECT_GROUPS_FROM_LIST: 'Select group(s) from the list for users to access',
            GROUP_BY_DEVICE_TYPE: 'Group by Device Type',
            DAY: 'Day',
            WEEK: 'Week',
            CURRENT_TIME: 'CURRENT TIME',
            NOTES: 'Notes',
            ASTERISK_FIRST_NAME: 'First Name*',
            ASTERISK_LAST_NAME: 'Last Name*',
            UNSNOOZE: 'Unsnooze',
            TAGS_UPDATED_SUCCESSFULLY: 'Tags updated successfully',
            MUST_BE_GREATER_THAN: 'Must be greater than',
            MUST_BE_LESS_THAN: 'Must be less than',
            CUSTOM: 'Custom',
            DISPLAY_SCORE_AVERAGES_ON_DEVICES: 'Display score averages on devices',
            MAXIMUM_NUMBER_OF_UPCOMINGS_TO_DISPLAY: 'Maximum number of upcomings to display',
            SELECTED_DEVICES: 'Selected Devices',
            SELECTED_GROUPS_AND_DEVICES: 'Selected Groups and Devices',
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
            INVITED: 'Invited',
            PENDING: 'Pending',
            VIEW_SCHEDULE: 'View Schedule',
            PRIMARY: 'PRIMARY',
            SELECTED_CONTROLS: 'SELECTED CONTROLS',
            SELECTED_LOADS: 'SELECTED LOADS',
            SECONDARY: 'SECONDARY',
            SELECTED_CHANNEL: 'SELECTED CHANNELS',
            SEARCH_GROUP_AND_DEVICES: 'Search Group/Devices',
            SEARCH_CHANNEL: 'Search Channel',
            THIS_WIDGET_WILL_DISPLAY_THE_DEVICES:
                'This widget will display the devices according to the dashboard on which the widget is placed.',
            LINK_TO_SPECIFIC_DEVICES: 'Link to specific device(s)',
            DISPLAY_VIEW_BAR: 'Display “View” bar',
            SELECT_DEVICES: 'Select Device(s)',
            CHOOSE_NAME: 'Choose Name',
            SET_EXCEPTION_DETAILS: 'Set Exception Details',
            OPTIONAL: '(Optional)',
            FROM_THE_LEFT_COLUMN: 'from the left column',
            PUSH: 'Push',
            SCHEDULING_DEVICE: 'DEVICE',
            SCHEDULING_GROUP: 'GROUP',
            SOURCE: 'SOURCE',
            SCEDULING_ACTIVE: 'ACTIVE',
            SCEDULING_INACTIVE: 'INACTIVE',
            HAS_BEEN_REMOVED: 'has been removed.',
            COPY_RIGHT_TEXT: 'Copyright © Company',
            ALL_RIGHTS_RESERVED: 'All Rights Reserved',
            COUNTRY_CODE: 'Country Code',
            PREVENT_UNAUTHORIZED_ACCESS_FOR_YOUR_ACCOUNT:
                'Prevent unauthorized access for your account by adding an additional layer of security. When you sign in, two-factor authentication helps make sure your information remains safe, private and secure.',
            EXPORT_ALARM_RECORDS: 'Export Alarm Records',
            PUBLISH_TEXT: 'This will also published the following widget dependencies',
            SHARE_TEXT: 'This will also shared the following widget dependencies',
            SELECT_DELETE_TO_REMOVE: 'Select ‘Delete’ to remove',
            PART_NUMBER: 'Part Number',
            INSTALLATION_DATE: 'Installation Date',
            NO_COMPONENTS: 'No Components',
            ASSIGNMENTS_REMOVED_SUCCESSFULLY: 'Assignment(s) removed successfully',
            VIRTUAL_LOAD_CREATED_SUCCESSFULLY: 'Virtual Load Created Successfully.',
            VIRTUAL_LOAD_UPDATED_SUCCESSFULLY: 'Virtual Load Updated Successfully.',
            SHARED: 'shared',
            PUBLISHED: 'published',
            LIST: 'List',
            YOUR_ACCOUNT_HAS_BEEN_SUCCESSFULLY_DELETED: 'Your Account has been successfully deleted.',
            YOUR_PERMISSION_IS_REQUIRED_TO_SAVE_FILES_TO_YOUR_DEVICE:
                'Your permission is required to save Files to your device',
            PROPERTY_UPDATED_SUCCESSFULLY: 'Changes Saved Successfully',
            NOT_CONFIGURED: 'Not Configured',
            HAS_BEEN_MOVED: 'has been moved.',
            MOVE_GROUP_NAME_HEADER: 'Move {{dragSource.name}}?',
            MOVE_GROUP_NAME_DESC:
                'Moving the <b>{{dragSource.name}}</b> group may affect user access rights, information aggregation, historical data, and reports.',
            USER: 'User',
            USERS_DELETED_SUCCESSFULLY: 'deleted successfully.',
            USER_USERS: 'User (s)',
            HAS_BEEN_DISABLED: 'has been disabled',
            HAS_BEEN_ENABLED: 'has been enabled',
            DATE_AND_TIME: 'Date & Time',
            USER_FILTERS: 'User Filters',
            FILTER_BY_GROUPS: 'Filter by Groups',
            AUTOMATION_FILTERS: 'Automation Filters',
            LOAD_NUMBER: 'Load Number',
            TIMELINE_FILTERS: 'Timeline Filters',
            DEVICE_FILTERS: 'Device Filters',
            TAG: 'Tag',
            SCHEDULE_FILTERS: 'Schedule Filters',
            SCHEDULE_NAME: 'Schedule Name',
            DISABLE_USERS: 'Disable Users(s)',
            ENABLE_USERS: 'Enable Users(s)',
            DELETE_USERS: 'Delete Users(s)',
            UPDATE: 'Update',
            EXPORT_TREND_XLSX: 'xlsx',
            EXPORT_TREND_PDF: 'pdf',
            EXPORT_TREND_CSV: 'csv',
            EXPORT_TREND_UNKNOWN: 'unknown',
            GET_ALL_VIRTUAL_LOADS: 'getAllVirtualLoads',
            FILE_TYPES: 'fileType',
            CHECKED: 'checked',
            UNCHECKED: 'unchecked',
            VALUE_TO_SET_AT: 'Value to set at',
            UNTIL: 'Until',
            SCHEDULE_DETAILS: 'Schedule Details',
            VIEW_ALL_LOAD_TRENDS: 'View All Load Trends',
            VIEW_FULL_TREND_VIEWER: 'View Full Trendviewer',
            SELECTED_COUNT: 'selected {{count}}',
            HELP_TEXT: 'Help',
            PRIVACY_POLICY: 'Brightlayer Privacy Notice',
            CONFIGURE_HIERARCHY_OF_GROUPS_AND_DEVICES: 'Configure Hierarchy of Groups, Devices',
            PREFERENCES_AND_CUSTOM_NOTIFICATIONS: 'Preferences, Custom Notifications',
            TRACKING_AND_USER_EVENTS: 'Tracking, User Events',
            MONTH: 'month',
            SAVE_AUDIT_LOG: 'Save Audit Log',
            NO_USERS: 'No Users',
            YOU_ARE_CURRENTLY_SETTING_YOUR_NOTIFICATION_PREFERENCES:
                'You’re currently setting your notification preferences for {{orgName}} and the groups you have access to. Your Preferences do not affect other users.',
            CLOSED_TEXT: 'CLOSED',
            CRITICAL: 'Critical',
            PERMANENTLY_DELETE_ACCOUNT:
                'Select ‘Continue’ to permanently delete your account from all organizations and all of it’s associated information and data.',
            YOU_ARE_ADMINISTRATOR_FOR_ONE_OR_MORE_ORG:
                'You are an organization administrator for one or more organizations. You must switch to each organization for which you are an administrator, and then either delete the organization or grant the administrator role to another user and leave the organization. Once you have deleted or left all organizations, or are no longer an administrator for any organization, you can delete your account.',
            DELETE_ACCOUNT: 'Delete Account ?',
            ACCOUNT_AND_DATA_PERMANENTLY_DELETED:
                'Your account and all of it’s associated information and data will be permanently deleted. This cannot be undone. To proceed, type ‘delete’ in the text box below and then select the ‘Delete My Account’ button.',
            SYSTEM_ROLE_NAME: 'SYSTEM ROLE:',
            GROUP_UPDATED_SUCCESSFULLY: 'Group Updated successfully.',
            LEAVE: 'Leave {{orgName}} ?',
            NO_COMPONENT_DATA_AVAILABLE: 'No Component Data Available',
            NOT_SUPPORT_COMPONENT: 'This Device Type does not support Component',
            VIEW_ALL_COMPONENTS: 'View All Components',
            DEVICE_DOES_NOT_HAVE_VIRTUAL_LOAD: 'This Device doesnt have virtual loads.',
            ACCOUNTS: 'Accounts',
            SELECT_DATE_RANGE: 'Select Date Range',
            NAME_EMAIL_PASSWORD_AVATAR: 'Name, Email, Password, Avatar',
            DOCS: 'Docs',
            REPORT_FILTERS: 'Report Filters',
            DOCUMENT_FILTER: 'Document Filter',
            THIS_WIDGET_TYPE_NOT_SUPPORTED: 'This widget type does not support the selected group or device.',
            LOG_DETAIL: 'Log Detail',
            SHARE_LOG: 'Share Log',
            AUTOMATION_SELECT_DEVICE_TYPES: 'Automation Select Device Types',
            SELECT_DETAILS: 'Select Details',
            SELECT_GROUP_TYPE: 'Select Group Type',
            SELECT_PARENT_GROUP: 'Select Parent Group',
            SELECT_USERS_AND_CONTACTS: 'Select Users And Contacts',
            ADVANCED: 'Advanced',
            EDIT_NAME_AND_DESCRIPTION: 'Edit Name and Description',
            ASSIGN_GROUPS: 'Assign Group(s)',
            EDIT_PRIVILEGES: 'Edit Privileges',
            RECIEVED: 'Recieved',
            NOTIFICATIONS_TITLE: 'Notifications',
            AUTOMATION_SUBTITLE: 'Control Automations',
            USER_SUBTITLE: 'Configure Users and Roles',
            AUDIT_LOGS_FILTER_DESCRIPTION: 'description',
            DELETE_ORGANIZATION: 'Delete Organization',
            REALM_DETAILS: 'Realm Details',
            APPLICATION_OR_PDF: 'application/pdf',
            TEXT_OR_CSV: 'text/csv',
            PLEASE_DO_NOT_CLOSE_THIS_WINDOW: 'Please do not close this window',
            NOT_APPLICABLES: 'Not Applicable',
            DOWNLOADED: 'Downloaded',
            ERROR_DOWNLOAD_EXPORT: 'An error occurred while downloading export:',
            ACKNOWLEDGEMENT_NAME: 'Acknowledgement',
            CREATE_ORG_SUBTITLE:
                'Must be minimum four characters in length with no special characters at the beginning.',
            MAP_LOCATION_ERROR:
                'Enable location services on your device to find your location with GPS or enter it manually.',
            ENTER_SETTINGS: 'Enter Settings',
            TIME: {
                SECONDS: 'Seconds',
            },
            SELECTED_EVENTS_WILL_NOTIFY: 'Selected events will notify',
            NOTIFICATION_ALL_USERS: 'all users',
            NOTIFICATION_USERS: ' users',
            NOTIFICATION_USER: ' user',
            VIEW_ALL_GROUPS: 'View All Groups',
            CONFIG_DEVICE_WITH_NFC: 'Configure Devices With NFC',
            SCHEDULE: 'Schedule',
            DOWNLOAD_DONE_SUCCESSFULLY: 'Download done successfully',
            NEW_GROUP: 'New Group',
            USER_GROUP_COUNT: 'Selected ({{count}})',
            LAST_SYNCED: 'Last Synced:',
            ALL_WORKING: 'All Working',
            MESH_DELETED_MSG: ' has been deleted.',
            SCAN: 'Scan',
            RESCAN: 'Re-scan',
            CONTACT_EATON: 'Contact Eaton',
            SUBSCRIPTION_ERROR_TEXT: 'This operation is not allowed due to Error Code: {{errorCode}}',
            SUBSCRIPTION_SYNC_REQUIRED_TITLE: 'Entitlement Sync Required',
            SUBSCRIPTION_SYNC_REQUIRED_TEXT:
                'Your entitlement has been updated. Please sync the updated entitlement with all mesh devices from Mesh Control tab before using this feature.',
            SUBSCRIPTION_FETCH_ERROR: 'Unable to load subscription details.',
            SUBSCRIPTION_NETWORK_ERROR: 'No internet connection. Please check your connection and try again.',
            FEATURE_NOT_SUPPORTED_TITLE: 'Feature Not Available',
            FEATURE_NOT_SUPPORTED_TEXT:
                'This feature is not included in current entitlement plan.  To upgrade plan contact Eaton\nBLsupport@eaton.com',
            COMMISSIONING_NOT_SUPPORTED:
                'Commissioning is not available in the existing plan for the selected {{deviceTypeLabel}} device type.\nTo upgrade plan contact Eaton\nBLsupport@eaton.com',
            CHAMP_SUPPORT_HEADER: 'For Champ fixture related support (8am - 5pm EST)',
            GENERAL_SUPPORT_HEADER: 'For General Brightlayer Support (8am - 5pm EST)',
            ALPHANUMERIC: 'Alphanumeric',
            ASCENDING: 'Ascending',
            DESCENDING: 'Descending',
            DISPLAY_ORGANIZATIONS: 'Display Organizations',
            DISPLAY_ALL: 'Display All',
            DATE_CREATED: 'Date Created',
            LOADS_GROUPS: 'Load Groups',
            BALANCING: 'Balancing',
            TURN_OFF_DESCRIPTION: 'turn off',
            TURN_ON_DESCRIPTION: 'turn on',
            MANAGE_LOAD_GROUPS: 'Manage Load Groups',
            SELECT_LOAD_GROUPS: 'Select Load Groups',
            VIEW_FULL: 'View Full',
            LOADS_HAVE_BEEN_ADDED_SUCCESSFULLY: 'Load(s) have been added successfully.',
            ASSIGN_TO_GROUPS: 'Assign to Groups',
            SELECT_USERS: 'Select Users',
            SELECT_GROUP_DEVICE_INFO:
                'Choose on which device(s) the automated action is to apply. If a group is selected, then the action selected will apply to each device of the specified device type located in that group.',
            PLEASE_PROVIDE_VALID_CHARACTERS: 'Please provide valid characters',
            CREATE_SUCCESS_MSG: '{{name}} created successfully.',
            LOAD_GROUP_TRENDS: 'Load Group Trends',
            NO: 'No',
            YES: 'Yes',
        },
        COMMUNICATIONS: {
            DOWNLOAD_CSV: 'Download as CSV',
            DOWNLOAD: 'Download',
            LOG_INFO: 'Log Info',
            VIEW_DETAILS: 'View details',
            MAIL_STATUS: 'Mail Status',
            FIRMWARE_VERSION: 'Firmware Version',
            HARDWARE_VERSION: 'Hardware Version',
            MAC_ADDRESS: 'MAC Address',
            IP_ADDRESS: 'IP Address',
        },
        ROUTE_TITLES: {
            SAVE_CHANGES_TITLE: 'Save Your Changes?',
            CANCEL_CHANGES_TITLE: 'Cancel Changes?',
            COMMENTS: 'Comments',
            MORE_LABEL: 'More',
            CATEGORY: 'Category',
            NO_SETTINGS_AVAILABLE: 'No settings available',
            ERROR_MSG: 'An error occurred while saving.',
            TRY_AGAIN: 'Try again',
            MOBILE_REGISTRATION: 'Mobile is not register for push notification',
            NEVER_EXPIRES: 'Never Expires',
            EDIT_DEVICE_CONFIG: 'Edit Device Configuration',
            ADD_DEVICE: 'Add Device',
            EDIT_ORGANIZATION: 'Edit Organization',
            USERS_AND_ROLES: 'Users & Roles',
            USER_PROFILE: 'User Profile',
            MY_PROFILE: 'My Profile',
            WIDGET_DASHBOARD: 'Dashboards & Widgets',
            EDIT_WIDGET: 'Configure And Preview',
            EDIT_ROLE: 'Edit Role',
            MANAGE_REALM: 'Realm Management',
            DASHBOARD_MANAGEMENT: 'Dashboard Management',
            EDIT_DASHBOARD: 'EditDashboard',
            GROUP_MANAGEMENT: 'Group Heirarchy',
            USERS_WITH_THIS_ROLE: 'Users with this role',
            EDIT_USER_PROFILE: 'Edit User Profile',
            AUTOMATION: 'Automation',
            APPROVE_USER: 'Approve User',
            GRP_HIERARCHY: 'Group Hierarchy',
            ORG_SETTINGS: 'Organization Settings',
            GROUP_LIST: 'Group List',
            MAX_OF_6_TAGS: 'Max of 6 tags',
            TARIFFS_AND_CURRENCIES: 'Tariffs & Currencies',
            ADD_TARIFF: 'Add Tariff',
            SCHEDULES: 'Schedules',
            AUTOMATION_NAME: 'Automation Name',
        },

        COMPONENTS: {
            DELETE_MODAL_DESCRIPTION:
                'To proceed, type <b>‘delete’</b> in the text box below and then select the ‘{{text}}’ button.',
            DELETE_MODAL_DESCRIPTION_ONE: 'To proceed, type ',
            DELETE_MODAL_DESCRIPTION_TWO: '‘delete’',
            DELETE_MODAL_DESCRIPTION_THREE: ' in the text box below and then select the ‘{{text}}’ button.',
            REMOVE_MODAL_DESCRIPTION:
                'To proceed, type <b>‘remove’</b> in the text box below and then select the ‘{{text}}’ button.',
            TABLE: {
                PAGINATION_LABEL: 'Items per page',
            },
            MORE_INFORMATION_ABOUT_THE_ALARM_TO_ACKNOWLEDGE_IT:
                'Use this field to give context or add more information about the alarm, in order to acknowledge it.',
            SEE_ALL_NOTES_LEFT_BY_EVERY_OPERATOR:
                'Later on it will be possible to see all notes left by every operator on the dedicated alarm page.',
            HEADER_ACTIONS: {
                MENU_ITEM_TEXTS: {
                    USER_SUBTITLE: 'Configure Users and Roles',
                    GROUPS_TITLE: 'Groups',
                    GROUPS_SUBTITLE: 'Configure Hierarchy of Groups, Devices ',
                    ALARMS_TITLE: 'Alarms',
                    ALARMS_SUBTITLE: 'Configure Alarms, Incidents',
                    NOTIFICATIONS_TITLE: 'Notifications',
                    NOTIFICATIONS_SUBTITLE: 'Preferences, Custom Notifications',
                    AUTOMATION_TITLE: 'Automations',
                    AUTOMATION_SUBTITLE: 'Control Automations',
                    SCHEDULE_TITLE: 'Schedules',
                    SCHEDULE_SUBTITLE: 'Control Schedules',
                    DASHBOARD_TITLE: 'Dashboards & Widgets',
                    DASHBOARD_SUBTITLE: 'Create and Edit',
                    PROFILE_TITLE: 'Account',
                    PROFILE_SUBTITLE: 'Name,Email,Password,Avatar',
                    AUDIT_LOGS_SUBTITLE: 'tracking, user events, System Changes',
                    AUDIT_SUBTITLE: 'tracking, user events',
                    CHANNEL_LIBRARY_TITLE: 'Device Channel Library',
                    CHANNEL_LIBRARY_SUBTITLE: 'Manage viewable channels',
                    TARIFFS_AND_CURRENCIES: 'Tariffs and Currencies',
                    TARIFFS_AND_CURRENCIES_SUBTITLE: 'Create & manage tariffs and currencies',
                    CUSTOMER_VALIDATION_TITLE: 'Customer Validation',
                    OFFLINE_PARTIAL_TELEMETRY_TITLE: 'Offline/Partial Telemetry',
                    EMAILS_RECEIVED_FROM_DEVICES_TITLE: 'Emails Received From Devices',
                    ACTIVATION_TITLE: 'Activation',
                    UPCOMING_TITLE: 'Upcoming',
                    DEVICE_MIGRATION_TITLE: 'Device Migration',
                    EXPORT_DATA_TITLE: 'Export and Download Data',
                    EXPORT_DATA_SUBTITLE: 'Export and download your data',
                },
                LOG_OUT_LABEL: 'Log Out',
            },
            HELP_SCREEN_CONTENT:
                '<0>General Questions </0> <1>  For feedback, questions, or support please email us at<0> BLSupport@eaton.com</0>.</1> <0>Emergency Support </0> <1>For immediate support during business hours, <br /> <0>1-877-ETN-CARE</0>, Option 2, Option 9.</1>',
            PRIVACY_POLICY_CONTENT:
                '<0> <0>Privacy notice / your privacy rights</0> <br/> Brightlayer remote monitoring dashboard <br />(BRMD Services)</0><1>  This Notice contains details about how Eaton collects and uses information from you and the entity you represent (collectively, the “Authorized Party”) when the Authorized Party uses the BRMD Services.</1><1>Whenever you download, install or operate the BRMD Services Application or use the BRMD Services in any other way, you represent that you are an agent or representative of an Authorized Party, and that you have the authority to use the Services on behalf of such Authorized Party.</1> <1> This Notice covers only the Services identified above, and does not apply to information which the Authorized Party may send us by other means. Other Eaton sites, applications and other online services or locations may have their own privacy policies, and the Authorized Party should consult those accordingly. </1> <1> Please read this Notice carefully to understand our practices regarding the Authorized Party’s information and how we will treat it. If the Authorized Party does not agree with our policies and practices, do not download, install or operate the BRMD Services and do not interact with any other part of the Services. By using the Services, the Authorized Party agrees to the terms of this Notice. </1> <1> This Notice is effective as of: ……………. </1> <2> Notice Changes </2> <1> Eaton may update this Notice from time to time. Any changes to this Notice will be posted for a period of thirty (30) days and will be effective when posted (see https……. ). The changes will also be immediately incorporated into this Notice. </1> <1> Continued use of the Services by the Authorized Party after any changes are made to this Notice constitutes the Authorized Party’s acceptance of the changes, so please check this Notice periodically for updates. If any of the changes are unacceptable to the Authorized Party, the Authorized Party should cease using the Services </1> <1> If any changes to this Notice materially affect how Eaton treats or handles personal data that the Authorized Party has already provided to Eaton or that has otherwise been collected by us, we will notify the Authorized Party by email (if we have a valid email address to use) and give the Authorized Party thirty (30) days to opt-in to the changes as they pertain to the Authorized Party’s information. If the Authorized Party does not opt-in, its information will continue to be used in a manner that is consistent with the version of this Notice under which it was collected, or the information will be deleted.</1> <2> Personal data (“Personal Data”) is generally defined as information that may be able to identify a natural person, information that could reasonably be linked to such person, or information that may be used to get access to personal accounts. Personal Data could include, but is not limited to, name, address, telephone number, email address, username and password, IP address or other online identifiers, credit/debit card number or other financial information, professional or employment-related information, office address and other business information, etc.</2> <2> There are certain parts of the Services where the Authorized Party may be asked to provide Eaton with Personal Data, or where such Personal Data or other information may be collected from the Authorized Party in an automated manner. For example, Eaton may collect Personal Data (and other related information) such as name, title, residential and/or business address(es), email address(es), personal and/or business telephone number(s), and employer information when the Authorized Party: </2><3> - Process the Authorized Party’s account registration on the Site and/or in connection with the BRMD Service; <br /> - Administer the Authorized Party’s account in connection with the Services; <br /> - Provide the Services, its contents and related information to the Authorized Party; <br /> - Maintain proper business records and other relevant records; <br /> - Provide ongoing technical support related to the Authorized Party’s account; <br /> - Contact the Authorized Party if there are issues with content that was uploaded or posted through the Services; <br /> - Respond to questions and comments; <br /> - Communicate with the Authorized Party regarding additional uses of the Personal Data it provides which go beyond the scope of this list; <br /> - Process and catalog the Authorized Party’s responses to surveys or questionnaires; <br /> - Evaluate and improve the content and general administration of the Services; <br /> - Perform internal operations related to the Services; <br /> - Troubleshoot software issues and operational problems with the Services; <br /> - Conduct data analysis and testing; and/or <br /> - Monitor usage patterns for the Services. </3><2> The Site or BRMD Services may use cookies. Cookies are files that are transmitted to the Authorized Party’s computer when the Authorized Party visits the Site or uses the BRMD Services. Cookies allow Eaton to recognize the Authorized Party’s browser when it subsequently returns to the Site or uses the BRMD Services again. Cookies may also collect the Authorized Party’s user preferences when  visiting the Site or using the BRMD Services. Eaton uses cookies to manage acceptance of Eaton’s Terms of Use/Legal Notice/End-User License Agreement for the Services and this Notice. The Authorized Party may be able to disable the cookies by consulting the relevant browser and/or computer instructions. Please note that disabling cookies could affect how the Site and/or BRMD Services appear and/or operate for the Authorized Party.</2>',
        },
        REALM: {
            CONFIRM_MOVE: 'Confirm Move',
            MOVE_SELECTIONS: 'Move Selections to Realm',
            MOVE_REALM_ORG_TITLE: 'Move Realms and Organizations',
            MOVE_REALM_ORG_HEADER: 'Select Realms and Organizations to Move',
            SELECT_DEST_HEADER: 'Select the Destination Realm',
            MOVE_REALM_ORG_DESC:
                'Moving Realms and Organizations may affect user access rights, settings restrictions, application theme, support, locale defaults. All devices, groups, settings, dashboards, and widgets will be transferred.',
            REALM_ORG_MOVE_SUCCESS: 'Realms and/or Organizations Moved Successfully',
            NO_REALM: 'No Realms',
            MOVE_REALM: 'Move Realm',
            NAVIGATE_MODAL_DESCRIPTION: `Navigating to an Organization will leave Realm Management. Are you sure you want to navigate away?`,
            NAVIGATE_MODAL_HEADER: 'Navigate to {{ name }}?',
            NAVIGATE_MODAL_ACTION_BUTTON_TEXT: 'Go',
            REALM_NAME_HELPER_TEXT: 'e.g. Company or Product Name',
            URL_NAME: 'URL Friendly Name',
            URL_HELPER_TEXT: 'Name that will appear in your realm’s URL',
            ADD_REALM: {
                HEADER: 'Create New Realm',
                SUB_HEADER: 'New Realm',
                PARENT: 'Parent',
                SUCCESS_MESSAGE: 'Realm added successfully',
            },
        },

        CUSTOM_URL: {
            CERTIFICATE_DOWNLOADED: 'Certificate downloaded',
            INSTRUCTIONS_DOWNLOADED: 'Instructions downloaded',
            CERTIFICATE_DOWNLOADING: 'Certificate downloading...',
            TITLE: 'Custom Url',
            ENABLE_CUSTOM_URL: 'Enable custom URL',
            SAVE_MSG: `Changes to Custom URL have been saved`,
            REMOVE_MSG: 'The Custom URL has been removed from the {{name}} realm.',
            DOWNLOAD_SSL_CERTIFICATE: 'Download SSL Certificate',
            REMOVE_URL_TITLE: 'Remove Custom URL?',
            REMOVE_URL: 'Remove Custom URL',
            SSL_CERTIFICATE: 'SSL Certificate',
            VIEW_SSL: 'View SSL Certificate',
            INSTRUCTIONS_TITLE: 'Configuration Instructions',
            CHOOSE_SSL_KEY: 'Choose SSL Key File',
            CHOOSE_SSL_FILE: 'Choose SSL Certificate File',
            UPLOAD_SSL: 'Upload SSL Certificate',
            REMOVE_CUSTOM_URL_DESC:
                'Selecting ‘Remove Custom URL’ to will remove this realm’s custom URL and its SSL Certificate. It will still be accessible through it’s default Eaton URL. Or, select ‘Cancel’ To return to the previous window.',
            INSTRUCTIONS_TEXT: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut porttitor leo a diam. Fusce ut placerat orci nulla pellentesque dignissim enim sit amet. Porttitor eget dolor morbi non. Justo donec enim diam vulputate ut pharetra. Sit amet venenatis urna cursus eget nunc scelerisque viverra. Elementum tempus egestas sed sed risus pretium quam. Fames ac turpis egestas maecenas pharetra convallis. Scelerisque viverra mauris in aliquam sem fringilla ut. Facilisis magna etiam tempor orci eu lobortis elementum nibh tellus.
Eu scelerisque felis imperdiet proin fermentum leo. Morbi quis commodo odio aenean sed adipiscing diam. Nulla facilisi etiam dignissim diam. Gravida quis blandit turpis cursus in hac habitasse. In est ante in nibh mauris cursus mattis molestie. Tempor orci eu lobortis elementum nibh tellus. Aliquet enim tortor at auctor urna nunc id cursus metus. Fames ac turpis egestas integer eget aliquet. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Odio eu feugiat pretium nibh. Tellus cras adipiscing enim eu turpis egestas pretium aenean pharetra. Pretium fusce id velit ut tortor pretium viverra suspendisse potenti. Arcu dictum varius duis at consectetur lorem donec massa. Quis commodo odio aenean sed adipiscing diam donec. Eu feugiat pretium nibh ipsum consequat nisl vel pretium. In hac habitasse platea dictumst vestibulum rhoncus est pellentesque. Non quam lacus suspendisse faucibus interdum posuere lorem ipsum dolor.`,
        },

        REALM_SUMMARY: {
            AVATAR_LOGO: '{{logoState}} Avatar Logo',
            LANDSCAPE_IMAGE: '{{imageState}} Landscape Logo',
            PATTERN_LOGO: '{{imageState}} Pattern',
            DEFAULT_URL: 'Default Url',
            IMAGE_HELPER: 'SVG 2 MB Max.',
            PATTERN: 'Background Pattern',
            LANDSCAPE_LOGO: 'Landscape Logo',
            LANDSCAPE_HELPER_TEXT: 'SVG, PNG, JPG (1000x500px), 2 MB Max.',
            MANAGE_URL: 'Manage Custom URL',
            REALM_DELETED_SUCCESSFULLY: 'Realm Deleted Successfully',
            REALM_SUSPENDED_OR_RESTORED_SUCCESS: 'Realm {{type}} successfully.',
            REALM_UPDATED_SUCCESSFULLY: 'Realm Updated Successfully',
            UPDATE_FORM: {
                REALM_NAME: 'Realm Name',
                REALM_NAME_EXAMPLE: 'e.g.Company or Product Name',
                REALM_URL: 'Url',
            },
            SUSPEND_REALM_LABEL: 'Suspend Realm',
            RESTORE_REALM_LABEL: 'Restore Realm',
            DELETE_REALM_LABEL: 'Delete Realm',
            SUSPEND_CONFIRM_DESCRIPTION:
                'Suspending a Realm will disable access to it and its child Realms and Organizations. It can be restored at any time.',
            RESTORE_CONFIRM_DESCRIPTION:
                'Restoring a Realm will re-enable access to it and its child Realms and Organizations.',
            DELETE_MODAL_DESCRIPTION:
                '{{name}}, all of its organizations, devices, groups, users, and data will be permanently deleted. This cannot be undone.',
        },
        REALM_CUSTOMIZE_FORM: {
            HEADER: 'Application Preferences',
            APPLICATION_NAME: 'Application Name',
            PRIMARY_COLOR: 'Branding Color',
            LOCALE_LABEL: 'Locale',
            TEMPERATURE_UNIT: 'Temperature Unit',
            DECIMAL_SEPARATOR: 'Decimal separator',
            TIMESTAMP_RESOLUTION: 'Timestamp Resolution',
            SUPPORT_AND_LEGAL: 'Support and Legal',
            CONTACT_EMAIL: 'Contact Email',
            CONTACT_PHONE: 'Contact Phone Number',
        },
        REGISTRATION: {
            AREA_CODE: 'Area Code',
            PHONE_NUMBER: 'Phone Number (Optional)',
            WELCOME: 'Welcome {{name}}',
            SUCCESS_MESSAGE_TEXT: 'Your user account has been successfully created with the email <b>{{email}}</b>.',
            SUCCESS_MESSAGE_TEXT_1:
                '\n\nYour account has already been added to the <b>{{organization}}</b> organization.\n\nSelect Log In below to Log In.',
            SUCCESS_MESSAGE_TEXT_2:
                'Your account has been successfully created.\n Please log in with your Okta account email and password',
            FAILURE_MESSAGE:
                'We were unable to complete your registration. Press continue below to continue to Eaton Brightlayer Industrial suite.',
            MULTIFACTOR_AUTH_TEXT: 'Enable Two-factor Authentication',
            LOGIN_BUTTON: 'Log In',
            STEPS: {
                MULTIFACTOR_TITLE: 'Secure Your Account',
            },
            MULTIFACTOR_TITLE: 'Secure Your Account With Two-Factor Authentication',
            MULTIFACTOR_TEXT:
                'Prevent unauthorized access for your account by adding an additional layer of security. When you sign in, two-factor authentication helps make sure your information remians safe, private and secure.',
            MULTIFACTOR_EXTRA_PROTECTION_TITLE: 'Extra Protection',
            MULTIFACTOR_EXTRA_PROTECTION_TEXT:
                'We’ll ask for your password and then a login code when we notice an unusual login request for your account.',
            MULTIFACTOR_SMS_TTITLE: 'VIA SMS Message or Email',
            MULTIFACTOR_SMS_TEXT: 'A code will be sent to you via SMS Message or Email.',
        },
        USER_MANAGEMENT: {
            USER_MANAGEMENT_TITLE: 'User Management',
            ORGANIZATION_DETAILS: 'Organization Details',
            ORGANIZATION_ROLLUPS: 'Organization Rollups',
            EDIT_USER: 'Edit User',
            USERS_DELETE_SUCCESS: '{{count}} user(s) successfully deleted!',
            USERS_INVITATION_SUCCESS: '{{count}} invitation resent successfully',
            DISABLE_ACCOUNT_MSG: '{{username}} {{pronoun}} been disabled.',
            ENABLE_ACCOUNT_MSG: '{{username}} {{pronoun}} been enabled',
            SELF_DELETE_SUCCESS: 'Your Account has been successfully deleted.',
            ADD_OR_EDIT_USER: {
                INVITE_USER: 'Invite and add another User',
                USER_ADDED_SUCCESS_MSG_MULTI: 'Users added successfully',
                USER_REMOVE_SUCCESS_MSG_MULTI: 'Users removed successfully',
                USER_ADDED_SUCCESS_MSG: 'User added successfully',
                USER_INVITED_SUCCESS_MSG: 'added successfully!',
                USER_REMOVE_SUCCESS_MSG: 'User removed successfully',
                ADD_USER: 'Add User(s)',
                EDIT_USER_DETAILS: 'Edit User Details',
                CHANGE_ROLE: {
                    HEADER: 'Change {{userName}}’s role to {{role}}?',
                    DESCRIPTION_ONE:
                        'You have changed {{userName}}’s role to {{currentRole}}. If you did not mean to do this - select cancel.',
                    DESCRIPTION_TWO: 'If this was intended, select Continue to save your changes.',
                },
                REMOVE_ASSIGNMENT: 'Remove this assignment',
                REMOVE_USER_ASSIGNMENT: 'Remove User Assignment',
                INVITE_USER_TITLE: 'Invite User to {{orgName}}',
                INVITE_USER_MSG_1: 'Fields marked with an asterisk(*) are required,',
                INVITE_USER_MSG_2: 'fields when {{task}} a User.',
                SELECT_ROLE_TYPE: 'Select a Role Type',
                SELECT_ROLE: 'Select a Role*',
                REALM_LEVEL: 'Realm Level Role',
                ORG_LEVEL: 'Organization level Role',
                INVITE_AND_ADD: 'Invite and add another User',
                SELECT_ORG: 'Select an Organization*',
                ASSIGN_TO_GROUPS: 'Assign to Group(s)',
                ASSIGN_TO_REALMS: 'Assign to Realm(s)',
                SELECT_ROLE_LABEL: 'Select a Role {{state}} {{selectedOrg}}',
                REMOVE_ASSIGNMENT_LABEL: 'Remove Assignment?',
                REMOVE_ROLE_WARN:
                    '*Users without a checkbox must be assigned a second role before this role can be removed from their profile.',
                REMOVE_ASSIGNMENT_DESCRIPTION: 'The information about this assignment will be removed.',
                BTN: {
                    ADD_ADDITIONAL: 'Add Additional Roles',
                },
                SELECT_GROUP: ' Select a Groups or Devices from the Group list.',
                ASSIGN_GROUP: 'Assign Group(s)*',
                SELECT_USERS: 'Select users to assign to ”My Custom Role',
                SELECT_USERS_ROLE: 'Select users to assign to {{roleName}}',
                SELECT_REMOVE: 'Select ‘Remove’ to unassign {{length}} user(s) from {{roleName}}',
            },
            DISABLE_USER: 'Disable User',
            ENABLE_USER: 'Enable User',
            DELETE_USER: 'Delete User',
            NO_USER_TITLE: 'No Users Found',
            MULTI_ITEMS_MODAL_HEADER_ORG: 'Delete User(s)',
            MULTI_ITEMS_MODAL_DESCRIPTION:
                'Select `Continue` to permanently delete the selected user(s) and all of their profile information. This will not remove log entries or reverse changes they previously made to the system.',
            DELETE_MODAL_DESCRIPTION:
                '{{total}} user(s) and all of their profile information will be permanently removed. This will not remove log entries or reverse changes they previously made to the system.',
            USER_MENU: {
                USER_TITLE: 'Add User',
                DISABLE_TITLE: 'Disable User(s)',
                ENABLE_TITLE: 'Enable User(s)',
                RESEND_TITLE: 'Resend Invitation',
            },
            DELETE_SELF_USER: {
                HEADER: 'Delete Your Account.',
                DESCRIPTION:
                    'You are an organization administrator for one or more organizations. You must switch to each organization for which you are an administrator, and then either delete the organization or grant the administrator role to another user and leave the organization. Once you have deleted or left all organizations, or are no longer an administrator for any organization, you can delete your account.',
            },
            TABS: {
                TITLE_2: 'Roles',
            },
            DISABLED_USERS: 'User Accounts have been disabled',
            ENABLED_USERS: 'User Accounts have been enabled',
            USER_ACCOUNTS: 'User accounts',
            USER_ACCOUNT: 'User account',
            HAVE: 'have',
            HAS: 'has',
            USERS_DELETED_MSG: '{{count}} user(s) have been deleted successfully.',
            USER_DELETED_MSG: '{{username}} has been deleted successfully.',
            USERS_DISABLE_MSG: '{{count}} user(s) Successfully disabled!',
            USER_DISABLE_MSG: '{{username}} Successfully disabled!',
            USERS_ENABLE_MSG: '{{count}} user(s) Successfully enabled!',
            USER_ENABLE_MSG: '{{username}} Successfully enabled!',
        },
        ROLE_MANAGEMENT: {
            NAME_AND_DESC: 'Name & Description',
            USERS_WITH_THIS_ROLE: 'Users with this Role',

            MESSAGES: {
                DELETE_CONFIRM_MESSAGE: '{{name}} and all of it’s associated settings will be permanently deleted.',
                CREATE_ROLE_SUCCESS: '{{roleName}} added successfully',
                UPDATE_ROLE_SUCCESS: 'Changes to {{roleName}} have been saved.',
                DELETE_ROLE_SUCCESS: '{{roleName}} has been deleted.',
            },
            DELETE_ROLE: 'Delete Role',
            ADD_OR_EDIT_ROLE: {
                DELETE_ROLE: 'Delete Role?',
                SAVE_CHANGES: 'Save Changes',
                DELETE_ASSOCIATED:
                    '{{name}} and all of it’s associated settings will be permanently deleted.To proceed, type ‘delete’ in the text box below and then select the ‘Delete Role’ button.',
                PERMANENTLY_DELETE_ROLE: `Select ‘Continue’ to permanently delete {{name}} and all of it’s settings.`,
                CHANGES_SUBTITLE: 'Your changes to this role have not been saved.',
                CANCEL_GO_BACK: 'Cancel and Go Back',
                ERROR_DELETING_ROLE: 'Error Deleting Role?',
                ASSOCIATED_USER_COUNT: `There are {{count}} users associated with this role. In order to delete a role it cannot have any associated users. Go back and remove the associated users and try deleting this role again.`,
                DEFAULT_SYSTEM_ROLES: 'Default system roles are not editable outside of selecting users.',
            },
            USERS_DELETE_SUCCESSFULLY: 'users delete successfully',
            ROLE_ADDED_SUCCESSFULLY: 'Role added successfully',
            PRIVILEGES_SAVED_SUCCESSFULLY: 'Privileges saved successfully',
            USERS_ACCOUNTS_HAVE_BEEN_DISABLED: 'User(s) Accounts have been disabled',
            USERS_ACCOUNTS_HAVE_BEEN_ENABLED: 'User(s) Accounts have been enabled',
            NAME_AND_DESCRIPTION: 'Name & Description',
            REMOVE_USER_ASSIGNMENTS: 'Remove User Assignments?',
        },
        API_MANAGEMENT: {
            CLIENT_ID: 'Client ID',
            CREATE_SERVICE_ACCOUNT: 'Create Service Account',
            DELETE_SERVICE_ACCOUNTS: 'Delete Service Account(s)',
            NO_SERVICE_ACCOUNTS_FOUND: 'No Service Accounts Found',
            SERVICE_ACCOUNT: {
                TITLE: 'Service Account',
                REQUIRED_FIELDS: 'Fields marked with an asterisk(*) are required.',
                EXPIRATION_DATE: 'Expiration Date*',
                SELECT_ROLE_TYPE: 'Select a Role Type*',
                REALM_LEVEL_ROLE: 'Realm Level Role',
                ORGANIZATION_LEVEL_ROLE: 'Organisation Level Role',
                ASSIGN_TO_ORGANIZATION: 'Assign to Organization',
                ASSIGN_TO_REALM: 'Assign to Realm',
                SELECT_ROLE: 'Select a Role*',
                CONNECTION_TITLE: 'Service Account Connection',
                CONNECTION_INSTRUCTIONS:
                    'Save your Client ID and Client Secret in a safe place. This is the only time the Client Secret will be displayed.',
                CLIENT_ID: 'Client ID:',
                CLIENT_SECRET: 'Client Secret:',
                COPY_CREDENTIALS: 'Copy Client ID & Secret to Clipboard',
                CREATE_ACCOUNT: 'Create Account',
                SAVED_MESSAGE: 'Service Account has been saved',
            },
        },
        DEVICE_MANAGEMENT: {
            DEVICE_SNOOZED_SUCCESS_MSG: 'Device Snoozed Successfully',
            DEVICE_UNSNOOZED_SUCCESS_MSG: 'Device Unsnoozed Successfully',
            MULTI_ITEMS_MODAL_HEADER: 'Delete Device(s)?',
            MULTI_ITEMS_MODAL_HEADERS: 'Delete Device(s)',
            MULTI_ITEMS_MODAL_DESCRIPTION: `Selecting ‘continue’ will permanently delete selected Device(s) and all associated information. This will not remove log entries or changes previously made to the system.`,
            DELETE_MODAL_DESCRIPTION: '{{total}} device(s) will be deleted permanently.',
            DELETE_DEVICE_BTN: 'Delete Device(s)',
            DELETE_DEVICES_SUCCESS: '{{deviceIds}} Device(s) Successfully deleted!',
            EDIT_CONFIRMATION_HEADER: 'Save Device Configuration?',
            EDIT_CONFIRMATION_TEXT: `Select ‘Continue’ to overwrite the current device configuration settings. This cannot be undone. Select ‘Close Without Saving’ to exit and discard changes or select ‘Go Back’ to return to the form.`,
            CLOSE_WITHOUT_SAVING_BTN: 'Close Without Saving',
            EDIT_SUCCESS_MSG: `Changes to the Device Configuration have been saved.`,
            DASHBOARD_CHILD_DEVICE_DELETE_WITH_OTHER_DEVICES_DESCRIPTION:
                'The device(s) below are physically connected through a PX Dashboard gateway and must be removed locally at the gateway. To continue deleting other selected devices select continue or select cancel to return to the preivous screen.',
            DASHBOARD_CHILD_DEVICE_DELETE_DESCRIPTION:
                'The device(s) below are physically connected through a PX Dashboard gateway and must be removed locally at the gateway.',
            DASHBOARD_MAIN_DESC:
                'Selecting ‘continue’ will permanently delete selected Device(s) and all associated information. This will not remove log entries or changes previously made to the system. You are attempting to delete one or more gateway devices. This will also remove all devices attached to the selected gateway(s) from the system.',
            DASHBOARD_BOLD_DESC: ' For full removal the PXDB Gateway must also be removed locally.',
            GATEWAY_CHILD_DELETE_RESTRICTION_HEADER: 'Device(s) Cannot Be Deleted',
            GATEWAY_CHILD_DELETE_RESTRICTION_DESC:
                'The listed device(s) you are trying to delete are child devices of parent device(s) and can only be deleted through the deletion of their parent device(s).',
            NO_DEVICE_FOUND: 'No Devices Found',
            DEVICE_DELETE_SUCCESS_MSG: 'Device(s) have been deleted.',
            MULTI_ITEMS_MODAL_DESC_MOBILE:
                '{{count}} device(s) will be deleted permanently. To proceed deleting, type “delete” in the text box below and then select the "Delete" button.',
            EDIT_FAILED_MSG: `Failed to change the Device Configuration`,
        },
        ADD_DEVICE_FORM: {
            HEADER: 'Add Device to {{orgName}}',
            ADD_DEVICE_DESCRIPTION: 'Add Device Description',
            INFORM_MANDATORY_FIELDS: 'Fields marked with an asterisk (*) are required when adding a Device.',
            // PRODUCT_ID_TAKEN_ERROR_MSG: 'A device with this Product ID has already been added to the system',
            // SERIAL_NUM_TAKEN_ERROR_MSG: 'A device with this serial number has already been added to the system.',
            GUID_TAKEN_ERROR_MSG: 'A device with this GUID number has already been added to the system.',
            SAVE_DEVICE: 'Save Device',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            SAVE_AND_ADD_NEW_DEVICE: 'Save & Add New Device',
            INVALID_DEVICE_NAME:
                'Please enter a valid device name. Device names support alphanumeric characters, -, and _.',
            INVALID_GUID: 'Please enter a valid GUID.',
            GUID_IS_REQUIRED: 'GUID is required.',
            INVALID_PRODUCT_ID: 'Please enter a valid Product ID.',
            INVALID_SERIAL_NUM: 'Please enter a valid Serial Number.',
            DEVICE_SAVED_SUCCESSFULLY: '{{deviceName}} has been saved.',
            OK_BTN: 'OK',
            SUCCESS_MODAL_TITLE: 'Submission Successful!',
            SUCCESS_MODAL_BODY_1:
                'Your Connected Device is being remotely configured. Please allow 10 to 90 minutes for this configuration to be downloaded to your Gateway.',
            SUCCESS_MODAL_BODY_2:
                'Connection String. Use the button below to copy this connection string for use with your device. Please save and keep this string in a secure location, it will not be displayed again.',
            SUCCESS_MODAL_BODY_3:
                'Encrypted Gateway Connection String. Use the button below to copy this Encrypted Gateway Connection String for use with your device. Please save and keep this string and its associated GUID in a secure location, it will not be displayed again.',
            NETWORK_SETTINGS: 'Network Settings',
            CONFIGURATION_APPLY_SUCCESSFULLY: 'Device successfully updated with new configuration.',
            ADD_DEVICE_SUCCESS_MSG: 'Device added successfully',
            SUBSCRIPTION_TITLE: 'Select a Subscription Plan',
            SUBSCRIPTION_TITLE_MSG: 'Select the subscription plan to associate this device to.',
            DEVICE_LIMIT_TITLE: 'Subscription Device Limit Reached',
            DEVICE_LIMIT_MSG:
                'Your device subscription limit for {{modelName}} devices has been reached. Please add a new subscription for additional devices to continue adding this device.',
            START: 'Start:',
            END: 'End:',
            ADD_DEVICE_MANUALLY: 'Add Device Manually',
            NFC_PAIRING: 'Add or Edit Network Profile/Settings',
            QR_CODE: 'Scan QR code to retrieve GUID',
            ERROR_MODAL_TITLE: 'Error Saving',
            ENCRYPTED_GATEWAY_CONNECTION_STRING: 'Encrypted Gateway Connection String',
            ADD_DEVICE_WITH_QR: 'Add Device With QR Code',
            ADD_DEVICE_WITH_NFC: 'Add Device With NFC',
            PREDICT_PULSE_WIZARD_INSTRUCTIONS_1: 'Download and run the PredictPulse Activation Wizard.',
            PREDICT_PULSE_WIZARD_INSTRUCTIONS_2: 'Check your email {{email}} for an organization code.',
            PREDICT_PULSE_WIZARD_INSTRUCTIONS_3: 'The Activation Wizard will walk you through the rest of the steps.',
            DOWNLOAD_PREDICT_PULSE_WIZARD: 'Download PredictPulse Activation Wizard',
            EMAIL_PLACEHOLDER: 'your email address',
        },
        EDIT_DEVICE_FORM: {
            DEVICE_TYPE: 'Device Type*',
            DEVICE_MODEL: 'Device Model*',
            CONNECTED_GATEWAY: 'Connected Gateway*',
            DEVICE_NAME: 'Device Name*',
            INFORM_MANDATORY_FIELDS: 'Fields marked with an asterisk (*) are required when adding a Device.',
            EDIT_DEVICE_CONFIGURATION: 'Edit Device Configuration',
            WEB_HEADER: '{{name}} Configuration',
            CONFIRM_MSG:
                'Select ‘Continue’  to overwrite the current device configuration settings. This cannot be undone. Select ‘Close Without Saving’ to exit and discard changes or select ‘Go Back’ to return to the form.',
        },
        DEVICE_FORM_COMMON: {
            DEVICE_TYPE: 'Device Type',
            DEVICE_MODEL: 'Device Model',
            DEVICE_NAME: 'Device Name',
            TAGS_LIMIT_TEXT: '{{count}} tags maximum',
            ADD_NEW_DEVICE: 'Add New Device',
        },
        ADD_DEVICE_OPTION: {
            ERROR_TITLE: 'Error Retrieving Details',
            ERROR_QRCODE_MSG: 'Unable to read QR code data',
            ERROR_REQUEST_MSG: 'Unable to process request',
            ENTER_MANUALLY_BTN_LBL: 'Enter Manually',
            CAMERA_USER_MSG: 'Align reticles with QR Code on back of device',
        },
        DEVICE: {
            DELETE_DEVICE_QUESTION_CONFIRM: 'Delete Device?',
            DELETE_DEVICE_CONFIRM_MESSAGE:
                'Entrance devices and its data will be deleted forever. To proceed deleting these devices and it’s associated data,  type "<b>delete</b>" in the text box below and select the \'Delete\' button.',
            DELETE_MESH_WITH_ZONE_ERROR:
                'Mesh cannot be deleted if it has zones under it. To delete the mesh, you need to delete all zones under this mesh first.',
            DELETE_DEVICE_QUESTION: 'Delete BLE Mesh?',
            DELETE_DEVICE: 'Delete Device',
            DELETE_WARNING: 'Deletion Warning!',
            DELETE_WARNING_SUBTITLE:
                'Selecting ‘continue’ will permanently delete the devices and remove it from the Bluetooth Mesh network. Please note that all historical data associated with these devices will be lost upon removal.',

            NFC_PAIRING_LABEL: 'Configure Device(s) with NFC',
            ADD_MANUALLY_LABEL: 'Add Device Manually',
            ASSIGN_TO_GATEWAY_LABEL: 'Assign to Gateway',
            ADD_NFC_CONFIG: {
                BTN_EXPAND: 'Expand All',
                IPV4_SECTION: 'IPv4 Settings',
                IPV6_SECTION: 'IPv6 Settings',
                DNS_SETTINGS: 'DNS Settings',
                IPV4_TYPE_DHCP: 'DHCP (Automatic)',
                IPV6_TYPE_SLACC: 'SLACC (Automatic)',
                IP_STATIC: 'Static',
                IPV4_METHOD: 'IPv4 Method*',
                IPV4_ADDRESS: 'IPv4 Address*',
                IPV4_SUBNET: 'IPv4 Subnet*',
                IPV4_GATEWAY: 'IPv4 Gateway*',
                IPV6_METHOD: 'IPv6 Method*',
                IPV6_ADDRESS: 'IPv6 Address*',
                IPV6_PREFIX: 'IPv6 Prefix*',
                IPV6_GATEWAY: 'IPv6 Gateway*',
                PROXY_IP: 'Proxy IP*',
                PROXY_PORT: 'Proxy Port*',
                PROXY_AUTH: 'Proxy Settings',
                PROXY_USER: 'Proxy User',
                PROXY_PASS: 'Proxy Password',
                PROXY_CPASS: 'Confirm Proxy Password*',
                PRIMARY_DNS: 'Primary DNS*',
                SEC_DNS: 'Secondary DNS*',
                HOST_NAME: 'Hostname*',
                DOMAIN_NAME: 'Domain Name*',
                CONFIGURATION_SAVED_SUCCESSFULLY: 'Configuration Profile Saved Successfully',
            },
            NFC: {
                TITLE: 'Configure and Add a Device',
                EMPTY_TITLE: 'Configure with NFC',
                SUB_TITLE: 'Select a Configuration Profile',
                NO_CONFIG_FOUND: 'No Configuration Profiles found',
                NO_CONFIG_MSG:
                    'Configuration Profiles let you configure and claim devices into this organisation. Create a new profile to add devices.',
                BTN_ADD_NEW_PROFILE: 'Add Device Using Current Configuration',
                BTN_ADD_EXISTING_PRFILE: 'Use Current Device Configuration',
                BTN_ADD_NEW_PRFILE_LIST: 'Add New Configuration Profile',
                BTN_ENTER_GUID_MANUALLY: 'Enter GUID Manually',
                ERROR_SAVE_TITLE: 'Error Saving Configuration',
                ERROR_SAVE_SUBTITLE: 'Unable to save configuration details to device.',
                ERROR_RETRIVE_SUBTITLE: 'Error connecting to NFC',
                SCAN_TITLE: 'Ready to Scan',
                SCAN_LABEL: 'Hold your phone near the item to learn more about it.',
                SCAN_SUCCESS: 'Device successfully updated with new configuration',
                BANNER_MSG: 'Device Configured Successfully. Select a profile to configure another device.',
                NFC_DISABLE_MSG: 'Please enable NFC from settings.',
                ERROR_MSG: 'Something went wrong. Please try again.',
                INFORM_MANDATORY_FIELDS: 'Fields marked with an asterisk(*) are required fields to add a Device.',
            },
            DELETE_NFC_MODAL: {
                MODAL_BODY: 'Select ‘Continue’ to permanently delete {{name}}.This cannot be undone.',
                MODAL_CONFIRM_MSG: '{{name}} settings will be permanently deleted.This cannot be undone.',
                DEL_CONFIGURATION: 'Delete Configuration Profile',
                CONFIGURATION_DELETE_SUCCESSFULLY: 'Configuration Profile Deleted Successfully',
            },
            NFC_GUID_MANUAL: {
                TITLE: 'Enter GUID',
                GUID: 'GUID',
                PLACEHOLDER_TEXT: '********-****-****-****-************',
            },
            NFC_SCAN: {
                TITLE: 'Scan QR code',
                SUBTITLE: 'Retrieve GUID',
            },
        },
        LOGIN: {
            CREATE_ACCOUNT: 'Sign Up!',
        },
        TAGS_MANAGEMENT: {
            NO_TAGS: 'No Tags Found',
            HAS_BEEN_SUCCESSFULLY_EDITED: '{{tagName}} has been successfully edited.',

            MESSAGES: {
                DELETE_TAGS_MSG_MULTI: '{{count}} Device tags has been successfully deleted.',
                EDIT_SUCCESS_MSG: '{{tagName}} has been changed.',
                CREATE_SUCCESS_MSG: '{{tagName}} has been successfully created.',
                DELETE_TAGS_MSG: '{{count}} Device tag has been successfully deleted.',
            },
            DELETE_MODAL: {
                BTN_LABEL: 'Delete Tag(s)',
                MULTI_ITEMS_TAG_HEADER: 'Delete Tag(s) ?',
                MULTI_ITEMS_MODAL_HEADER: 'Delete Tag(s) ?',
                MULTI_ITEMS_MODAL_DESCRIPTION:
                    'Select ‘Delete Tag(s)’ to permanently delete the selected tag(s). This tag(s) will be removed from all devices associated with it.',
                DELETE_MODAL_DESCRIPTION:
                    '{{total}} tag(s) and all of their profile information will be permanently deleted. This will not remove log entries or reverse changes they previously made to the system',
            },
            LABEL: {
                TAG_NAME: 'Tag Name',
                TAG_NAME_WITH_ASTERISK: 'Tag Name*',
                ADD_TAG: 'Add Tag',
                ADD_TAGS: 'Add Tags',
                DELETE_TAG: 'Delete Tag(s)',
            },
            EDIT_TAGS: {
                EDIT_TAG: 'Edit Tag',
            },
            CREATE_TAGS: {
                CREATE_TAG_MSG: 'Fields marked with an asterisk(*) are required when adding a Tag.',
                CREATE_TAG: 'Create Tag',
                EXISTING_DEVICES: 'Select and link to existing devices',
                SELECTED_DEVICES: 'Selected Devices ({{count}})',
            },
            NO_DEVICES: {
                NO_DEVICES_LABEL: 'No Devices yet',
                NO_DEVICE_MSG: 'Select From the groups List',
            },
        },
        ORG_REGISTRATION: {
            NO_ORG_ADMINS: 'No Organization Admin(s)',
            NO_USER_EXIST_TXT: "If no other users exist, you'll need to add users to the organization first.",
            MOVE_ORG: 'Move Organization',
            ORG_CONTACT: 'Organization Contact Details',
            CONTACT_INFO: 'Contact Information',
            CREATE_ORG: {
                ACTIVATION_ORG: 'Activation Code',
                NEW_ORG: 'Create New Organization',
            },
            JOIN_ORG: {
                DESC: 'Your request will be withdrawn from joining organization.',
                NOTE_MSG:
                    'Enter the Organization Code below. Contact your administrator if you do not know your Organization Code.',
                ORG_CODE: 'Organization Code',
                JOIN_ORG: 'Join Organization',
            },
            NO_ORG: {
                TITLE: 'No Organizations',
                NOTE_MSG:
                    'You do not currently belong to an Organization. You’ll need to Join or Create an Organization to use the application.',
                CREATE_ORG_BTN: 'Create a New Organization',
                JOIN_ORG_BTN: 'Join an Existing Organization',
                PENDING_TXT: "You're currently waiting for approval to join an Organization. ",
                PENDING_MSG: 'You’re currently waiting for approval to join {{orgs}}.',
                WITHDRAW_REQ_BTN: 'Withdraw Request',
            },
            ORG_CREATED: {
                TITLE: 'Organization Created!',
                SUCCESS_MSG:
                    'You have successfully created the {{name}} organization! Tap Finish to continue to the application.',
                WELCOME: 'Welcome {{firstName}}!',
            },
            CREATE_ORG_ERRORS: {
                UNABLE_TO_CREATE_ORG: 'Unable to create organization.',
                ORG_ID_MISSING: 'Organization was created, but its ID was not returned for the user invitation.',
                USER_INVITE_FAILED: 'Organization was created, but the user invitation failed.',
                ADMIN_ROLE_MISSING: 'Organization was created, but the Organization Admin role was not available.',
            },
            ORG_JOINED: {
                TITLE: 'Organization Joined',
                SUCCESS_MSG:
                    'You have successfully joined the {{name}} organization! Tap Finish to continue to the application.',
            },
            WAITING_APPROVAL: {
                NOTE_ONE:
                    'You’ll need to be approved by an administrator before you can join this Organization. You’ll receive an email notification when you’ve been approved.',
                NOTE_TWO:
                    'In the meantime you can continue setting up your account, get to know the application, or join another Organization.',
            },
            PENDING_APPROVAL: {
                NOTE_ONE:
                    'You’ve already requested to join this organization and are awaiting administrator  approval. You’ll receive an email notification when you’ve been approved.',
                NOTE_TWO:
                    'In the meantime, you can continue setting up your account, get to know the application, or join another Organization.',
                NOTE_APPROVED:
                    'You are already a member of the {{name}} organization. Tap Finish to continue to the application.',
            },
            ALREADY_JOINED: {
                NOTE_ONE: `You're already a part of this organization.`,
                NOTE_TWO: `In the meantime, you can continue setting up your account, get to know the application, or join another Organization.`,
            },
            WITHDRAW_ORG: {
                TITLE: 'Withdraw Your Request',
                NOTE: 'Withdraw your request to join {{name}}?',
                NOTE_2: 'Withdraw your request to join from...',
                BTN_WITHDRAW: 'Withdraw Request To Join',
                BTN_WITHDRAW_ONLY: 'Withdraw',
                SUCCESS_MSG: 'Your request to join {{name}} has been withdrawn.',
                SUCESS_MSG_ORGS: 'Your request to {{number}} {{org}} have been withdrawn.',
                ORG: 'organization',
                ORGS: 'organizations',
                OK_MSG: 'OK',
            },
            ORG_DETAILS: {
                ORG_CONTACT: 'Organization Contact Detail',
                REMOVE_LOGO_BTN: 'Remove Logo',
                REPLACE_LOGO_BTN: 'Replace Organization Logo',
                ORG_CODE_MSG: 'This code cannot be changed',
                AUTH_MSG: 'Require Two-factor Authentication (2FA)',
                BTN_CREATE: 'Create an Organization',
                BTN_LEAVE: 'Leave this Organization',
                BTN_DELETE: 'Permanently Delete this Organization',
                BTN_JOIN: 'Join Organization',
                BTN_SAVE: 'Save Changes',
                CANCEL_REQ: 'Cancel Request ?',
            },
            ADMIN_LEAVE_MODAL: {
                SUB_TITLE:
                    'As the only organization admin, you’ll need to grant that role to another user before you can leave',
            },
            ASSIGN_ROLE: {
                ASSIGN_TO_USERS: 'Assign Role to Users',
                MSG_BODY_ONE:
                    'As the only organization admin, you’ll need to grant that role to another user before you can leave ',
                MSG_BODY_TWO:
                    '. If no other users exist, you’ll need to add users to the organization first through the ',
                WEB_URL_TEXT: 'desktop application (URL).',
                MSG_BOTTOM: 'The Organization can also be deleted if you cannot add other users.',
                ASSIGNMENT_REMOVE_TEXT: 'Assignment Removed Successfully.',
                USERS_WITH_THIS_ROLE: 'Users with this role',
            },
            CONFIRM_LEAVE: {
                ASSIGN_ORG_ADMIN: 'Assign Organization Admin',
                CONFIRM_ASSIGN: 'Organization Admin Assigned',
                BTN_UNDO: 'Undo Assign Role',
                BTN_CANCEL: 'Back to Organization Settings',
                ADMIN_DESCRIPTION: `{{adminUserName}} is now an Organization Admin. You are now able to leave {{orgName}}.`,
            },
            SWITCH_ORG: {
                BTN_CANCEL_REQ: 'Cancel Request',
                MODAL_TITLE: 'Cancel Request?',
                MODAL_DESC: 'Your request will be withdrawn from joining organization',
            },
            UPDATE_ORG: {
                UPDATE_ORG_NAME: 'Update Organization Name',
                HEADER: 'Edit the organization name and then select ‘Save’ or select ‘Cancel’ to return to the previous screen.',
            },
            IF_NO_OTHER_USERS_EXIST: 'If no other users exist, you’ll need to add users to the organization first.',
            EDIT_ORG_NAME_DESC:
                'Edit the organization name and then select ‘Save’ or select ‘Cancel’ to return to the previous screen.',
            CREATE_AN_ORG: 'Create an Organization',
        },
        MANAGEMENT: {
            SERVICE_CONTACTS: {
                HEADER: 'Service Contact Required.',
                DESCRIPTION:
                    'At least one service contact is required. Please select another user before removing this contact.',
            },
            MANAGE_ORG: 'ManageOrg',
            DELETE_ORG_MODAL: {
                ORG_DELETE_MSG: 'Organization deleted successfully.',
                MODAL_BODY:
                    'Select ‘Continue’ to permanently delete {{name}} and all of its associated location, device, alarm, event, report, and user data. This cannot be undone.',
                MODAL_BODY_PART_ONE: 'To proceed, type',
                MODAL_BODY_PART_DELETE: '‘delete’',
                MODAL_BODY_PART_TWO: 'in the text box below and then select the ‘Delete Organization’ button.',
                MODAL_FOOTER_DELETE_BTN: 'Delete Organization',
                MODAL_DESC:
                    '{{orgName}} and all of its associated location, device, alarm, event, report, and user data will be permanently deleted. This cannot be undone.',
                MODAL_CONFIRM_MSG:
                    '{{name}} and all of its associated location, device, alarm, event, report, and user data will be permanently deleted. This cannot be undone.',
                MODAL_TEXT_LABEL: 'Type “delete” to confirm',
            },
            USER_PROFILE: {
                ASSIGNMENT_SUCCESS_MSG: '{{username}} profile has been updated.',
                DELETE_MODAL_HEADER: 'Delete Your Account?',
                DELETE_MODAL_DESCRIPTION:
                    'Your account and all of it’s associated information and data will be permanently deleted. This cannot be undone.',
                DELETE_CONFIRM_MODAL_DESC:
                    'Select ‘Continue’ to permanently delete your account and all of its associated information and data.',
                DELETE_MY_ACCOUNT: 'Delete My Account',
                USER_PROFILE_DELETE_DESC:
                    'Select ‘Continue’ to permanently delete {{firstName}} {{lastName}} and all of their profile information. This will not remove log entries or reverse changes they previously made to the system.',
                USER_DELETE_TEXT_SUCCESS: '{{username}} has been successfully deleted.',
                DELETE_TITLE: 'Delete {{firstName}} {{lastName}}',
                EDIT_USER_PROFILE: 'Edit User Profile',
                INVITE_USER: 'Invite User',
                DELETE_USER_PROFILE: 'Delete {{firstName}} {{lastName}}?',
                APPROVE_USER: 'Approve User',
                UPLOAD_BTN: 'Upload Image',
                REPLACE_IMAGE_BTN: 'Replace Image',
                CALENDAR_WEEK: 'Calendar Week',
                TIME_ZONE: 'Time Zone',
                REMOVE_IMAGE_BTN: 'Remove Image',
                DISABLE_USER: 'Disable {{userName}}?',
                UPLOAD_INAGE_BTN: 'Upload an Image',
                PHONE_NUMBER: 'Phone Number',
                EMAIL: 'Email',
                PHONE: 'Phone',
                MFA_TITLE: 'Two-factor Authentication',
                MFA_SUBTITLE: 'Required by the organization',
                IDLE_LOGOUT_TITLE: 'Automatic Log Out',
                IDLE_LOGOUT_SUBTITLE_DISABLED: 'Disabled',
                ROLE: 'Role',
                CALENDAR_WEEK_SUBTITLE: 'Calendar week view begins on',
                TEMPERATURE_FORMAT: 'Temperature Format',
                TEMPERATURE_FORMAT_SUBTITLE: 'Temperature is viewed in',
                DECIMAL_SEP_FORMAT: 'Decimal Separator Format',
                DECIMAL_SEP_FORMAT_SUBTITLE: 'Decimal separators are viewed as',
                ORG_OR_REALM: 'Organization or Realm',
                TYPE_OR_GROUPS: 'Type or Groups',
                REMOVE_ASSIGNMENTS: 'Remove Assignment(s)',
                ASSIGN_TO_ROLES: 'Assign To Role(s)',
                NO_ROLES: 'No Roles Found',
                SELECTED_PREFERENCE_UPDATE_SUCCESS: 'Your selected preference has been updated',
                DELETE_DESC:
                    '{{firstName}} {{lastName}} and all of their profile information will be permanently deleted.',
                REMOVE_ASSIGNMENT_DESC: `Select 'Continue' to permanently remove the selected role(s) from {{firstName}} {{lastName}}`,
                DISABLE_USER_PROFILE: `Select 'Continue' to disable {{name}} and all of their profile information. This will not disable log entries or reverse changes they previously made to the system.`,
                PERMANENT_DELETE: `Select 'Continue' to permanently delete {{name}} and all of their profile information. This will not remove log entries or reverse changes they previously made to the system.`,
                DELETE_CONFIRM_MODAL_SUB: '{{name}} and all of their profile information will be permanently deleted. ',
                DOWNLOAD_PROFILE_INFO: `Download user information`,
                MFA_TITLE_POPUP: 'Disable Two Factor Authentication?',
                MFC_MSG:
                    'Two factor authentication adds extra layer of protection to your account. Are you sure you want to disable it?',
                MFA_ACTION_TITLE: 'Disable Two Factor Authentication',
                MFA_ACTION_TITLE_MB: 'Disable 2FA',
                DOWNLOAD_PROFILE_DATA: `Download User Data`,
                DISABLE_USERS_PROFILE: `Select ‘Continue’ to disable the selected user(s) and all of their profile information. This will not disable log entries or reverse changes they previously made to the system.`,
            },
            EDIT_USERNAME: {
                NOTE: 'Fields marked with an asterisk(*) are required fields when editing a User.',
                UPDATE_BTN: 'Update Username',
                UPDATE_NAME_TITLE: 'Update Name',
                FIRST_NAME: 'First Name',
                LAST_NAME: 'Last Name',
                UPDATE_SUCCESS_MSG: 'Username has been updated.',
            },
            EDIT_PHONE_NUMBER: {
                FAILED_ATTEMPTS: 'You have made too many failed attempts.',
                REQUEST_NEW_CODE: 'Please request for a new code to be sent to {{phoneNumber}}',
                REQUEST_NEW: 'Request for a New Code',
                HEADER: 'Update Phone Number',
                HEADER_OTP: 'Verify Phone Number',
                TITLE: 'Phone No',
                BTN_BACK: 'Back',
                BTN_SUBMIT: 'Submit',
                BTN_NEXT: 'Next',
                ERROR_TITLE: 'Error',
                SUCCESS_MSG: 'Your phone number has been successfully updated with the phone number ',
                NOTE: 'To update your phone number, enter a new phone number in the fields below. You will need to verify your new phone number before the changes can be saved to your account.',
                HELP_TEXT: 'A mobile number is required in order to receive sms notifications.',
                OTP_NOTE:
                    'A verification code has been sent to the phone number you provided. Enter the code below to continue. This code is valid for 15 minutes.',
                OTP_HELP_TEXT: 'Didn’t receive a code?',
                UPDATE_SUCCESS: 'Phone Number Updated',
                CONFIRMATION_TXT: 'A confirmation email has been sent to your email address {{email}}.',
                OTP_BTN: 'Send Again',
            },
            EDIT_COUNTRY: {
                HEADER: 'Update My Country Preferences',
                MOBILE_HEADER: 'Update My Country',
                SELECT_PREFRENCES: 'Please select your location country preferences',
                SUCCESS_MSG: 'Your country preference has been updated.',
                NOTE: 'Please select your country preferences',
            },
            TABS: {
                GENERAL_SETTINGS: 'General Settings',
                DEVICE_TAGS: 'Device Tags',
            },
            ASSIGN_ANOTHER_USER_DESC:
                'You are an organization administrator for one or more organizations. You must switch to each organization for which you are an administrator, and then either delete the organization or grant the administrator role to another user and leave the organization. Once you have deleted or left all organizations, or are no longer an administrator for any organization, you can delete your account.',
            ASSOCIATED_DATA_DELETED_DESC:
                'Your account and all of it’s associated information and data will be permanently deleted. This cannot be undone. To proceed, type ‘delete’ in the text box below and then select the ‘Delete My Account’ button.',
        },
        HELP: {
            GENERAL_QUESTION: 'General questions',
            EMERGENCY_SUPPORT: 'Emergency Support',
            MSG_BODY_ONE: 'For feedback questions, or support please email us at ',
            MSG_BODY_TWO: 'For immediate support during business hours ',
            MSG_BODY_THREE: ',Option 2, Option 9.',
        },
        TIMELINE: {
            NO_TIMELINE: 'No Timeline Found',
            HEADING: 'Timeline',
            ALARM_ACKNOWLEDGED_SUCCESSFULLY: 'Alarm Acknowledged Successfully',
            VIEW_ALL_EVENT_DETAILS: 'View All Event Details',
            AT_TIME_OF_EVENT: 'At Time of Event:',
            AT_LAST_UPDATE: 'At Last Update:',
            LAST_UPDATE_DETAILS: 'Last Update Details',
        },
        NOTIFICATION_PREFERENCES: {
            LABEL: {
                EMAIL: 'EMAIL',
                SMS: 'SMS',
                PUSH: 'PUSH',
                DAILY_DIGEST: 'Include in Daily Digest',
                WEEKLY_DIGEST: 'Include in Weekly Digest',
                TROUBLESHOOTING: 'Troubleshooting',
                NEW_CUSTOM_NOTIFICATION: 'New Custom Notification',
                RESET_NOTIFICATION_PREFERENCES: 'Reset Notification Preferences?',
                SELECT_GROUPS: 'Select Groups',
                SELECT_GROUPS_DEVICES: 'Select Group(s) or Device(s)',
                SELECT_LOAD_GROUPS: 'Select Load Group(s)',
                SELECT_EVENTS: 'Select Events',
                SELECT_USERS: 'Select Users and Contacts',
                SELECT_NOTIFICATION_TYPES: 'Select Notification Types',
                SELECT_DEVICES: 'Select Devices',
                EDIT_CUSTOM_NOTIFICATION: 'Edit Custom Notifcation',
                UPDATE_NOTIFICATION: 'Update Notification',
                CUSTOM_BTN: 'Add Notification',
                NOTIFICATION_SUBHEADING: 'Notification',
                DELETE_NOTIFICATION: 'Delete Notification?',
                DELETE_NOTIFICATIONS: 'Delete Notifications?',
            },

            BTN: {
                RESET_NOTIFICATION_SETTINGS: 'Reset Notification Settings',
                RESET_NOTIFICATIONS: 'Reset Notifications',
                SEND_TEST_EMAIL: 'Send a Test Email',
                SEND_TEST_SMS: 'Send a Test Text Message',
                SEND_PUSH_NOTIFICATION: 'Send a Test Push Notification',
            },
            MESSAGES: {
                SUCCESS_MSG: 'Notification preferences changed successfully.',
                UPDATE_MSG: 'Notification updated successfully.',
                CREATE_MSG: 'Notification created successfully',
                ERROR_MSG: 'Failed to save {{type}} setting',
                PREFERENCES_MSG_FIRST: `You're currently setting your notification preferences for {{name}} and the groups you have access to.`,
                PREFERENCES_MSG_SECOND: `Your Preferences do not affect other users.`,
                PREFERENCES_MSG_THIRD: `Active custom notifications will override the preferences configured below.`,
                SWITCH_ORG_MESSAGE:
                    'You are currently setting your notification preferences for Acme Holdings and the groups you have access to. Your Preferences do not affect other users.',
                DELETE_MSG: '{{selectedIds}} custom notifications deleted successfully',
                DELETE_MODAL_NOTE: 'This notification will be permanently deleted.This cannot be undone',
            },
            APPLY_ALL_ORG_DIALOG: {
                DIALOG_TITLE: 'Apply Your Preferences to All Organizations?',
                INFO_TEXT:
                    'Your Preferences for this Organization will be applied to your account on the following Organizations.',
            },
        },
        AUDIT_LOGS: {
            EMAIL_SUCCESS: 'Email Sent Successfully',
            DOWNLOAD_MSG: 'File downloaded',
            DOWNLOAD_COMPLETE: 'Download complete',
            CODE_LABEL: 'Code',
            EXPORT_HEADER: 'Export Audit Log',
            EXPORT_SUBHEADER: 'Data and date range for export is collected based on page filters.',
            FILE_FORMAT: 'Choose file format',
            FILE_LOCATION: 'Choose file location',
            SYSTEM: 'System',
            REQUEST_LABEL: 'Request',
            RESPONSE_LABEL: 'Response',
            FILE_OPTIONS: {
                CSV: 'CSV',
                EXCEL: 'EXCEL',
                PDF: 'PDF',
            },
            OKAY_LABEL: 'OKAY',
            FILTER_HEADER: 'Audit Log Filters',
            CODE: 'Code :',
            EMPTYLOGS: 'No Audit Logs found',
            SAVE_DEVICE: 'Save To Device',
            SHARE: 'Share',
            TIME_EVENT: 'Time of Event',
            CARD_HEADER: 'Origin',
            USER: 'User',
            SAVE_AUDIT_LOGS_HEADER: 'Data and date range to be saved is selected based on page filters.',
            SAVE_AUDIT_LOGS: 'Save Audit Log To Device',
            SHARE_AUIDT_LOGS: 'Share Audit Log',
            DOCUMENT_DOWNLOADED: 'Document Downloaded',
            DOWNLOAD_FAIL_WITH_STATUS_CODE: 'Download failed with status code:',
            COLLECTING_AUDIT_LOG_DATA_FOR_EXPORT:
                'Collecting Audit Log data for export. Please wait this may take a few minutes.',
            SELECTED_BASED_ON_PAGE_FILTERS: 'ge to be saved is selected based on page filters.',
        },
        AUTOMATIONS: {
            DELETE_AUTOMATIONS_SUCCESS: '{{selectedIds}} automation(s) deleted successfully',
            DELETE_AUTOMATIONS_SUCCESS_MOBILE: '{{selectedIds}} automation(s) successfully deleted',
            DELETE_AUTOMATION_MODAL: 'Delete Automation?',
            DELETE_AUTOMATIONS_MODAL: 'Delete Automation(s)?',
            EMPTY_STATE_DESCRIPTION: 'Automations let you trigger control actions with events',
            NO_ACTION_FOUND: 'No Actions found',
            AUTOMATION_EDIT_SUCCESS: 'Automation updated successfully.',
            DELETE_AUTOMATIONS_COUNT: '{{selectedIds}} automation(s) will be deleted',
            AUTOMATION_CREATE_SUCCESS: 'Automation created successfully',
            UPDATE_AUTOMATION: 'Update Automation',
            NO_ACTIONS: 'No Actions',
            NO_DEVICE_TYPES: 'No Device Types',
            SELECT_TRIGGER_EVENTS: 'Select Trigger Events',
            ADD_AUTOMATION: 'Add Automation',
            SELECT_ACTIONS: 'Select Action',
            NEW_AUTOMATION: 'Automation Details',
            SELECT_DEVICE_TYPE_DESC: 'Choose the type of device you want to configure an automated action.',
            SELECT_EVENTS_DESC: 'Choose which events will trigger the action.',
            SELECT_ACTION_DESC: 'Choose the action you want to automate.',
            SELECT_GROUP_AND_DEVICE_DESC:
                'Choose on which device(s) the automated action is to apply. If a group is selected, then the action selected will apply to each device of the specified device type located in that group.',
            SELECT_LOAD_GROUP_DESC: 'Choose on which load group(s) the automated action is to apply.',
            NO_EVENTS: 'No Events',
            EDIT_AUTOMATION: 'Edit Automation',
            EDIT_AUTOMATIONS: 'Edit Automations',
            NO_AUTOMATIONS: 'No Automations',
            NO_DESC_1: 'Automations let you trigger control actions',
            NO_DESC_2: 'with events',
            EVENT_MSG: 'Set a delay before a notification is sent',
            DELETE_AUTOMATION_NOTE_1:
                'Selecting Delete will permanently remove {{count}} automations from the system. This cannot be undone.',
            DELETE_AUTOMATION_NOTE_2:
                'Selecting Delete will permanently remove this automation from the system. This cannot be undone.',
            DELETE_AUTOMATION_NOTE_3:
                'Selecting Delete will permanently remove {{count}} automation(s) from the system. This cannot be undone.',
            SELECT_GROUP_NO_DESC: 'You can add groups to better organize Devices.',
            DELAY: 'Delay',
            AUTOMATION_NAME_HELPER_TEXT: 'e.g. Shutdown on Over Temperature, Load 2 On When High',
            SELECT_DEVICE_MODEL_SUBHEADER: 'Choose the device models you want to configure an automated action.',
            SELECT_ASSET_CATEGORY_SUBHEADER: 'Choose the category and assets to configure an automated action.',
            SELECT_ASSET_TYPE: 'Select Asset Type',
            ASSET_CATEGORY: 'Asset Category',
            DEVICE_CATEGORY: 'Device Category',
            DEVICE_MODELS: 'Device Models',
            LOAD_GROUPS: 'Load Groups',
            LOAD_GROUPS_SELECTION_PLACEHOLDER: 'Load Groups selection will appear here.',
            TURN_OFF_LOAD_GROUP: 'Turn Off Load Group',
            TURN_ON_LOAD_GROUP: 'Turn On Load Group',
            LOAD_BALANCING_INFO_BANNER:
                'Load balancing automations can only be edited under load balancing in a group or device.',
            TRIGGER_EVENTS: 'Trigger Event(s)',
            ACTIONS_LABEL: 'Action(s)',
        },
        CUSTOM_NOTIFICATION: {
            TITLE: 'Custom Notification',
            NOTE: 'Custom Notifications can be created by Group, Device Type, Devices, and/or Events. Custom notifications can be assigned to existing User Accounts or Emergency Contacts.',
            NOTE_SECOND: 'Custom notification rules take precedence over individual notification preferences.',
            NO_DATA_BTN: 'Add a Custom Notification',
            NO_DATA_DESC_FIRST: 'Custom Notifications can be created by Group,',
            NO_DATA_DESC_SECOND: 'Device Type, Devices, and/or Events. Custom',
            NO_DATA_DESC_THIRD: 'notifications can be assigned to existing User',
            NO_DATA_DESC_FOURTH: 'Accounts or Emergency Contacts.',
        },
        UPLOADING_IMAGE: {
            INVALID_FORMAT: 'Invalid image format',
            IMAGE_SIZE_WARN: 'Image size must be less than 2 MB',
            BTN_CAMERA: 'Take Photo',
            BTN_GALLARY: 'Choose Existing Photo',
            BTN_FILES: 'Browse Files...',
            ERROR_CAMERA: 'Error while uploading Image.',
            PERMISSION_ERROR: 'Please enable permissions for image access in phone settings.',
        },
        GROUP_MANAGEMENT: {
            NO_GRPS_YET: 'No groups yet',
            NO_GPRS_MSG: 'Select from the groups list.',
            DELETE_GROUP_MOBILE: 'Deleting {{groupName}} will delete just the group. No other data will be lost.',
            MOVE_GROUPS_AND_DEVICES: {
                HEADER: 'Move Groups and Devices',
                GROUPS_DEVICES: '{{groupCount}} groups {{deviceCount} Devices}',
                SELECT_GROUPS_DEVICES: 'Select Groups and Devices to Move',
                SELECT_GROUPS: 'Select Devices and Groups to Move to {{name}}',
                MOVE_TO: 'Move Groups and Devices to {{selectedDestinationGroup}}',
                SELECT_DESTINATION_GROUP: 'Select the Destination Group',
                DESCRIPTION:
                    'Moving groups and devices may affect user access rights, information aggregation, historical data, reports, and more.',
                CHILD_GROUPS_MOVE: 'Child groups and devices have been moved.',
                DELETE_GROUP: 'Deleting will delete just the group. No other data will be lost.',
                DELETE_GROUP_MOBILE: 'Deleting {{groupName}} will delete just the group. No other data will be lost.',
                HEADER_TITLE: 'Groups & Devices Moved',
                WILL_DELETE_JUST_THE_GROUP: 'will delete just the group.',
                NO_OTHER_DATA_WILL_BE_LOST: 'No other data will be lost.',
            },
            EDIT_GROUP: {
                CHILD_GROUPS: 'Child Groups',
                NO_CHILD_GROUPS: 'No Child Groups',
                SUB_EMPTYSTATE_DEVICES: 'This Group has no direct child Devices, but may have Devices in child Groups',
                SUB_EMPTYSTATE_GROUPS: 'This Group has no Groups',
                IMAGE_REMOVED: 'Image removed successfully.',
                IMAGE_UPDATED: 'Image updated successfully.',
                GROUP_COUNT: '{{groupCount}} Groups',
                DEVICE_COUNT: '{{deviceCount}} Devices',
                UPDATE_GROUP: 'Update Group',
            },
            HELPER_TEXTS: {
                ASSISTIVE_TEXT: 'Assistive Text',
                GROUP_NAME_HELPER_TEXT: 'e.g. Location, Region, Division, etc.',
                SHORT_NAME_HELPER_TEXT: 'A short name can be used when displaying a breadcrumb or auto-naming a device',
                PARENT_GROUP_HELPER_TEXT:
                    'This structure can also be edited from the main hierarchy page with a drag-and-drop function',
                GROUP_TYPE_HELPER_TEXT:
                    'Group Type can define what cards and widgets you see by default as well as slots for common devices for this type',
            },
            STEPPER_MODAL: {
                GROUP_NAME: 'Group Name',
                GROUP_SHORT_NAME: 'Group Short Name',
                PARENT_GROUP: 'Parent Group',
                GROUP_TYPE: 'Group Type',
                MOVE_EXISTING_GROUPS_AND_DEVICES: 'Select Devices and Groups to Move to {{name}}',
                SELECT_USERS: 'Select Users with Access to {{name}}',
                DISPLAY_PREFRENCES: 'Display Preferences for {{name}}',
                SUB_HEADING_DISPLAY_PREFRENCES:
                    'This imagery will be shown in cards, headers, and lists, allowing you to more easily identify your groups.',
                PHOTO: 'Photo',
                MAP: 'Map',
                ADD_EXISTING: 'Add Existing Groups and Devices',
                SET_USER_ACCESS: 'Set User Access',
                CHOOSE_DISPLAY: 'Choose Display',
            },
            TOOLTIP: {
                EDIT: 'Edit Group',
            },
            BTN: {
                ADD_A_GROUP: 'Add a Group',
                ADD_AND_FINISH: 'Add Group & Finish',
                MOVE_A_GROUP: 'Move a Group',
                MOVE_A_DEVICE: 'Move a Device',
                UPLOAD_A_PHOTO: 'Upload a Photo',
            },
            LABELS: {
                GROUPS: 'Group(s)',
                SHORT_NAME: 'Short Name',
                CHILDREN: 'Children',
                MOVE_GROUP: 'Move Group & Device',
                MOVE_BTN_LABEL: 'Move Group(s) & Device(s)',
                DELETE_THIS_GROUP: 'Delete this Group',
                NO_GROUPS: 'No Groups',
                NO_GROUPS_FOUND: 'No Groups Found',
                FILE_SIZE: 'Maximum file size of 50MB',
            },
            MESSAGE: {
                SELECTED_DELETE: '{{groupName}} and all of its child groups and devices have been deleted',
                SUCCESS_DELETE: '{{groupName}} has been deleted',
                HAVE_BEEN: ' have been ',
                ARE_BEING: 'are being',
                MOVED_TO: 'moved to ',
                CREATED_SUCCESSFULLY: 'Group created successfully.',
                GROUP_CHANGES_SUCCESS: 'Group changes saved successfully',
            },
            DELETE_MODAL: {
                MOVE_CHILDREN: 'Move Children to Another Group',
                CONFIRM_MESSAGE:
                    '{{name}} and all of it’s associated settings will be permanently deleted. To proceed, type ‘delete’ in the text box below and then select the ‘Delete Role’ button.',

                HEADER_MOBILE: 'Delete {{groupName}}?',
                MOVE_CHILDREN_DESC: 'Children can be moved to another group before deleting {{groupName}}.',
                DELETE_GRP_AND_CHILDREN: 'Delete Group and Children',
                DELETE_AND_ERASE: 'Delete & Erase All Data',
                HEADER: 'Delete {{groupName}} and All of its Children?',
                DESCRIPTION:
                    'This cannot be undone. All of the location, device, alarm, event data for Pittsburgh and all of its child groups and devices will be permanently deleted.',
                DESCRIPTION_MOBILE:
                    'This cannot be undone. All of the location, device, alarm, event data for {{groupName}} and all of its child groups and devices will be permanently deleted.',
            },
            GROUPS_AND_DEVICES_MOVED_SUCCESSFULLY: 'Groups and Devices Moved Successfully',
        },
        MESSAGE: {
            SELECTED_DELETE: '{{groupName}} and all of its child groups and devices have been deleted',
            SUCCESS_DELETE: '{{groupName}} has been deleted',
            HAS_BEEN: 'has been',
            ARE_BEING: 'are being',
            MOVED_TO: 'moved to {{groupName}}.',
            CREATED_SUCCESSFULLY: 'Group created successfully.',
        },
        DOCUMENTS: {
            DOCUMENT_FILTER: {
                TITLE: 'Document Filters',
                DOCUMENT_TYPE: 'Document Type',
                FILE_NAME: 'File Name',
                GROUPS_DEVICES: 'Group(s) & Devices',
                APPLY_FILTERS: 'Apply Filters',
            },
        },
        DEVICES: {
            FILTER: 'Filters',
            DEVICE_NAME: 'Device Name',
            OPTIONS: {
                ADD_EDIT_TAGS: 'Add/ Edit Tags',
                DEVICE_CONFIGURATION: 'Device Configuration',
                MOVE_DEVICE: 'Move Device',
            },
        },
        NOTIFICATION_AND_PREFERENCES: {
            LABELS: {
                SELECT_DEVICE_MODELS: 'Select Device Models',
                PREFERENCES: 'Preferences',
                SELECT_DEVICE_TYPES: 'Select Device Type',
                SELECT_ASSET: 'Select Assets',
            },
            CUSTOM_NOTIFICATIONS: {
                TITLE: 'Custom Notifications',
                NO_CUSTOM_NOTIFICATION_DESCRIPTION: `Custom Notifications can be created by Group, Device Type, Devices, and/or Events. Custom notifications can be assigned to existing User Accounts or Emergency Contacts.`,
            },
        },
        DASHBOARDS: {
            ASSOCIATE_DEVICES_SUCCESS_MSG:
                '{{name}} has been successfully associated with {{count}} selected group(s) or device(s).',
            UPDATE_DASHBOARD_DETAILS_MSG: '{{name}} details have been updated.',
            SELECT_DASHBOARD: 'Select A Dashboard',
            REPLACE_CURRENT_DASHBOARD: 'Replace the current device dashboard with another from the library.',
            NO_ALTERNATE_DASHBOARDS:
                'There are no alternative dashboards present in the library compatible with this device. Edit the current dashboard and select “Save As” to create a new one.',
            DASHBOARD_UPDATE_SUCCESS: 'Dashboard updated successfully',
            DASHBOARD_DELETE_SUCCESS: '{{name}} has been deleted.',
            CREATE_DASHBOARD: 'Create Dashboard',
            DASHBOARD_LIBRARY_LABEL: 'Dashboard Library',
            EDIT_DASHBOARD: {
                DASHBOARD_DETAILS_LABEL: 'Dashboard Details',
                DASHBOARD_UPDATE_SUCCESSFULLY: 'Dashboard details updated successfully.',
            },
            SHARE_DASHBOARD: 'Share Dashboard',
            REALM_LIBRARY: 'Realm Library',
            NO_DASHBOARD: 'No Dashboard',
            CLONE_DASHBOARD: 'Clone Dashboard',
            ASSOCIATE_DEVICES: 'Select the groups or devices to associate with the {{name}} Dashboard.',
            CLOSE_WARN_MODAL: {
                HEADER: 'Exit Without Saving?',
                DESCRIPTION:
                    "Select 'Close Editor' to exit the dashboard editor without saving changes or 'Cancel' to save changes before exiting",
                CLOSE_EDITOR: 'Close Editor',
            },
            DELETE_DASHBOARD: {
                WARN_TEXT_1: 'This dashboard is in use and associated with {{count}} devices.',
                WARN_TEXT_2: 'Deleting the dashboard will remove it from all associated devices.',
                WARN_TEXT_3: 'You are about to delete a dashboard. This action cannot be undone.',
                DELETE_DEFAULT_DASHBOARD_DESC:
                    'This is the default dashboard for the {{dataSource}}. You must select another dashboard as the default dashboard for {{dataSource}} before continuing.',
                DELETE_DASHBOARD_TEXT: 'Delete Dashboard',
                DELETE_DASHBOARD_TEXT_TITLE: 'Delete Dashboard ?',
                DELETE_DASHBOARD_DESCRIPTION: 'This will permanently delete {{name}}. This action cannot be undone.',
                UNABLE_DELETE: 'Cannot Delete Dashboard',
                UNABLE_DELETE_TEXT:
                    'There are no alternative dashboards present in the library compatible with this device.',
            },
            DASHBOARD_DETAILS_MODAL: {
                SET_AS_DEFAULT: 'Set as the default system dashboard for {{sourceName}}',
                EMBEDED_WIDGETS: 'Embedded Widgets',
                DESCRIPTION: 'Changes made to this dashboard will be reflected in the dashboard library.',
            },
            CLONE_MODAL_DASHBOARD: {
                DESCRIPTION: 'Give the new dashboard a name and description.',
                SYSTEM_USER_DESCRIPTION: 'Is this a system or user dashboard?',
                SYSTEM_DASHBOARD: 'System Dashboard',
                SYSTEM_DASHBOARD_DESCRIPTION: 'Displayed to all users.',
                USER_DASHBOARD: 'User Dashboard',
                USER_DASHBOARD_DESCRIPTION: 'Private, displayed only to you.',
                SET_AS_DEFAULT: 'Set as the default system dashboard for {{deviceType}}.',
                HAS_BEEN_CREATED: ' has been created.',
                HAS_BEEN_SAVED: ' has been saved',
            },
        },
        WIDGETS: {
            WIDGETS_BUILDER: 'Widget Builder',
            WIDGET_NOT_CONFIGURED: 'Widget Not Configured',
            NOT_FOUND_LABEL: 'Widget Not Found',
            CONFIGURATION_EMPTY_STATE_DESC:
                'This widget will display the devices according to the device or group dashboard on which the widget is placed.',
            NEW_WIDGET: 'New Widget',
            NO_DEVICE_PROVISION: 'A device must first be provisioned before device types will be available.',
            WIDGET_UPDATE_SUCCESS: '{{widgetName}} updated successfully',
            WIDGET_DELETE_SUCCESS: '{{widgetName}} widget has been deleted.',
            NO_WIDGET: 'No Widgets',
            NO_WIDGETS_FOUND: 'No Widgets Found',
            NO_WIDGET_DESC: 'Widgets let you monitor, interact with and manage groups and devices.',
            ADD_WIDGET: 'Add Widget',
            ADD_WIDGET_SUBTITLE: 'Select a datasource for the new {{widgetType}} widget.',
            CREATE_WIDGET: 'Create Widget',
            COMMON_PREFERENCES: {
                TOTAL_COUNT_TEXT: 'Display total {{countKey}} in header',
                MAXIMUM_CHANNEL_TEXT: 'Maximum number of {{channelType}} to display.',
                AMOUNT_OF_CHANNELS_DISPLAY_TEXT: 'Number of {{channelType}} to display',
            },
            COMMON: {
                MAX_CHANNEL_TEXT: 'Maximum number of channels to display on {{widgetType}}.',
                REARRANGE_CHANNELS_DESCRIPTION:
                    'Drag the selected {{channelType}} in the order you would like to view them. Total {{channelType}} displayed {{count}} in the widget can be modified in Display Preferences.',
            },
            ADD_WIDGET_MODAL: {
                FILTER_TYPE: 'Filter by Widget Type',
                SELECT_WIDGET: 'Select Widget',
                NO_WIDGET_TYPE: 'Select widget type from the left column',
                EXISTING_WIDGETS: 'EXISTING WIDGETS',
                NO_EXISTING_WIDGETS:
                    'There are currently no pre-existing {{label}} widgets. Select Next below to proceed.',
            },
            PREVIEW_MODAL: {
                HEADER: 'Select Preview {{header}}',
            },
            RENAME_WIDGET_MODAL: {
                SUCCESS_MSG: '{{widgetName}} has been renamed.',
                RENAME_WIDGET: 'Rename Widget',
                HEADER: 'Rename Widget?',
                WARN_TXT: 'This widget is in use and associated with {{count}} dashboards.',
                WARN_TXT_DESC: 'Renaming the widget will change the widget name in all associated dashboards.',
            },
            CLONE_MODAL_HEADER: 'Give your new widget a name and description',
            WIDGET_NAME_ALREADY_EXISTS: 'Widget name already exists',
            CLOSE_WARN_MODAL: {
                HEADER: 'Exit Without Saving?',
                DESCRIPTION:
                    "Select 'Close Editor' to exit the widget editor without saving changes or 'Cancel' to save changes before exiting",
                CLOSE_EDITOR: 'Close Editor',
            },

            CLONE_WIDGET: 'Clone Widget',
            SAVE_AS_LABEL: 'Save As',
            WIDGET_CONFIGURATION: {
                CONFIGURATION: 'Configuration',
                DISPLAY_PREFRENCES: 'Display Preferences',
            },
            DELETE_WIDGET_MODAL: {
                HEADER: 'Delete Widget?',
                BTN_TITLE: 'Delete Widget',
                WARN_TEXT_1: 'This widget is in use and associated with {{count}} dashboards.',
                WARN_TEXT_2: 'Deleting the widget will remove it from all associated dashboards.',
                WARN_TEXT_3: 'You are about to delete a widget. This action cannot be undone.',
            },
            REMOVE_WIDGET_MODAL: {
                HEADER: 'Remove {{widgetName}} Widget ?',
                DESCRIPTION: "Select 'Continue' to remove {{widgetName}} widget and all of its settings.",
            },
            GROUP_LIST: {
                DISPLAY_PREFERENCE: {
                    GRPS_TO_DISPLAY: 'Number of groups to display',
                    DESCENDING: 'Descending',
                    ASCENDING: 'Ascending',
                    DISPLAY_ORDER: 'Display Order',
                    DISPLAY_VIEW_ALL: 'Display “View All” bar',
                    DISPLAY_TOTAL_COUNT: 'Display total count in header',
                    MAX_NO_GRP: 'Maximum number of groups to display in widget',
                    DISPLAY_DIRECTION: 'Display Order Direction',
                    MENU_ITEM: {
                        STATUS: 'Status',
                        HIERARCHY_ORDER: 'Hierarchical Order',
                        ALPHABETICAL: 'Alphabetical',
                        DEVICE_GROUP_COUNT: 'Group Count',
                    },
                    DISPLAY_LAST_UPDATED: 'Display Last Updated in Header',
                    DISPLAY_WIDGET_HEADER: 'Display Widget Header',
                },
                NOT_LINKED_MSG: 'Not linked to a specific group',
                NOT_LINKED_DESC:
                    'This widget will display the immediate child groups of the group dashboard on which the widget is placed.',
            },
            GAUGE: {
                SELECTED_CHANNELS: 'SELECTED CHANNELS',
                GAUGE_TYPE: 'Gauge Type',
                DISPLAY_SCALE: 'Display Scale',
                DISPLAY_THRESHOLD: 'Display Threshold',
                SELECTED_CHANNEL_TXT:
                    'The selected channel is now displayed as a gauge. To choose a different gauge type, open the Display Preferences.',
                MENU_ITEMS: {
                    SOLID_GAUGE: 'Solid Gauge',
                    KPI: 'KPI',
                    SPEEDOMETER: 'Speedometer',
                    HORIZONATL: 'Horizontal',
                },
            },
            CHARTS: {
                BAR_CHART: 'Bar Chart',
                COLUMN_CHART: 'Column Chart',
                PIE_CHART: 'Pie Chart',
                MAX_CHARTS: 'Maximum number of channels to display on chart',
                CHART_TYPE: 'Chart Type',
                BAR: 'Bar',
                COLUMN: 'Column',
                UNITS: {
                    AMPS: '(A) Amps',
                    CELSIUS: '(°C) Celsius',
                    KILOWATTS: ' (kW) Kilowatts',
                    PERCENTAGE: ' (%) Percentage',
                    VOLTAGE: '(dV) Voltage',
                },
                MAX_CHANNELS_TRENDS: 'Maximum number of channels to display on trends',
                MAX_NUMBER_LOAD_GROUPS: 'Maximum number of load groups',
            },
            LOADS: {
                ADD_VIRTUAL_LOAD: 'Add Virtual Load',
                NO_LOADS_FOUND: 'No Loads Found',
                DISPLAY_TOTAL_LOADS: 'Display total count in header',
                NO_OF_LOADS: 'Number of loads to display',
                MAX_LOADS_DISPLAY: 'Maximum number of loads to display in widget',
                SELECT_LOADS_WITHOUT_COUNT: 'Select Loads',
                SELECT_LOADS: 'Select Loads ({{count}})',
                SELECT_LOAD_SWITCH_LABEL: "Display all of this device's loads automatically",
                VIRTUAL_LOAD_LABEL: 'This Device doesnt have virtual loads.',
                NO_VIRTUAL_LOADS: 'No Virtual Loads',
                NO_VIRTUAL_LOADS_DESC: 'Add loads to this UPS to assist in planning and add context to device user',
                VIRTUAL_LOAD_SUCCESS_CREATION: 'Virtual Load Created Successfully.',
                VIEW_ALL: 'View All Virtual Loads',
                SELECTED_LOADS: 'Selected Loads',
            },
            LOADS_GROUPS: {
                NO_LOAD_GROUPS: 'No Load Groups',
                NO_LOAD_GROUPS_DESCRIPTION: 'Once load groups are added or created they will be viewable here.',
                ADD_LOAD_GROUPS_TO_WIDGET: 'Add Load Group(s) to Widget',
                CREATE_LOAD_GROUP: 'Create Load Group',
                ADD_LOAD_GROUPS: 'Add Load(s)',
                ADD_LOADS: 'Add Load(s)',
                REMOVE_LOADS: 'Remove Load(s)',
                NEW_LOAD_GROUP_NAME_AND_DESCRIPTION: 'Give your new load group a name and description.',
                NEW_LOAD_GROUP_SUB_HEADING:
                    'Is this a single device specific load group or will it contain loads that span two or more devices?',
                MULTI_DEVICE_TYPE_SELECTION: 'Device Type For Load Selection',
                SELECT_SIXTEEN_LOADS: 'You can select up to sixteen loads for a single load group.',
                ADDED_LOADS_VIEWABLE: 'Once loads are added to this load group they will be viewable here.',
                REMOVE_SELECTED_LOADS:
                    'Selecting ‘continue’ will remove the <{{loadCount}}> selected load(s) or select ‘cancel’ to go back.',
                SELECT_LOAD_GROUPS_TO_ADD: 'Select Loads to Add to the Load Group',
                CHANGES_HAVE_BEEN_SAVED_SUCCESSFULLY: 'Changes have been saved successfully.',
                LOAD_GROUP_DETAILS: 'Load Group Details',
                PERMISSION_FOR_ALL_DEVICES:
                    'A user must have permissions for all devices in a linked load group in order to view and interact with that load group.',
                REDUNDANCY: 'Redundancy',
                SELECT_ACTIVE_LOADS_BEFORE_ALERT_NOTIFICATION:
                    'Select the minimum number of active loads necessary before alert notification.',
                SELECT_DEVICE_TO_CREATE_A_LOAD_GROUP: 'Select device to create a load group',
                SELECT_LOADS_TO_ADD_TO_THE_LOAD_GROUP: 'Select Loads to Add to the Load Group',
                LOAD_GROUP_CREATED_SUCCESSFULLY: 'Load group created successfully.',
                SELECTED_LOAD_GROUP_DELETED: 'Load group <{{loadGroupName}}> has been successfully deleted.',
                COUNT_LOAD_GROUP_DELETED: '<{{count}}> Load Group(s) have been deleted successfully.',
                REDUNDANCY_ACTIVE: 'Redundancy Active',
                REDUNDANCY_ERROR: 'Redundancy Error',
                LOAD_COUNT: 'Load Count',
                DELETE_LOAD_GROUP_WITH_QUESTION_MARK: 'Delete Load Group?',
                DELETE_LOAD_GROUP_BTN: 'Delete Load Group',
                DELETE_LOAD_GROUP_DESCRIPTION:
                    'To delete <{{loadGroupName}}> load group select ‘Delete Load Group’ or cancel to go back.',
                SPECIFIC_TO_A_SINGLE_DEVICE: 'Specific to a single device',
                CONTAINS_LOADS_ON_MULTIPLE_DEVICES: 'Contains loads on multiple devices',
                LOAD_GROUP_SUCCESSFULLY_DELETED: 'Load group <{{loadGroupName}}> has been successfully deleted.',
                TURN_LOAD_GROUP_OFF: 'Turn Load Group Off?',
                TURN_LOAD_GROUP_ON: 'Turn Load Group On?',
                LOAD_GROUPS_INDETERMINATE_TITLE: 'Load Group in Indeterminate State',
                LOAD_GROUPS_INDETERMINATE_SUBTITLE:
                    'Select if you would like to turn all load groups on or turn all load groups off.',
                CREATE_LOAD_GROUP_SUBTITLE: 'Give your new load group a name and description.',
                MULTI_DEVICE_QUESTION:
                    'Is this a single device specific load group or will it contain loads that span two or more devices?',
                DISCARD_CHANGES_HEADER: 'Discard Changes?',
                DISCARD_CHANGES_DESCRIPTION:
                    'Select ‘Continue’ to discard your changes or ‘Go Back’ to save your changes.',
                LOAD_GROUP_TURNING_OFF: 'Load group turning off',
                LOAD_GROUP_TURNING_ON: 'Load group turning on',
                LOAD_GROUP_TURN_OFF_INITIATED: '{{loadGroupName}} turn off initiated.',
                LOAD_GROUP_TURN_ON_INITIATED: '{{loadGroupName}} turn on initiated.',
                LOAD_GROUP_TURN_ON_COMPLETED: '{{loadGroupName}} turn on completed.',
                LOAD_GROUP_TURN_OFF_COMPLETED: '{{loadGroupName}} turn off completed.',
                TURN_ALL_LOAD_GROUPS: 'Select whether you want to turn all load groups ON or OFF.',
                TURN_ALL_LOADS_ON: 'Turn All Loads On',
                TURN_ALL_LOADS_OFF: 'Turn All Loads Off',
                ALL_LOADS_TURNED_ON_SUCCESSFULLY: 'All loads turned on successfully.',
                ALL_LOADS_TURNED_OFF_SUCCESSFULLY: 'All loads turned off successfully.',
                LOADS_REMOVED_SUCCESSFULLY: 'Loads have been removed successfully.',
                LOADS_HAVE_BEEN_ADDED_SUCCESSFULLY: 'Load(s) have been added successfully.',
                REMOVE_ALL_SELECT_LOADS_DESCRIPTION:
                    'A load group must contain at least one load. All loads in the load group have been selected for removal. Please deselect at least one load to continue or return to the manage load group screen and delete the load group.',
                DISCARD_CHANGES_DESCRIPTION_MOBILE:
                    'Select ‘Discard Changes’  to discard your changes or select ‘Go Back’ to continue editing and to save your changes.',
                TURN_LOAD_GROUP_OFF_DESCRIPTION: 'Would you like to turn off',
                TURN_LOAD_GROUP_ON_DESCRIPTION: 'Would you like to turn on',
            },
            BALANCING: {
                ADD_AUTOMATION: 'Add Automation',
                CREATE_AUTOMATION: 'Create Automation',
                SEARCH_GROUPS_AND_DEVICES: 'Search Groups & Devices',
                DELETE_AUTOMATION: 'Delete Automation(s)',
                NO_LOAD_BALANCING_TITLE: 'No Load Balancing Automations',
                LOAD_BALANCING: 'Load Balancing',
                NO_LOAD_BALANCING_DESCRIPTION: 'Load balancing automations let you trigger control actions with events',
                DELETE_AUTOMATIONS_HEADER: 'Delete Automation(s)?',
                DELETE_AUTOMATIONS_DESCRIPTION:
                    "To continue deleting {{count}} load balancing automation(s) select the 'Delete' button or select cancel to go back.",
                DELETE_SUCCESS: '{{count}} load balancing Automation(s) have been deleted',
                DELETE_AUTOMATIONS_DESCRIPTION_COUNT:
                    "To continue deleting {{count}} load balancing automation(s) select the 'Delete' button or select cancel to go back.",
                DELETE_SUCCESS_COUNT: '{{count}} load balancing Automation(s) have been deleted',
                AUTOMATION_NAME_LIMIT: 'Automation Name must be {{limit}} characters or fewer',
                AUTOMATION_NAME_REQUIRED: 'Please enter a valid Automation Name',
                AUTOMATION_DESC_LIMIT: 'Automation Description must be {{limit}} characters or fewer',
                UPDATE_SUCCESS: 'Changes to automation have been saved.',
                SAVE_SUCCESS: 'Automation has been saved',
                ACTION_UPDATE_SUCCESS: 'Action has been updated',
                ACTION_CREATE_SUCCESS: 'Action has been created',
                ACTION_DELETE_SUCCESS: 'Action has been deleted',
                LOAD_ON: 'Load On',
                LOAD_GROUP_ON: 'Load Group On',
                NO_CONTROLLABLE_LOADS: 'No Controllable Loads',
                TRIGGER_EVENT_ICON_HELPER:
                    'An automation requires a selected load or load group defined as the trigger for an event.',
                EMPTY_LOAD_GROUPS: 'No load groups found',
                EMPTY_DEVICES: 'No devices found.',
                MULTIPLE_DEVICE: 'Multiple Device',
                TURN_ON_LOAD: 'Turn On Load',
                TURN_OFF_LOAD: 'Turn Off Load',
                TURN_ON_LOAD_GROUP: 'Turn On Load Group',
                TURN_OFF_LOAD_GROUP: 'Turn Off Load Group',
                MULTIPLE_LOADS: 'Multiple Loads',
                MULTIPLE_LOAD_GROUPS: 'Multiple Load Groups',
                MULTIPLE_DEVICES: 'Multiple Devices',
                AUTOMATION_DETAILS: 'Automation Details',
                TRIGGER_EVENT: 'Trigger Event',
                ON_SET: 'On Set',
                ON_CLEAR: 'On Clear',
                ERROR_LOADING_EVENTS: 'Failed to load trigger events. Please try again later.',
                THRESHOLD_MODAL_SUBHEADER:
                    'Setting or changing threshold values will update them in the device details and change them for both automations and notifications',
                UPDATE: 'Update',
                SYSTEM_DISABLED_WARNING: 'Reactivate the disabled alert value in this automation to reenable it.',
                SELECT_TRIGGER_EVENT_HEADING: '2. Select Trigger Event',
                CREATE_ACTIONS_HEADING: '3. Create Action(s)',
                CREATE_ACTIONS_HEADING_MOBILE: 'Create Action',
                SELECT_TARGET_HEADING: '1. Select Target',
                SELECT_TARGET: 'Select Target',
                APPLY_ACTION_HEADING: '2. Apply Action to Target(s)',
                SELECT_TRIGGER_HEADING: '1. Select Trigger',
                TRIGGER_TYPE_LABEL: 'Trigger Type',
                TRIGGER_EVENT_HELPER: 'A trigger event calls an action.',
                ACTION_HELPER: 'An action is applied to loads or load groups to perform a task',
                TARGET_LOADS: 'Loads',
                TARGET_LOAD_GROUPS: 'Load Groups',
                TARGET_DEVICES: 'Devices',
                TURN_ON_DEVICE: 'Turn On Device',
                TURN_OFF_DEVICE: 'Turn Off Device',
                SELECT_TARGET_ACTION_DESC: 'Select the target and action to apply',
                NOTES_PLACEHOLDER: 'Notes',
                DELETE_ACTION_CONFIRM_MESSAGE: 'To continue deleting the action select the ‘Delete Action’ button.',
                DELETE_ACTION_BUTTON: 'Delete Action',
                MULTIPLE_GROUPS: 'Multiple Groups',
                DISABLING_THRESHOLD_WARNING: 'Disabling a threshold disables linked automations and notifications.',
                DELETE_AUTOMATIONS_MESSAGE:
                    'To continue deleting 2 load balancing automation(s) select the  ‘Delete’ button or select cancel to go back.',
                SELECT_ASSET_S: 'Select Asset(s)',
                TARGET_TYPE: 'Target Type',
            },
            TIMELINE: {
                DISPLAY_PREFERENCE: {
                    HEADER: 'Events to display',
                    DISPLAY_SEVERITY: 'Display severity rollups',
                    MAX_NO_OF_EVENTS: 'Maximum number of events to display',
                },
            },
            MAPS: {
                INFORMATIONAL_LABEL: 'Informational',
                DEVICE_TYPES_TO_DISPLAY: 'Device types to display',
                SELECT_GROUPS_DEVICES: 'Select Groups and Devices',
            },
            LOADS_DESC_ONE: 'Drag the Selected Loads in the order you would like to view them. Total',
            LOADS_DESC_TWO: 'loads displayed in the widget can be modified in Display Preferences.',
            EDIT_LOAD_DETAILS: 'Edit Load Details',
            EDIT_THRESHOLD: 'Edit Threshold',
            PREVIEW_DOCUMENT: 'Preview Document',
            UPCOMING_DETAILS: 'Upcoming Details',
            COMPONENT_LIST: 'Component List',
            COMPONENT_DETAILS: 'Component Details',
        },
        ENTITLEMENTS: {
            NA: '#N/A',
            NO_FEATURE_PACKAGE_SELECTED: 'No Feature Package Selected',
            NO_DEVICES_TEXT: 'Once devices are added to this Device License they will be viewable here.',
            NO_FEATURE_PACKAGE_SELECTED_DESCRIPTION:
                'Select a feature package from the pulldown above and its enabled features will be viewable here.',
            SUCCESS_MSG: {
                PLAN_CREATED: '{{planName}} has been created.',
                PLAN_UPDATED: '{{planName}} has been updated.',
                PLAN_DELETED: '{{planName}} has been deleted.',
                SUBSCRIPTION_CREATED: 'Subscription has been created.',
                SUBSCRIPTION_CREATED_V2: 'Subscription {{sequenceNumber}} has been created.',
                SUBSCRIPTION_UPDATED: 'Subscription has been updated.',
                SUBSCRIPTION_DELETED: 'Subscription has been deleted.',
            },
            DEVICE_LICENSE: {
                NAME_EXISTS_ERROR: 'Device License Name is already in use',
                FIELD_REQUIRED: 'Fields marked with an asterisk(*) are required.',
                DELETE_MODAL: {
                    HEADER: 'Delete Device License?',
                    DESCRIPTION: 'To continue deleting <{{deviceLicenseName}}> select the ‘Delete’ button.',
                },
            },
            CANCEL_CONFIRM_MODAL: {
                DESCRIPTION:
                    'Selecting ‘Continue’ will discard all changes or select ‘Go Back’ to continue editing the Device License.',
            },
            CANCEL_MODAL: {
                DESCRIPTION:
                    'There are unsaved changes to the Entitlement plan. Select ‘Continue’ to close this entitlement plan without saving changes or select ‘Save Changes’ to save the changes before closing.',
            },
            NO_ENTITLEMENTS: {
                NO_ENTITLEMENT: 'No Entitlements Found',
                ADD_PLAN_BTN: 'Add Entitlements',
            },
            SUBSCRIPTION: {
                START_END_DATES_APPEAR_FIRST_DEVICE_COMMISSIONED:
                    'Start and End Dates will appear when the first device is commissioned.',
                ONLY_ONE_SUB_HEADER: 'Only one subscription can be active at a time',
                ONLY_ONE_SUB_BODY_ONE:
                    'Adding a new subscription will cancel and replace the current one as the active subscription on this device license.',
                ONLY_ONE_SUB_BODY_TWO:
                    'Select ‘Continue’ to replace the active subscription or ‘Cancel’ to return to the Device License Details screen.',
                SUBSCRIPTION_START_COMMISSIONED_TEXT: 'Start subscription when the first device is commissioned',
                REVENERA_DATE_REFLECT_INFO: 'The start date & end date would be reflected after upgrade.',
                SUBSCRIPTIONS: 'Subscriptions',
                SUBSCRIPTION_NUMBER: 'Subscription #',
                DEVICE_LICENSES: 'Device Licenses',
                DEVICE_LICENSE_DETAILS_CUS_FAC: 'Devie License Details (Customer Facing)',
                MANAGE_SUB: 'Manage Subscriptions',
                VIEW_SUB: 'View Subscriptions',
                VIEW_DEV_LIC_SUB: 'Device Licenses & Subscriptions',
                MANAGE_DEV_LIC_SUB: 'Manage Device Licenses & Subscriptions',
                EDIT_SUB: 'Edit Subscription',
                ACTIVATE_LABEL: 'Activate Now',
                ADD_SUBSCRIPTION: 'Add Subscription',
                ADD_DEVICE_LICENSE: 'Add Device License',
                REVERNERA_ID: 'Revernera Account ID',
                DESCRIPTION: 'Description',
                EDIT_SUBSCRIPTION: 'Edit Subscription Details',
                ENTITLEMENT_PLAN: 'Entitlement Plan',
                DEVICE_LICENSE_NAME: 'Device License Name*',
                DEVICE_LICENSE_NAME_LABEL: 'Device License Name',
                FEATURE_PACKAGE: 'Feature Package',
                SUBSCRIPTION_START: 'Subscription Start Date',
                SUBSCRIPTION_END: 'Subscription End Date',
                DEVICE_COUNT: 'Device Count',
                ACTIVATION_ID: 'Activation ID',
                START_DATE: 'Start Date',
                END_DATE: 'End Date',
                DATE_RANGE: 'Date Range',
                LIMIT_DEVICE_MSG: 'Limit devices to specific count',
                SUBSCRIPTION_DETAILS: 'Subscription Details',
                SUBSCRIPTION_NOTES: 'Subscription Notes',
                DEVICE_LICENSE_DETAILS: 'Device License Details',
                DEVICE_LICENSE_DETAILS_CUSTOMER_FACING: 'Device License Details (Customer Facing)',
                NO_SUBSCRIPTION: 'No Subscriptions Found',
                DELETE_MODAL: {
                    HEADER: 'Delete Subscription?',
                    DESCRIPTION: 'Clicking ‘Delete’ will permanently delete this subscription.',
                },
                ACTIVATE_MODAL: {
                    HEADER: 'Save Your Changes',
                    DESCRIPTION:
                        'This action will expire your current plan and activate the new plan effective todays date. Are you sure you want to proceed?',
                },
                EFFECTIVE_STATUS: 'Effective Status',
                STATUS_UPCOMING: 'Upcoming',
                STATUS_ACTIVE: 'Active',
                STATUS_EXPIRED: 'Expired',
                TRIAL_FEATURE_PACKAGE: 'Trial Feature Package',
                NO_EXPIRATION: 'No Expiration',
                NO_DEVICE_ACTIVATED: 'No Device Activated',
                DEFERRED_START: 'Start on first device commission',
                SEQUENCE_NUMBER: 'Sequence #',
            },
            ADD_REVERNERA_MODAL: {
                HEADER: 'Revernera Account ID#',
                WARN_HEADER: 'No Revernera Account ID# Associated',
                WARN_DESCRIPTION:
                    'A Revenera Account ID must first be associated with in order to associate a Revernera-enabled entitlement plan.',
                DESCRIPTION:
                    'A Revernera Account ID# is required when Revernera is enabled for a specific entitlement plan. Its purpose is to associate a subscription to the appropriate organization or realm’s Revernera Account.',
            },
            REVENERA_ACCOUNT_ID: 'Revenera Account ID',
            REVENERA_ACTIVATION_ID: 'Revenera Activation ID',
            TITLE: 'Entitlements',
            SELECT_FEATURES_LABEL: 'Select Features',
            CUSTOMIZE_ENTITLEMENT: 'Customize your Entitlement Plan by selecting features.',
            HELPER_TEXT: {
                REQUIRED: 'Required',
            },
            BTN: {
                ADD_ENTITLEMENT: 'Add Entitlement Plan',
                EDIT_ENTITLEMENT: 'Edit Entitlement Plan',
            },
            CLONE_MODAL: {
                HEADER: 'Clone Entitlement Plan',
                SUB_HEADER: 'Give your new entitlement plan a name and description.',
            },
            ASSOCIATED_REALMS_AND_ORGS: {
                TITLE: 'Associated Realm & Orgs',
                HEADER: 'Associated Realms & Organizations',
                SUB_HEADER: 'View Realms and Organizations with {{realmName}} plan assigned.',
            },
            DELETE_MODAL: {
                HEADER: 'Delete Entitlement Plan?',
                DESCRIPTION: 'Clicking ‘Delete’ will permanently delete this entitlement plan.',
            },
            DELETE_WARN_MODAL: {
                DESCRIPTION:
                    'There are realms and organizations associated with this plan. They must be migrated to a different plan before this plan can be deleted.',
            },
            ADD_EDIT: {
                END_CURRENT_ACTIVE_SUB_HEADER: 'End Current Active Subscriptions?',
                END_CURRENT_ACTIVE_SUB_DESCRIPTION:
                    'Selecting ‘Continue’ will end the current active subscription and begin this newly created subscription immediately.',
                INVALID_ACTIVATION_CODE_HEADER: 'Invalid Activation Code',
                INVAID_ACTIVATION_CODE_DESCRIPTION:
                    'The Revenera activation code could not be validated.  Please, check the activation code and try again.',
                BASE_FEATURE_PACKAGE: 'Base Feature Package',
                SET_BASE_PLAN: 'Set as Base Plan?',
                SET_BASE_PLAN_MSG_1:
                    'Select ‘Continue’ to set {{planName}} as the default tier one base plan or ‘Cancel’ to go back. ',
                SET_BASE_PLAN_TITLE:
                    'This will override the current default base plan and will set the {{planName}} plan as the new base plan for this entire realm and apply to new self-registration organizations in this realm moving forward.',
                BASE_PLAN: 'Set as Base Plan',
                REVENERA_SUPPORTED: 'Revenera Supported',
                ACTIVE_SERVICE_CONTRACT: 'Active Service Contract',
                ENTITLEMENT_PLAN_LABEL: 'Entitlments Plan',
                FEATURES_LABEL: 'Features',
                DEVICEMODELS_LABEL: 'Device Models',
                SUBSCRIPTIONS_LABEL: 'Subscriptions',
                DEVICES_LABEL: 'Devices',
                REQUIRED_FIELDS: 'Fields marked with an asterik(*) are required',
                CHANGE_BASE_PLAN_CONFIRM:
                    'Select ‘Continue’ to set {{planName}} as the default tier one base plan or ‘Cancel’ to go back.',
                CHANGE_BASE_PLAN:
                    'This will override the default base plan and will set the {{planName}} plan as the new base plan for this entire realm. It will also apply to all new self-registration organizations in this moving forward.',
            },
            FEATURES_INCLUDED_IN_YOUR_ENTITLEMENT_PLAN: 'Features included in your entitlement plan.',
            AVAILABLE_FEATURES: 'Available Features',
            SELECTED_DEVICE_MODELS: 'Selected Device Models',
            DEVICES_SELECTED_AT_LEFT_WILL_APPEAR_HERE: 'Devices selected at left will appear here.',
        },
        FEATURE_PACKAGES: {
            FEATURES: 'FEATURES',
            NA: '#N/A',
            NAME_EXISTS_ERROR: 'This name is already in use',
            SUCCESS_MSG: {
                PLAN_CREATED: '{{planName}} has been created.',
                PLAN_UPDATED: '{{planName}} has been updated',
                PLAN_DELETED: '{{planName}} has been deleted',
                SUBSCRIPTION_CREATED: 'Subscription has been created.',
                SUBSCRIPTION_CREATED_V2: 'Subscription {{sequenceNumber}} has been created.',
                SUBSCRIPTION_UPDATED: 'Subscription has been updated.',
                SUBSCRIPTION_DELETED: 'Subscription has been deleted.',
                FEATURE_PACKAGE_CREATED: '<{{planName}}> has been created.',
                DEVICE_LICENSE_CREATED:
                    '{{deviceLicenseName}} has been Created. Select the back arrow to return to the Device License list.',
                DEVICE_LICENSE_UPDATED: '{{deviceLicenseName}} has been updated.',
                DEVICE_LICENSE_DELETED: '{{deviceLicenseName}} has been deleted.',
            },
            DEVICE_LICENSE: {
                FIELD_REQUIRED: 'Fields marked with an asterisk(*) are required.',
                START_END_DATES_COMMISSIONED: 'Start and End Dates will appear when the first device is commissioned.',
                SUBSCRIPTION_NOTES: 'Subscription Notes',
                DELETE_MODAL: {
                    HEADER: 'Delete Device License?',
                    DESCRIPTION: 'To continue deleting <{{deviceLicenseName}}> select the ‘Delete’ button.',
                },
            },
            CANCEL_MODAL: {
                DESCRIPTION:
                    'There are unsaved changes to the Entitlement plan. Select ‘Continue’ to close this entitlement plan without saving changes or select ‘Save Changes’ to save the changes before closing.',
                FEATURE_PACKAGE_DESCRIPTION:
                    'There are unsaved changes to the Feature Package. Select ‘Continue’ to close this feature package without saving changes or select ‘Save Changes’ to save the changes before closing.',
            },
            NO_FEATURE_PACKAGES: {
                NO_FEATURE_PACKAGE: 'No Feature Packages Found',
                ADD_PLAN_BTN: 'Add Feature Packages',
            },
            SUBSCRIPTION: {
                REPLACE_SUB_MODAL: {
                    HEADER: 'Only one subscription can be active',
                    BODY: 'Adding a new subscription will deactivate and replace the currently active subscription, {{currentSubscriptionName}}. Select ‘Next’ to apply the new subscription, {{newSubscriptionName}}, or select Go Back to return to the Device License Details view without making changes.',
                },
                ACTIVATE_SUBSCRIPTION: 'Activate Subscription',
                ACTIVATE_SUB_SUCCESS_MSG: 'Subscription for {{deviceLicenseName}} activated successfully.',
                ACTIVATE_SUB_FAILURE_MSG: 'Failed to activate subscription. Please try again later.',
                SUBSCRIPTION_START_COMMISSIONED_TEXT: 'Start subscription when the first device is commissioned',
                SUBSCRIPTIONS: 'Subscriptions',
                SUBSCRIPTION_NUMBER: 'Subscription #',
                DEVICE_LICENSES: 'Device Licenses',
                DEVICE_LICENSE_DETAILS_CUS_FAC: 'Devie License Details (Customer Facing)',
                MANAGE_SUB: 'Manage Subscriptions',
                VIEW_SUB: 'View Subscription',
                VIEW_DEV_LIC_SUB: 'Device Licenses & Subscriptions',
                MANAGE_DEV_LIC_SUB: 'Manage Device Licenses & Subscriptions',
                EDIT_SUB: 'Edit Subscription',
                ACTIVATE_LABEL: 'Activate Now',
                ADD_SUBSCRIPTION: 'Add Subscription',
                ADD_DEVICE_LICENSE: 'Add Device License',
                REVERNERA_ID: 'Revernera Account ID',
                DESCRIPTION: 'Description',
                EDIT_SUBSCRIPTION: 'Edit Subscription Details',
                FEATURE_PLAN: 'Feature Plan',
                DEVICE_LICENSE_NAME: 'Device License Name*',
                DEVICE_LICENSE_NAME_LABEL: 'Device License Name',
                FEATURE_PACKAGE: 'Feature Package',
                SUBSCRIPTION_START: 'Subscription Start Date',
                SUBSCRIPTION_END: 'Subscription End Date',
                DEVICE_COUNT: 'Device Count',
                ACTIVATION_ID: 'Activation ID',
                APPLY_ACTIVATION_ID: 'Apply Activation ID',
                ACTIVATION_MODAL: {
                    DESCRIPTION: 'Enter the Activation ID then select ‘Next’ to continue to device license selection.',
                },
                UNRECOGNIZED_ACTIVATION_ID: 'Activation ID is not recognized.',
                START_DATE: 'Start Date',
                END_DATE: 'End Date',
                DATE_RANGE: 'Date Range',
                LIMIT_DEVICE_MSG: 'Limit devices to specific count',
                SUBSCRIPTION_DETAILS: 'Subscription Details',
                SUBSCRIPTION_NOTES: 'Subscription Notes',
                DEVICE_LICENSE_DETAILS: 'Device License Details',
                DEVICE_LICENSE_DETAILS_CUSTOMER_FACING: 'Device License Details (Customer Facing)',
                NO_SUBSCRIPTION: 'No Subscriptions Found',
                NO_DEVICE_LICENSES: 'No Device Licenses Found',
                NO_DEVICE_LICENSES_BTN: 'Add Device License',
                DELETE_MODAL: {
                    HEADER: 'Delete Subscription?',
                    DESCRIPTION: 'Clicking ‘Delete’ will permanently delete this subscription.',
                },
                ACTIVATE_MODAL: {
                    HEADER: 'Save Your Changes',
                    DESCRIPTION:
                        'This action will expire your current plan and activate the new plan effective todays date. Are you sure you want to proceed?',
                },
                EFFECTIVE_STATUS: 'Effective Status',
                STATUS_UPCOMING: 'Upcoming',
                STATUS_ACTIVE: 'Active',
                STATUS_EXPIRED: 'Expired',
                TRIAL_FEATURE_PACKAGE: 'Trial Feature Package',
                NO_EXPIRATION: 'No Expiration',
                DEFERRED_START: 'Start on first device commission',
                SEQUENCE_NUMBER: 'Sequence #',
            },
            ASSOCIATE_ACTIVATION: {
                HEADER: 'Associate Activation ID',
                TITLE: 'Associate Activation ID with Device License',
                DESCRIPTION:
                    'To associate an activation ID, you can either assign it to an existing device license—thereby updating its current subscription—or create a new device license and assign the subscription during creation.',
                FILTERED_LIST_NOTE:
                    'The list of device licenses below is filtered to include only device licenses that are compatible with the new Activation ID. Device licenses that contain devices not supported by the entered activation ID are excluded from the list.',
                CREATE_NEW_DEVICE_LICENSE: 'Create a New Device License',
                CREATE_NEW_DEVICE_LICENSE_DESC:
                    'Create a new device license that will contain newly added devices, or choose an existing device license below to update its associated subscription.',
                EXPIRES: 'Expires',
            },
            ADD_REVERNERA_MODAL: {
                HEADER: 'Revernera Account ID#',
                WARN_HEADER: 'No Revernera Account ID# Associated',
                WARN_DESCRIPTION:
                    'A Revenera Account ID must first be associated with in order to associate a Revernera-enabled entitlement plan.',
                DESCRIPTION:
                    'A Revernera Account ID# is required when Revernera is enabled for a specific entitlement plan. Its purpose is to associate a subscription to the appropriate organization or realm’s Revernera Account.',
            },
            ADD_REVENERA_PART_NUMBER_MODAL: {
                HEADER: 'Revenera Part Number Required',
                DESCRIPTION: 'A valid Revenera part number is required when enabling Revenera for a feature package.',
                INPUT_HEADER: 'Revenera Part Number',
            },
            REVENERA_ACCOUNT_ID: 'Revernera Account ID',
            TITLE: 'Feature Packages',
            SELECT_FEATURES_LABEL: 'Select Features',
            CUSTOMIZE_ENTITLEMENT: 'Customize your Entitlement Plan by selecting features.',
            HELPER_TEXT: {
                REQUIRED: 'Required',
            },
            BTN: {
                CREATE_FEATURE_PACKAGE: 'Create Feature Package',
                ADD_FEATURE_PACKAGE: 'Add Feature Package',
                EDIT_FEATURE_PACKAGE: 'Edit Feature Package',
            },
            CLONE_MODAL: {
                HEADER: 'Clone Feature Package?',
                SUB_HEADER: 'Give your new Feature Package a name and description.',
            },
            ASSOCIATED_REALMS_AND_ORGS: {
                TITLE: 'Associated Realm & Orgs',
                HEADER: 'Associated Realms & Organizations',
                SUB_HEADER: 'View Realms and Organizations with {{realmName}} plan assigned.',
            },
            DELETE_MODAL: {
                HEADER: 'Delete Feature Package?',
                DESCRIPTION: 'Clicking ‘Delete’ will permanently delete this Feature package.',
            },
            DELETE_WARN_MODAL: {
                DESCRIPTION:
                    'There are realms and organizations associated with this Feature Package. They must be migrated to a different Feature Package before this package can be deleted.',
            },
            ADD_EDIT: {
                BASE_FEATURE_PACKAGE: 'Base Feature Package',
                SET_BASE_PLAN: 'Set as Base Plan?',
                SET_BASE_PLAN_MSG_1:
                    'Select ‘Continue’ to set {{planName}} as the default tier one base plan or ‘Cancel’ to go back. ',
                SET_BASE_PLAN_TITLE:
                    'This will override the current default base feature package and will set the {{planName}} feature package as the new base feature package for this entire realm and apply to new self-registration organizations in this realm moving forward.',
                BASE_PLAN: 'Set as Base Plan',
                REVENERA_SUPPORTED: 'Revenera Supported',
                REVENERA_PART_NUMBER: 'Revenera Part Number',
                REVENERA_PART_NUMBER_TOOLTIP:
                    'Part number cannot be changed or removed because this feature pack is already used by existing licenses.',
                REVENERA_PART_NUMBER_IN_USE_ERROR:
                    'Part number is already in use. End users will be unable to activate it.',
                ACTIVE_SERVICE_CONTRACT: 'Active Service Contract',
                FEATURE_PLAN_LABEL: 'Feature Plan',
                FEATURES_LABEL: 'Features',
                DEVICEMODELS_LABEL: 'Device Models',
                SUBSCRIPTIONS_LABEL: 'Subscriptions',
                DEVICES_LABEL: 'Devices',
                REQUIRED_FIELDS: 'Fields marked with an asterik(*) are required',
                CHANGE_BASE_PLAN_CONFIRM:
                    'Select ‘Continue’ to set {{planName}} as the default tier one base plan or ‘Cancel’ to go back.',
                CHANGE_BASE_PLAN:
                    'This will override the default base plan and will set the {{planName}} plan as the new base plan for this entire realm. It will also apply to all new self-registration organizations in this moving forward.',
                SET_A_DURATION: 'Set A Duration',
                DURATION_TOOLTIP: 'Sets the duration length for a subscription. It will not expire when disabled.',
                DURATION_MONTHS: 'Duration (Months)',
                DURATION_HELPER: 'Enter a value between 1 and 360 months.',
                LIMIT_DEVICE_COUNT: 'Limit the Number of Devices On A Subscription',
                DEVICE_LIMIT_TOOLTIP: 'Sets the maximum number of devices that can be commissioned for a subscription.',
                DEVICE_LIMIT_LABEL: 'Device Limit',
                ADD_TRIAL_FEATURE_PACKAGE: 'Add trial feature package',
                TRIAL_FEATURE_PACKAGE_TOOLTIP: 'Enables selecting a trial feature pack.',
                LOADING_TRIAL_FEATURE_PACKAGES: 'Loading Trial Feature Packages, Please Wait',
                SELECT_TRIAL_FEATURE_PACKAGE: 'Select Trial Feature Package',
                MONTHS: 'months',
                DEVICE_LIMIT_INDICATOR: '{{count}} devices',
                REVENERA_TOOLTIP: 'Enables Revenera Support.',
                ACTIVE_SERVICE_TOOLTIP: 'Adds a service contract to this feature pack.',
                SET_AS_BASE_PLAN_TOOLTIP: 'Sets as the default feature pack. Will not impact existing subscriptions.',
                REQUIRES_SETTING_A_DURATION: 'Requires setting a duration',
            },
            FEATURES_INCLUDED_IN_YOUR_ENTITLEMENT_PLAN: 'Features included in your feature plan.',
            AVAILABLE_FEATURES: 'Available Features',
            SELECTED_DEVICE_MODELS: 'Selected Device Models',
            DEVICES_SELECTED_AT_LEFT_WILL_APPEAR_HERE: 'Devices selected at left will appear here.',
            CONTINUE_BTN: {
                ALERT_MSG: 'Changes to {{planName}} have not been saved.',
            },
        },
        LOADS: {
            CYCLE: 'Cycle',
            LOAD_NAME: 'Load Name',
            TURN_ON: 'Turn On',
            TURN_OFF: 'Turn Off',
            LOAD_OFF: 'Turn Load Off ?',
            LOAD_ON: 'Turn Load On ?',
            TYPE_OF_LOAD: 'Type of Load *',
            LOAD_DETAILS: 'Load Details',
            LOAD_TREND_CURRENT: 'Current',
            LOAD_TREND_ASSETS: 'Assets',
            WOULD_YOU_LIKE_TO: 'Would you like to',
            LOAD_IS_TURNING_OFF: 'Load is turning off',
            LOAD_IS_TURNING_ON: 'Load is turning on',
            LOAD_TURN_ON_COMPLETED: 'Load Turn On Completed',
            LOAD_TURN_OFF_COMPLETED: 'Load Turn Off Completed',
            TURNING_OFF_LOAD: 'Turning Off Load',
            TURNING_ON_LOAD: 'Turning On Load',
            ADD_LOADS: 'Add Loads',
        },
        TRENDS: {
            MSG: {
                DOWNLOAD_MSG: 'File downloaded',
                EMAIL_SUCCESS: 'Email Sent Successfully',
            },
            ADVANCED_EXPORT: {
                NULL_DATA_LABEL: 'Data is null',
                EXPORT_METHOD: 'Export Method',
                SELECT_CHANNELS_EXPORT: 'Select Channels to export data.',
                SELECTED_COUNT: 'Selected Channels ({{count}})',
                CHOOSE_CHANNELS: 'Choose Channels',
                CHOOSE_TIME: 'Choose time range',
                RECIPIENTS_COUNT: 'Recipients {{count}}',
                CHOOSE_EXPORT_METHOD: 'Choose an Export Methods',
                CHOOSE_EXPORT_METHOD_DESCRIPTION: 'Select one or more methods to export data.',
                SELECT_DAYS: 'Select the amount of days to export data.',
                SUMMARY_EXPORT_DATA: 'Summary Export Data',
                REVIWE_DATA: 'Review and confirm the data summary to exporting.',
                DATA_RANGE: 'Data Range',
                CHANNEL_COUNT: 'Channels {{count}}',
                ADVANCE: 'Advanced ..',
                SELECT_ONE_OR_MORE_METHOD_TO_EXPORT_DATA: 'Select one or more method to export data.',
                MINIMUM_NUMBER_OF_CHANNELS_SELECTED: 'Minimum Number of Channels Selected',
                MAXIMUM_NUMBER_OF_CHANNELS_SELECTED: 'Maximum Number of Channels Selected',
                ADVANCE_EXPORT_EXPORTING: 'exporting',
                ADVANCE_EXPORT_READY_TO_DOWNLOAD: 'Ready to download',
                NO_CHANNELS_AVAILABLE: 'No Channels Available',
                SELECT_FROM_THE_CHANNELS_LIST: 'Select from the Channels list.',
            },
            ADVANCE_EXPORT_EXPORTING: 'exporting',
        },
        DASHBOARD_MANAGEMENT: {
            SELECT_DASHBOARD: 'Select Dashboard',
            EDIT_DASHBOARD: 'Edit Dashboard',
            SUMMARY: {},
            DETAILS_HEADING: 'Details',
            DEVICE_DETAILS_HEADING: 'Device Details',
            TIME_EVENT_CLEARED: 'Time Event Cleared',
            TIME_OF_EVENT: 'Time of Event',
            EVENT_NAME: 'Event Name',
            NO_COMPONENT: 'No Component Found',
            NO_PROPERTIES: 'No Properties Available',
            NO_TIMELINE_FOUND: 'No Timeline Found',
            NO_TRENDS_AVAILABLE: 'No Trends Data Available',
            NO_DOCUMENTS_AVAILABLE: 'No Documents Available',
            ACKNOWLEDGEMENT_DETAILS: 'Acknowledgement Details',
            EVENT_DETAILS: 'Event Details',
            HISTORY: 'History',
            COLLAPSE_ALL: 'Collapse All',
            EXPAND_ALL: 'Expand All',
            SELECTED_DATE: 'Selected Date',
            LAST_UPDATE: 'Last Update Received',
            SET_THRESHOLD: 'Set {{thresholdValue}} thresholds values.',
            ALARM_INFORMATION_HEADING:
                'Use this field to give context or add more information about the alarm, in order to acknowledge it.',
            ALARM_INFORMATION_SUBHEADING:
                'Later on it will be possible to see all notes left by every operator on the dedicated alarm page.',
            EDIT_VIRTUAL_LOAD: 'Edit Virtual Load',
            DELETE_VIRTUAL_LOAD: 'Delete Virtual Load',
            VIEW_MORE: 'View More',
            MONTHLY_REPORTS: 'Monthly Reports',
            SERVICE_REQUEST_LABEL: 'Service is recommended within 180 days to avoid UPS downtime.',
            NO_WIDGETS_SUBTITLE: 'Widgets let you monitor, interact with and manage groups and devices.',
            MAXIMUM_25_WIDGETS_CAN_BE_DROPPED: 'Maximum 25 widgets can be dropped on a dashboard.',
            DASHBOARD_NAME: 'Dashboard Name',
            KILOWATTS_PER_HOUR: '(kWh) Kilowatts per hour',
            WATTS: '(W) Watts',
            EXPORT_AGGREGATED_TRENDS: 'Export Aggregated Trends',
            CHOOSE_FILE_TYPE: 'Choose file type',
            UPCOMING_EVENTS:
                'Upcoming events are things that may happen in the future. This includes predictions, scheduled service, and more.',
            ADD_SCHEDULE: 'Add Schedule',
            SEVEN_DAYS: '7 Days',
            UPDATE_DASHBOARD_MSG: '{{name}} has been saved.',
            DESCRIPTION_DEVICE_CAN_BE_ANYTHING: 'Description of device can be anything',
            ACKNOWLEDGED_BY: 'Acknowledged by',
            ACKNOWLEDGE_ALARM: 'Acknowledge alarm',
            USE_THIS_FIELD_TO_GIVE_CONTEXT:
                'Use this field to give context or add more information about the alarm, in order to acknowledge it.',
            SEE_ALL_NOTES_LEFT_BY_EVERY_OPERATOR:
                'Later on it will be possible to see all notes left by every operator on the dedicated alarm page.',
        },
        NFC: {
            EDIT_CONFIGURATION: 'Edit Configuration Profile',
            SAVE_CONFIGURATION: 'Save Configuration Profile',
            SAVE_AND_ADD_NEW_CONFIGURATION: 'Save as New Configuration Profile',
        },
        CHANNEL_MANAGEMENT: {
            APPLY_CHANNEL_PROFILE_TO_THIS_DEVICE: 'Apply Channel Profile To This Device',
            SAVE_CHANNEL_PROFILE: 'Save Channel Profile',
            DEVICE_LIST_FEATURE_DATA: 'Device List Feature Data',
            SAVE_CHANGES: 'Changes to the device profile have been saved; it may take a few seconds to reflect.',
            DISPLAY_NAME: 'Display Name',
            DESCRIPTION: 'Description',
            CADENCE: 'Cadence',
            CLOSE_MANAGER: 'Close Manager',
            CHANNEL_PROFILE_NAME: '{{saveChannelProfileName}} has been successfully saved.',
            CHANNEL_SELECTOR: 'Channel Manager',
            CHANNEL_DESCRIPTION: 'Select the channels to be available in the application ',
            CHANNEL_DESCRIPTION_DISABLING:
                ' Disabling channels that are currently in use may impact existing widgets & other UI components.',
            NO_CHANNEL_FOUND: 'No Channel found',
            CLOSE_DESCRIPTION:
                'Select `Close Manager` to exit the Channel Manager without saving changes or `Cancel` to save changes before exiting.',
            SAVE_DEVICE_CHANNEL_PROFILE: 'Save Device Channel Profile',
            SAVE_DESCRIPTION:
                'Give this device channel profile a name and select `Save` to save it to the device channel library for use with other devices.',
            DISPLAY_NAMES: '{{changeDisplayName}} has been successfully Updated.',
            EDIT_CHANNEL: 'Edit Channel',
            APPLY_MODAL: '{{matchChannelProfildId}} has been successfully applied.',
            PROFILE_NAME: 'Profile Name',
            MODAL: 'Modal',
            APPLY_PROFILE: 'Apply Profile',
            APPLY_PROFILE_DESCRIPTION:
                'Select the device channel profile to associate with this device. It will replace the current device channel profile.',
            NO_PROFILE_FOUND: 'No Profile Found',
        },
        CHANNEL_LIBRARY: {
            IMPORT_DEVICE_BTN: 'Import Device',
            PROFILE_NAME: 'Profile Name',
            MANUFACTURER: 'Manufacturer',
            APPLY_CHANNEL_PROFILE: 'Apply Channel Profile',
            CLONE_CHANNEL_PROFILE: 'Clone Channel Profile',
            RENAME_MODAL: {
                SUCCESS_MSG: '{{profileName}} has been renamed.',
                HEADER: 'Rename Profile',
            },
            CLONE_MODAL: {
                SUCCESS_MSG: 'Profile cloned successfully.',
                HEADER: 'Clone Profile',
                INSTRUCTION_TEXT: 'Give the new profile a name.',
            },
            DELETE_MODAL: {
                SUCCESS_MSG: 'Profile has been successfully deleted.',
                HEADER: 'Delete Device Profile?',
                WARN_TEXT:
                    '{{profileName}} will be deleted permanently.  To proceed select the ‘Delete’ button or cancel to return to the previous screen.  ',
                DELETE_PROFILE_BTN: 'Delete Profile',
            },
            IMPORT_DEVICE_MODAL: {
                HEADER: 'Import Device Profile',
                INSTRUCTION_TEXT:
                    'Select the device whose channel selections you would like to save as a device channel profile.',
                SAVE_NEW_PROFILE_HEADER: 'Name Device Profile',
                SUCCESS_MSG: 'Profile has been saved successfully.',
            },
            APPLY_PROFILE_MODAL: {
                HEADER: 'Apply Profile',
                INSTRUCTION_TEXT:
                    'Select the devices to apply the {{profileName}} profile to. This will replace the current channel selections.',
                SUCCESS_MSG: 'Profile has been applied to {{count}} devices.',
            },
            NO_CHANNEL_PROFILE_FOUND: 'No Channel Profile Found',
        },
        ICON_MANAGEMENT: {
            ICONS: 'Icons',
            ICON: 'Icon',
            CHANNEL: 'Channel',
            KEY: 'Key',
            SELECT_ICON: 'Select Icon',
            CHANNEL_DETAILS: 'Channel Details',
            REMOVE_ICON_BTN: 'Remove Icon',
            NO_CHANNEL_MSG: 'No Channels Found',
            TAB_CHANNEL_ICON: 'Channel Icons',
            TAB_ICON_LIB: 'Icon Library',
            EXTERNAL_LIB: 'External Library',
            IMPORT_FILE_MSG: 'Icon files must be a single color .svg',
            IMPORT_WAIT_MSG: 'Please wait while the icon imported.',
            SELECT_ICON_LIB: 'Select Icon Library',
            ICON_DETAILS: 'Icon Details',
            EXTERNAL_DETAILS: 'External Details',
            IMPORT_FROM_LIB: 'Import From an Existing Library',
            UPLOAD_ICON: 'Upload Icon',
            IMPORT_ICON: 'Import Icon',
            IMPORTING_ICON: 'Importing Icon',
            DELETE_ICON: 'Delete Icon',
            DELETE_TITLE: 'Delete {{icon}}?',
            DELETE_BTN_TITLE: 'Delete Icon',
            UPDATED_ICON_MSG: '{{icon}} icon has been successfully updated.',
            ADDED_ICON_MSG: '{{icon}} icon has been successfully added to the icon library.',
            DELETED_ICON_MSG: '{{icon}} icon has been successfully deleted from the icon library.',
            DELETE_USED_ICON_MSG:
                'Select ‘Continue’ to permanently delete {{icon}}. This will permanently remove it from the icon library and all associated channels.',
            DELETE_ICON_MSG:
                'Select ‘Continue’ to permanently delete {{icon}}. This will permanently remove it from the icon library.',
            DELETE_ICON_LENGTH_MSG:
                'This icon is currently used on and will be removed from the {{length}} devices below.',
            DELETE_CONFIRM_MSG:
                'The icon {{icon}} will be permanently deleted and removed from all associated channels. This cannot be undone.',
            CHANNEL_UPDATED_MSG: 'Channel Data has been successfully updated.',
            VISIT_LIB: 'Visit the {{lib}}',
            LIB_MSG: 'Insert the icon name from the {{lib}}',
            INSERT_ICON_NAME: 'Insert Icon Name',
            UPLOAD_ERROR: 'Upload Error',
            UPLOAD_ERROR_TEXT: 'File Size Exceeds 10kb',
            UPLOAD_ERROR_TEXT_TYPE: 'Incorrect File Type',
            CORRUPT_FILE_ERROR: 'Image file is corrupt',
            ERROR_ICON_NAME: 'Image could not be found in the selected library',
        },
        CHART: {
            NO_CHARTS_DATA_AVAILABLE: 'No Charts Data Available',
            EXPORT_CHART: 'Export Chart',
        },
        NEW_WIDGET_MODAL: {
            IS_THIS_A_SYSTEM_OR_USER_WIDGET: 'Is this a System or User widget?',
            SYSTEM_WIDGET: 'System Widget;',
            USER_WIDGET: 'User Widget;',
            PRIVATE_DISPLAYED_ONLY_TO_YOU: 'Private, displayed only to you;',
        },
        EDIT_USER_PROFILE: {
            REMOVE_ASSIGMENT_MODAL:
                'A user must have at least one assignment to remain in the system. Please deselect one assignment to continue. To remove the user from the system go back to the user list and select Remove User from the pulldown.',
        },
        FULL_MAP: {
            LOCATION_LABEL: 'Location or GPS Coordinates',
        },
        GROUP_HIERARCHY: {
            HIDE_THIS_PANEL: 'Hide This Panel',
        },
        MANAGE_CUSTOM_URL: {
            INVALID_FILE_FORMAT: 'Invalid file format.',
            THE_URL_USERS_WILL_ACCESS: 'The URL users will access',
        },
        MANAGE_ORGANIZATION: {
            ORGANIZATION_LEFT_SUCCESSFULLY: 'Organization left successfully.',
            CHANGES_TO_ORGANIZATION_SAVED: 'Changes to the organization name have been saved.',
            SELECT_ORGANIZATION: 'Select Organization',
        },
        MULTI_TRENDS: {
            TWENTY_FOUR_HOURS: '24 Hours',
            FIFTEEN_DAYS: '15 Days',
            THIRTY_ONE_DAYS: '31 Days',
            MAXIMUM_LIMIT_OF_10_CHANNELS_REACHED: 'Maximum limit of 10 channels reached.',
            AT_LIST_ONE_CHANNEL_MUST_BE_SELECTED: 'At least one channel must be selected.',
            NUMBER_OF_CHANNELS_SELECTED: 'number of Channels Selected',
            EXPORT_TRENDS: 'Export Trends',
            AREA_CHART: 'Area Chart',
            LINE_CHART: 'Line Chart',
            EXPORT_LOAD_GROUP_TRENDS: 'Export Load Group Trends',
            TIME_RANGE_APPLIED: 'Time Range Applied',
        },
        NOTIFICATION: {
            DELETE_NOTIFICATIONS: 'Delete Notifications',
            DELETE_NOTIFICATION: 'Delete Notification',
            SECURITY_DESK_NOTIFICATION: 'e.g. Overload Notification, Security Desk Notifications',
            CUSTOM_NOTIFICATION_NAME: 'Custom Notification Name',
            PUSH_NOTIFICATIONS_DISABLED:
                'This Setting may not apply to users that have Push Notifications disabled, or Emergency Contacts',
            NOTIFICATION_SENT: 'Notification sent',
            WILL_NOTIFY: 'will notify',
            WHEN_ACTIVE_AND_CLEARED: 'when active and when cleared.',
            NOTIFICATION_DELETE_DESC_ONE:
                'Selecting Delete will permanently remove {{count}} notifications from the system. This cannot be undone.',
            NOTIFICATION_DELETE_DESC_TWO:
                'Selecting Delete will permanently remove this notification from the system. This cannot be undone.',
            NOTIFICATION_MODEL_SUB_HEADER:
                'Choose the device type(s) or model(s) you want to configure an automated action.',
            NOTIFICATION_EVENTS_SUB_HEADER: 'Choose which events will trigger the notification.',
            NOTIFICATION_GROUPS_SUB_HEAER:
                'Choose on which device(s) the automated action is to apply. If a group is selected, then the action selected will apply to each device of the specified device type located in that group.',
            NOTIFICATION_USERS_SUB_HEADER: 'Choose the users to be notified.',
        },
        PREFERENCES: {
            RESET_NOTIFICATION_PREFERENCES:
                'Are you sure you want to reset your notification preferences? This does not apply to Custom Notifications.',
            NOTIFICATION_PREFERENCES_RESET_SUCCESSFULLY: 'Notification preferences reset successfully.',
        },
        VIRTUAL_LOAD: {
            WIDGET_TYPE_NOT_SUPPORTED: 'This widget type does not support selected group or device.',
            THIS_WIDGET_TYPE_NOT_CONFIGURED: 'This widget type is not configured.',
            VIRTUAL_LOAD_UPDATED_SUCCESSFULLY: 'Virtual Load Updated Successfully.',
        },
        REALM_MANAGEMENT: {
            SELECT_CHANNELS: 'Select Channels',
            DEVICE_FEATURE_CHANNELS: 'Device Feature Channels',
            CHANNELS_SPECIFIC_LIVE_DATA_IN_DEVICE_LIST:
                'Select up to three channels to feature as device specific live data in the device list',
            FEATURED_CHANNELS: 'Featured Channels',
        },
        SCHEDULING: {
            REPEAT_EVERY: 'Repeat Every',
            SET_SCHEDULE_DETAILS: 'Set Schedule Details',
            CHOOSE_FREQUENCY: 'choose frequency',
            REPEAT_ON_DAY: 'Repeat On Day',
            OF_EVERY: 'of Every',
            HOLIDAY: 'Holiday',
            YEAR: 'Year',
            SELECT_YEAR: 'Select Date',
            REPEAT_FOREVER: 'Repeat Forever',
            REPEAT_UNTIL: 'Repeat Until',
            SELECT_TIMEZONE: 'Select Timezone',
            SET_ACTION_DETAILS: 'Set Action Details',
            SETUP_SCHEDULE_EVENT: 'Add actions and configure their details to set up your scheduled event.',
            DEFAULT_VALUE_WHEN_ACTION_TIMES_OUT:
                'Set an End Time, returns the setting to the device’s default value when the action times out.',
            VALUE_TO_SET_AT_END_TIME: 'Value to set at end time',
            OVERRIDE_DEFAULT_AND_SET_TO_CUSTOM_VALUE_AT_TIMEOUT: 'Override default and set to custom value at timeout.',
            REMOVE_ACTION: 'Remove Action?',
            REMOVE_SCHEDULE_EVENT:
                'Selecting ‘Remove’ will remove this action from this schedule event. Or, select ‘Cancel’ To return to the previous window.',
            SELECT_ASSETS: 'Select Asset(s)',
            ASSET_TYPE: 'Asset Type',
            SELECT_AVAILABLE_ASSET_TYPE: 'Select asset type(s) to narrow down the list of available assets.',
            SELECT_ASSET_TYPE: 'Select Asset Type',
            APPLY_TO_INDIVIDUAL_ASSETS: 'Apply to individual assets',
            WHEN_SWITCH_IS_ENABLED:
                'When switch is enabled, the schedule applies to individual devices. When disabled, it applies at the group level and any compatible devices added in the future will automatically have the schedule applied to it.',
            SELECT_ASSET_TYPE_FROM_LEFT_COLUMN: 'Select Asset Type from the left column',
            SELECT_DEVICE_TYPE_FROM_LEFT_COLUMN: 'Select Device Type from the left column',
            OVERLAPPING_SCHEDULES: 'Overlapping Schedules',
            ONE_OR_MORE_DEVICES_ASSOCIATED_WITH_SCHEDULED_ACTION:
                'One or more of the devices associated with this scheduled action possess overlapping schedules. Go back and either change the scheduled time or remove the devices with conflicting scheduled actions.',
            CONFLICTING_DEVICES: 'Conflicting Devices',
            VALUE_TO_SET_AT_START_TIME: 'Value to set at startTime',
            DEVICE_DEFAULT_VALUE_WHEN_ACTION_TIME_OUT:
                'Set an End Time, returns the setting to the device’s default value when the action times out.',
            SELECTED_DAYS: 'Selected Days',
            THE_SCHEDULED_ACTION_WILL_BE_SKIPPED_ON_THESE_DAYS: 'The scheduled action will be skipped on these days.',
            EXCEPTIONS_HELP_YOU_PLAN_FOR_THE_EVENTS:
                'Exceptions help you plan for the events that are outside of your normal operational needs.',
            SELECT_EXCEPTION: 'Select Exception',
            HOLIDAY_LIST: 'Holiday List',
            SELECT_COUNTRY: 'Select Country',
            CHOOSE_SCHEDULE_NAME: 'Choose Schedule Name',
            SCHEDULE_HAS_BEEN_UPDATED: 'Schedule has been updated.',
            SCHEDULE_HAS_BEEN_ADDED: 'Schedule has been added.',
            CHOOSE_ALL_EVENTS:
                'Choose “All Events” to turn off this scheduled event permanently or “Next Schedule” to disable only the next scheduled action event.',
            NEXT_SCHEDULE: 'Next Schedule',
            SCHEDULE_DELETED_SUCCESSFULLY: 'Schedule(s) deleted successfully.',
            DELETE_SCHEDULE: 'Delete Schedule',
            LAST_RUN: 'Last Run',
            NO_SCHEDULE_ACTIONS: 'No Scheduled Actions',
            ADD_SCHEDULE_ACTIONS: 'Choose “Add Schedule” to Schedule actions.',
            DELETE_SCHEDULES_ACTION: 'Delete Schedule(s) Action?',
            THE_SCHEDULE_WILL_BE_PERMANENTLY_DELETED:
                'The schedule(s) will be permanently deleted. This cannot be undone.',
            SCHEDULE: 'Schedule',
            RETURN_TO_DEVICES_DEFAULT:
                'Set an End Time, returns the setting to the device’s default value when the action times out.',
            SCHEDULE_UPDATED_SUCCESSFULLY: 'Schedule updated successfully!',
            SCHEDULE_CREATED_SUCCESSFULLY: 'Schedule created successfully!',
            SCHEDULE_DESCRIPTION:
                'One or more of the devices associated with this scheduled action possess overlapping schedules. Go back and either change the scheduled time or remove the devices with conflicting scheduled actions.',
            MORE_CONFLICTING_DEVICES: 'more conflicting devices.',
            APPLY_TO_INDIVIDUAL_DEVICES: 'Apply to individual devices',
            DELECT_DEVICE_TYPES_TO_NARROW_THE_LIST: 'Select asset type(s) to narrow down the list of available assets.',
            SCHEDULES_DELETED_SUCCESSFULLY: 'Schedule(s) Deleted Successfully!',
            NEXT_SCHEDULE_DISABLED_SUCCESSFULLY: 'Next Schedule Disabled Successfully!',
            ALL_EVENTS_DISABLED_SUCCESSFULLY: 'All Events Disabled Successfully!',
            CALENDAR: 'Calendar',
            VIEW_ALL_DEVICES_ACTION_AND_EXCEPTIONS_FOR_A_SCHEDULE_EVENT_PART_ONE:
                'View all device(s) action and exceptions for a scheduled event.',
            VIEW_ALL_DEVICES_ACTION_AND_EXCEPTIONS_FOR_A_SCHEDULE_EVENT_PART_TWO:
                'Choose “Close” to exit or “Edit” to modify the scheduled event.',
            SCHEDULE_ENABLED_SUCCESSFULLY: 'Schedule Enabled Successfully!',
            NO_SCHEDULERS: 'No Schedulers',
            ADD_SCHEDULE: 'Add Schedule',
            THIS_DEVICE_TYPE_DOES_NOT_SUPPORT_LOADS: 'This Device Type does not support Loads',
            NO_LOADS_DATA_AVAILABLE: 'No Loads Data Available',
            MONTHS_JAN: 'January',
            MONTHS_FEB: 'Febraury',
            MONTHS_MAR: 'March',
            MONTHS_APR: 'April',
            MONTHS_MAY: 'May',
            MONTHS_JUNE: 'June',
            MONTHS_JULY: 'July',
            MONTHS_AUG: 'August',
            MONTHS_SEP: 'September',
            MONTHS_OCT: 'October',
            MONTHS_NOV: 'November',
            MONTHS_DEC: 'December',
            SCHEDULE_EVENT: 'Schedule Event',
            ONCE: 'Once',
            DAILY: 'Daily',
            WEEKLY: 'Weekly',
            MONTHLY: 'Monthly',
            YEARLY: 'Yearly',
            ALL: 'All',
            FIRST: 'First',
            SECOND: 'Second',
            THIRD: 'Third',
            FOURTH: 'Fourth',
            LAST: 'Last',
            FROM: 'From',
            RUN_AT: 'Run At',
            SELECT: 'Select',
            TYPES_TO_NARROW_DOWN: 'type(s) to narrow down the list of available',
            APPLY_TO_INDIVIDUAL: 'Apply to individual',
            TYPE_FROM_LEFT_COLUMN: 'Type from the left column.',
            ON: 'On',
            DISABLE_SCHEDULE: 'Disable Schedule',
            SKIPPED_NEXT_SCHEDULE: 'Skipped next schedule.',
            DISABLE: 'DISABLE',
            ENABLE: 'ENABLE',
            SUCCESSFULLY: 'successfully.',
            DATE_RANGE: 'Date Range',
        },
        SERVICE_CONTACT_LIST: {
            SERVICE_CONTACTS: 'Service Contacts',
            SERVICE_CONTACTS_AND_USERS: 'Service Contacts & Users',
            MANAGE_SERVICE_CONTACTS: 'Manage Service Contacts',
            SELECT_GROUP_OR_DEVICE: 'Select Group or Device',
            SELECT_GROUP_OR_DEVICE_DESCRIPTION:
                'Select the Group to manage its service contacts. This defaults to the Group where the current service contacts are managed.',
            SERVICE_CONTACT_SELECTIONS_DESCRIPTION:
                'Service contact selections default to the organization and propagate downwards. However, if service contact choices are made to a group they override the organization choices and if service contracts are added to a device they override the device’s group service contacts choices.',
            PRIORITIZE_THE_SELECTED_CONTACTS:
                'Prioritize the selected contacts by dragging them into the order they should be contacted from top (first to contact) to bottom (last to contact).',
            PREFERENCES: 'Preference',
            ADD_USER: 'Add User',
            EDIT_SERVICE_CONTACTS: 'Edit Service Contacts',
            VIEW_MANAGE_USERS: 'View & Manage User(s)',
            CONTACT_PRIORITY: 'Contact Priority',
            VIEW_ALL_USERS: 'View All Users',
        },
        SETTINGS: {
            SETTINGS_UPDATED_SUCCESSFULLY: 'Settings updated successfully',
        },
        WIDGET_MANAGEMENT: {
            NO_DEVICE_FOR_THE_SELECTED_SOURCE_EXISTS: 'No Device For The Selected Source Exists',
            WIDGETS_DATASOURCE_HAS_BEEN_CHANGED: 'The Widget’s datasource has been changed. Would you like to:',
            SAVE_AS_A_NEW_WIDGET_WITH_A_NEW_NAME: 'Save as a new widget with a new name.',
            OVER_RIGHT_THE_EXISTING_WIDGET: 'Overwrite the existing widget.',
            IS_THIS_A_SYSTEM_OR_USER_WIDGET: 'Is this a System or User widget?',
            WIDGET_NAME: 'Widget Name',
            SELECT_CONTROLS: 'Select Controls',
            SELECT_LOADS: 'Selected Loads',
            SELECT_CONTROLS_THAT_YOU_WOULD_LIKE_TO_VIEW_IN_THE_WIDGET:
                'Select Controls that you would like to view in the widget.',
            SELECT_ASSETS: 'Select Assets',
            LAST_UPDATED: 'Last Updated:',
            COMMAND_NAME: 'Command Name',
            PINNED_DASHBOARD: 'This set of controls will appear pinned at the top of the dashboard.',
            PIN_CONTROLS_TO_TOP_OF_DASHBOARD: 'Pin controls to top of dashboard',
            DISPLAY_TITLE_BAR: 'Display title bar',
            NUMBER_OF_UPCOMINGS_TO_DISPLAY: 'Number of upcomings to display',
            DISPLAY_TIME_PERIOD: 'Display time period',
            DEFAULT_TIME_PERIOD: 'Default time period',
            MAXIMUM_NUMBER_OF_ASSET_TYPE_TO_DISPLAY: 'Maximum number of asset types to display',
            ASSETS_TYPE_TO_DISPLAY: 'Assets Types to display',
            SELECT_ASSET_TO_DISPLAY_ON_WIDGET: 'Select assets to display on widget and detailed view chart.',
            SELECTED_ASSETS_TYPES: 'selected assets types',
            NUMBER_OF_DEVICES_TO_DISPLAY: 'Number of devices to display',
            MAXIMUM_NUMBER_OF_DEVICES_TO_DISPLAY_IN_WIDGET: 'Maximum number of devices to display in widget',
            DISPLAY_TOTAL_COUNT_OF_ASSETS_TYPE_CATEGORIES: 'Display total count of assets types categories',
            SELECT_UP_TO_SEVEN_PRIMARY_ASSET_TYPES_TO_DISPLAY_ON_WIDGET:
                'Select up to seven primary asset types to display on widget. Secondary assets selection will be displayed as other.',
            PIN_MAP_ON_DASHBOARD: 'Pin map on dashboard',
            DISPLAY_VIEW_FULL_MAP_BAR: 'Display “View Full Map” bar',
            DISPLAY_PIN_LABELS: 'Display Pin Labels',
            DISPLAY_TOUCH_TOOLTIPS_MOBILE: 'Display Touch Tooltips on Mobile',
            ALARM_TYPES_TO_DISPLAY: 'Alarm types to display',
            MAXIMUM_NUMBER_OF_ROWS_TO_DISPLAY: 'Maximum number of rows to display',
            RELATIVE_VIRTUAL_LOADS_CAN_ONLY_MANAGED_IN_THE_LIVE_DASHBOARD_WIDGET:
                'Relative virtual loads can only managed in the live dashboard widget.',
            HIGHEST_TO_LOWEST_CONSUMING_CATEGORY: 'Display from highest to lowest consuming category',
            WIDGET_CLONED_SUCCESSFULLY: 'Widget cloned successfully.',
            SAVE_WIDGET: 'Save Widget',
            REQUIRE_ACTION_CONFIRMATION_AFTER_PRESS: 'Require action confirmation after press',
            BUTTON_COLOR: 'Button Color',
            CMD_BAR_CONFIRM_TEXT: 'to continue or `Cancel` to go back',
            SELECT: 'Select',
            VALID_VALUE: 'Valid value is between 0 to 43200',
            ENTER_VALUE_TEXT: 'Enter the delay time.',
            DELAY_TIME: 'Delay time*',
            APPLY: 'Apply',
            ACCESS_DENIED: 'Access denied for this resource.',
            SELECT_ACTION: 'Select Action',
        },
        DEVICE_DETAILS: {
            SET_THRESHOLDS_VALUES: 'Set thresholds values.',
        },
        ALARM_DETAILS: {
            USERNAME: 'Username',
            DESCRIPTION_TITLE: 'Description',
            CLEAR_EVENT_BUTTON: 'Clear Event',
            ACKNOWLEDGE_BUTTON: 'Acknowledge',
            ADD_COMMENT_BUTTON: 'Add Comment',
            CUSTOMER_CONTACT: 'Customer Contact',
            EATON_SERVICE_PORTAL_REPRESENTATIVE: 'Eaton Service Portal Representative',
            EATON_REPRESENTATIVE: 'Eaton Representative',
            CONTACT_MADE_WITH_CUSTOMER_TECH: 'Contact Made with Customer/Tech',
            ACTION_TAKEN: 'Action Taken',
            CUSTOMER_CALL_PREFERENCE: 'Customer Call Preference',
            COMMENT_CATEGORY_ALARM: 'Alarm',
            COMMENT_CATEGORY_UPCOMING: 'Upcoming',
            COMMENT_CATEGORY_GENERAL: 'General',
            COMMENT_CATEGORY_LOST_COMMUNICATION: 'Lost Communication',
            LOADING_COMMENTS_MSG: 'Loading comments...',
            NO_COMMENTS_FOUND_MSG: 'No comments found',
            VIEW_ALL_COMMENTS_LABEL: 'View All Comments',
            COMMENT: 'Comment',
            COMMENT_REQUIRED_MSG: 'Please enter a comment',
            COMMENT_MIN_LENGTH_MSG: 'Please enter at least {{minLength}} characters',
            ALARM_TAB_TITLE: 'Alarm Details',
            ALARM_COMMENTS_TAB_TITLE: 'Comments',
            DEVICE_DETAILS: 'Device Details',
            DEVICE_NAME: 'Device Name',
            LOADING: 'Loading...',
            MORE_DETAILS_TITLE: 'More Details',
            MORE_DETAILS_CONTENT:
                'The device has an internal fault condition. Recommended action: Service or replace the device.',
            END_TIME: 'End Time',
            START_TIME: 'Start Time',
            ACKNOWLEDGE: 'Acknowledge',
            NOTIFICATION: 'Notification',
            SEVERITY: 'Severity',
            EVENT_NAME: 'Event Name',
            EVENT_DETAILS: 'Event Details',
            MODEL: 'Model',
            CTO: 'CTO',
            ORGANIZATION: 'Organization',
            SERIAL_NUMBER: 'Serial Number',
            SITE: 'Installed Address',
            LOCATION: 'Location',
            START_END: 'Start-End',
            CLEAR_ALARM: 'Clear Alarm',
            ALARM_CLEARED_MSG: 'Alarm has been Cleared',
            ALARM_FAILED_CLEARED_MSG: 'Failed to clear Alarm',
            ALARM_ACKNOWLEDGED_MSG: 'Alarm has been Acknowledged',
            ACKNOWLEDGE_UNSUCCESSFUL_MSG: 'Acknowledge Unsuccessful',
            ADD_COMMENT: 'Add a Comment',
            FILE_DOWNLOAD_SUCCESS_MSG: 'File downloaded successfully',
            NO_DATA_FOUND_MSG: 'No data found to download',
            NO_EXPORT_URL_MSG: 'No export URL found',
            NO_RESPONSE_FROM_EXPORT_DOWNLOAD_TIMELINE_MSG: 'No response received from exportDownloadTimeline',
            RECEIVED_LABL: 'Received',
            ACKNOWLEDGED_LABL: 'Acknowledged',
            ACKNOWLEDGED_FILTER_OPTS: 'Acknowledged',
            UNACKNOWLEDGED_FILTER_OPTS: 'Unacknowledged',
            VIEW_ALARM_DETAILS: 'View Alarm Details',
            NO_TIMELINE: 'No Timeline Found',
            RESOLVE: 'Resolve',
            CLOSE_ALARM_MODAL_TITLE: 'Close Alarm',
            CLEAR_ALARM_CONFIRMATION_MSG:
                'This action will not affect your operation. Are you sure you want to clear this alarm?',
            NO_USERS_FOUND_TITLE: 'No Users Found',
            NO_USERS_FOUND_DESCRIPTION: 'No users found',
            VIEW_DEVICE: 'View Device',
            SEVERITY_ALARM: 'Alarm',
            SEVERITY_OFFLINE: 'Offline',
            SEVERITY_WARNING: 'Warning',
            SEVERITY_INFORMATIONAL: 'Informational',
            SEVERITY_CRITICAL: 'Critical',
            SEVERITY_MAJOR: 'Major',
            SEVERITY_MINOR: 'Minor',
            ACTION_TAKEN_NO_ACTION: 'No Action',
            ACTION_TAKEN_TECH_SUPPORT: 'Tech Support',
            ACTION_TAKEN_TRUCK_ROLL: 'Truck Roll',
            ALARM_CAUSED_BY_TECH: 'Alarm Caused by Tech',
            ALARM_COMMENTS_TAB_TITLE_WITH_COUNT: 'Comments ({{value}})',
            ALARM_NAME: 'Alarm Name',
            ALARM_RECEIVED: 'Alarm Received',
            COMMENT_SUBMITTED_SUCCESS: 'Comment submitted successfully',
            COMMENT_SUBMIT_ERROR_MSG: 'Comment submission was unsuccessful',
            CONTACT_OUTCOME: 'Contact Outcome',
            CONTACT_OUTCOME_REQUIRED_MSG: 'Please enter the contact outcome',
            CUSTOMER_CONTACTED_NAME: 'Name of Customer Contacted',
            CUSTOMER_CONTACTED_NAME_REQUIRED_MSG: 'Please enter name of customer contacted',
            EATON_REPRESENTATIVE_INVALID_MSG: 'Please enter a valid Eaton representative',
            NO_COMMENTS_YET_MSG: 'No comments yet',
            SELECT_OPTION_REQUIRED_MSG: 'Please select an option',
        },
        CURRENCY_DETAILS: {
            SYMBOL: 'Symbol',
            CURRENCY_LIST_TITLE: 'Enable the currencies to utilize throughout the application',
            CURRENCY_TAB: 'Currencies',
            NO_CURRENCIES: 'No Currencies',
            CURRENCY_UPDATE_SUCCESSFULLY: 'Currency Updated successfully',
            CURRENCY_UPDATE_UNSUCCESSFULLY: 'Currency update unsuccessful',
        },
        TARIFF_DETAILS: {
            NO_TARIFF: 'No Tariffs',
            TARIFF_TAB: 'Tariffs',
            TARIFF_DETAILS_MODAL_TITLE: 'Tariff Details',
            DELETE_TARIFF_MODAL_TITLE: 'Delete Tariff',
            BTN_ADD_TARIFF: 'Add Tariff',
            BTN_EDIT_TARIFF: 'Edit Tariff',
            CLONE_TARIFF: 'Clone Tariff',
            TARIFF_DELETE_TEXT_SUCCESS: '{{tariffName}} has been deleted',
            CLONE_TARIFF_DESCRIPTION: 'Give the new Tariff a name and description.',

            CHOOSE_TARIFF_NAME: 'Choose Tariff Name',
            TARIFF_NAME: 'Tariff Name',
            DESCRIPTION: 'Description',
            SELECT_GROUP_ASSETS: 'Select Groups / Assets',
            SELECT_GROUP_SUBTITLE: 'Choose which Assets or Groups you want to apply this tariff to',
            SELECT_ASSETS: 'Select Asset(s)',
            SELECT_TITLE: 'Apply to individual assets',
            SELECT_ASSET_HELPER:
                'When switch is enabled, the schedule applies to individual assets. When disabled, it applies at the group level and any compatible devices added in the future will automatically have the schedule applied to it.',
            SELECT_CURRENCY: 'Select Currency',
            SELECT_CURRENCY_HELPER: 'Select the currency you would like to apply to this Tariff',
            SELECT_CURRENCY_EMPTY_MESSAGE:
                'All Currencies are disabled, please enable currencies from the Currencies tab to proceed',
            SELECT_TYPE_RATES: ' Select Tariff Type and Rates',
            SELECT_TARIFF_TYPE: 'Select Tariff Type',
            SINGLE_RATE: 'Single Rate:',
            SINGLE_RATE_DESCRIPTION: ' Select this option in case you have a single, fixed price for your rate',
            MULTIPLE_RATE: 'Multiple Rate:',
            MULTIPLE_RATE_DESCRIPTION:
                ' Select this option in order to add multiple rates with different prices (Peak, Off-Peak, Weekends)',
            PEAK_RATE: 'Peak Rate',
            STANDARD_RATE: 'Standard rate per unit',
            OFF_PEAK_RATE: 'Off Peak Rate',
            OFF_PEAK_RATE_HELPER: 'Rates that override the peak rate based on the time of the day',
            TARIFF: 'Tariff',
            TARIFF_ADDED_SUCCESSFULLY: '{{tariffName}} created Successfully',
            TARIFF_EDITED_SUCCESSFULLY: '{{tariffName}} edited Successfully',
        },

        HEALTH_STATUS: {
            POOR_HEALTH: 'Poor Health',
            LOAD: 'Load',
            CHANNEL: 'Channel',
            BATTERY: 'Battery',
        },
        DAY_FILTER: {
            VIEW_12_HRS: 'View 12 Hours',
            VIEW_24_HRS: 'View 24 Hours',
            VIEW_1_DAY: 'View 1 Day',
            VIEW_7_DAYS: 'View 7 Days',
            VIEW_30_DAYS: 'View 30 Days',
            VIEW_60_DAYS: 'View 60 Days',
            VIEW_90_DAYS: 'View 90 Days',
            VIEW_180_DAYS: 'View 180 Days',
        },
        ALARM_TABLE: {
            LODE_MORE_LABEL: 'Load More',
            LODE_LABEL: 'Load',
            OF_LABEL: 'of',
        },
        CUSTOM_NOTIFICATIONS: {
            NOTIFICATIONS_WILL_BE_PERMANENTLY_DELETED:
                'notification(s) will be permanently deleted.This cannot be undone',
        },

        ORGANIZATION_MANAGEMENT: {
            ADMIN_LEAVE_TEXT: 'If no other users exist, you’ll need to add users to the organization first.',
            ORGANIZATION_DELETE_WHEN_NO_USERS_ADDED:
                'The Organization can also be deleted if you cannot add other users.',
        },
        SCHEDULE: {
            NO_SCHEDULES_AVAILABLE: 'No Schedules Available',
        },
        MAP: {
            VIEW_FULL_MAP: 'View Full Map',
            SELECT_PIN_TO_VIEW_DETAILS: 'Select a pin to view details.',
        },

        DATA_OPERATIONS: {
            FILTERING: {
                AUDIT_LOGS_FILTER_LOGGED_AT: 'Date',
                AUDIT_LOGS_FILTER_USER: 'Users',
                AUDIT_LOGS_IP_ADDRESS: 'IP Address',
                AUDIT_LOGS_FILTER_SOURCE: 'Groups & Devices',
                AUDIT_LOGS_FILTER_DESCRIPTION: 'Description',
                USER_AND_ROLES_LAST_NAME: 'Last Name',
                USER_AND_ROLES_EMAIL: 'email',
                USER_AND_ROLES_GROUPS: 'groups',
                USER_AND_ROLES_FIRST_NAME: 'First Name',
                USER_AND_ROLES_PHONE: 'Phone',
                USER_AND_ROLES_ROLE: 'Role',
                USER_AND_ROLES_STATUS: 'Status',
            },
        },
        SNOOZE: {
            DEVICE_SNOOZED_FOR: 'Device Snoozed for',
            REMAINING: 'remaining',
            SNOOZE_HEADER: 'Snooze Notifications',
            SNOOZE_SUB_HEADER: 'Temporarily suppresses notifications.',
            THIRTY_MINUTES: '30 Minutes',
            ONE_HOUR: '1 Hour',
            FOUR_HOURS: '4 Hours',
        },
        DEVICE_TIMELINE: {
            ACKNOWLEDGEMENT_FAILED: 'Acknowledgment failed to communicate to end device at',
            CALL_SUPPORT_TEAM:
                '. If this problem continues, please call our support team at 877-386-2273 or email BLsupport@eaton.com.',
            CHANNEL_VALUES_AT_TIME_THE_EVENT_OCCURED: 'Channel values at time the event occured..',
            NO_EVENTS_FOUND: 'No Events Found',
            ACKNOWLEDGED: 'Acknowledged',
        },
        DEVICE_PROPERTIES: {
            EDIT_NAME: 'Edit Name',
            EDIT_DESCRIPTION: 'Edit Description',
            EDIT_TAGS: 'Edit Tags',
            EDIT_LOCATION: 'Edit Location',
            BATTERY_INSTALL_DATE: 'Battery Install Date',
            DEVICE_INSTALL_DATE: 'Device Install Date',
        },
        THRESHOLD_CONFIGURATION: {
            THRESHOLD_HAS_BEEN_MODIFIED: 'thresholds has been modified.',
            LOW_CRITICAL: 'Low Critical',
            HIGH_WARNING: 'High Warning',
            HIGH_CRITICAL: 'High Critical',
            THRESHOLD_VALUES: 'threshold values.',
            LOW_WARNING: 'Low Warning',
        },
        HELPERS_MSGS: {
            FILE_DOWNLOAD_PERMISSION: 'File Download Permission',
            SCHEDULE_MSG: 'Select assets that you would like to view in the widget.',
            DEVICE_LIST_MSG:
                'Drag the Selected Devices in the order you would like to view them.Total {{deviceLength}} devices displayed in the widget can be modified in Display Preferences.',
            LOADS_MSG:
                'Drag the Selected Loads in the order you would like to view them. Total {{loadsLength}} loads displayed in the widget can be modified in Display Preferences.',
            TIMELINE_MSG:
                'Drag the Selected Groups and Devices in the order you would like to view them.Total {{timelineLength}} devices and groups displayed in the widget can be modified in Display Preferences.',
            UPCOMING_MSG:
                'Total upcomings displayed ({{upcomingLength}}) in the widget can be modified in Display Preferences.',
        },
        UPCOMING_EVENTS: {
            SUPPORT_TECHNICIANS: 'Support Technician(s)',
            PULSE_SCORE: 'PulseScore',
            PULSE_SCORE_IMPACT_MESSAGE:
                "This recommendation has decreased this Device's PulseScore by <bold>{{points}} points</bold>. Resolve this issue to restore those points.",
            LEARN_MORE: 'Learn More',
            LEARN_MORE_PULSE_SCORE_ARIA_LABEL: 'Learn more about pulse score',
            RECOMMENDATION_NOTE: 'Recommendation Note',
            RECOMMENDATION_NOTE_FALLBACK:
                'Mauris in nisi ut diam vestibulum sodales eu vel ante. Cras eget nisl feugiat, sem at, ullamcorper diam. Sed ullamcorper ipsum non enim hendrerit, id volutpat ante ultrices. Donec vitae leo sit amet urna fringilla aliquam. Praesent tristique erat quis justo porta, non iaculis erat eleifend.',
            PULSE_SCORE_MODAL_WEIGHTED_METHOD:
                '<bold>PulseScore™</bold> uses a weighted point scoring method (0-100 points where 100 is an A+ and 65 or below is an F).',
            PULSE_SCORE_MODAL_DEVICE_MODE: 'Device Mode',
            PULSE_SCORE_MODAL_EVENTS_AND_ALARMS: 'Events and Alarms by Severity',
            PULSE_SCORE_MODAL_DEVICE_HEALTH_DATA: 'Device Health Data',
            PULSE_SCORE_MODAL_HISTORICAL_DATA: 'Historical Data',
            PULSE_SCORE_MODAL_CONFIGURATION_AGE_BEST_PRACTICES: 'Configuration, Age, Best Practices',
            PULSE_SCORE_MODAL_SCORING_REFRESHED: 'Scoring is refreshed with the latest device data received.',
            PULSE_SCORE_MODAL_DEVICES_IN_NORMAL_MODE:
                'Devices in Normal mode (Online, Healthy), with no alarms and optimal environments will achieve higher PulseScores.',
            PULSE_SCORE_MODAL_NOT_ALL_DEVICES_SUPPORTED: 'Not all devices or device types are supported at this time.',
        },
        UPCOMING: {
            MAKE: 'Make',
            INSTALLATION_DATE: 'Installation Date',
            LAST_SERVICE: 'Last Service',
            MODEL: 'Model',
            SERIAL_NUMBER: 'Serial Number',
            NAME: 'Name',
            STRINGS: 'Strings',
            BATTERIES: 'Batteries',
            EXPECTED_LIFE: 'Expected Life',
            CALCULATED_AGE: 'Calculated Age',
            FAN_BANKS: 'Fan Banks',
            FANS: 'Fans',
            NUMBER_OF_FILTERS: 'Number of Filters',
            TYPE: 'Type',
            AGE: 'Age',
            CURRENT_STATUS: 'Current Status',
            WARRANTY_CONTRACT_END: 'Warranty/Contract End',
            WITHIN_THIRTY_DAYS: 'Within 30 days',
            WITHIN_SIXTY_DAYS: 'Within 60 days',
            WITHIN_NINETY_DAYS: 'Within 90 days',
            WITHIN_ONE_TWENTY_DAYS: 'Within 120 days',
            WITHIN_ONE_EIGHTY_DAYS: 'Within 180 days',
            WITHIN_ONE_YEAR: 'Within 1 year',
            NOW: 'Now',
            SOON: 'Soon',
            WITHIN: 'Within',
            NO_UPCOMING_EVENTS: 'No Upcoming Events',
            UPCOMING_EVENTS_ARE_THINGS_THAT_MAY_HAPPEN_IN_THE_FUTURE:
                'Upcoming events are things that may happen in the future. This includes predictions, scheduled service, and more.',
            UPCOMING_EVENT_FALLBACK: 'Upcoming Event',
            EVENT_STATEMENT: '{{eventType}} before {{scheduledDate}}',
            ACKNOWLEDGE_UPCOMING: 'Acknowledge Upcoming',
            SERVICE_REQUEST: 'Request Service',
            SERVICE_SCHEDULING_MESSAGE:
                'This service requires scheduling. Please call 1-800-843-9433 and a support specialist will help you book a time.',
            SERVICE_OPTIONS: 'Service Options',
            SERVICE_OPTIONS_SUBTITLE: 'Select one of the options below to continue with your service flow.',
            SERVICE_OPTIONS_CALL_EATON: 'Call Eaton at {{phone}}, option 1, rather than submit your online request.',
            REQUEST_SERVICE_NOTE_PREFIX:
                'Please note, for emergency requests and any service visit not related to your predictive alert, call Eaton at ',
            REQUEST_SERVICE_NOTE_SUFFIX: ', option 1, rather than submit your online request.',
            ACKNOWLEDGE_SUCCESS: '{{upcomingName}} has been acknowledged.',
            ACKNOWLEDGED_SUCCESSFULLY: 'Acknowledged Successfully',
            ACKNOWLEDGE_FAILED: 'Failed to acknowledge event. Please try again.',
            VALUE: 'Value',
            ACKNOWLEDGEMENT_DETAILS: 'Acknowledgement Details',
            DETAILS: 'Details',
            SERVICE_REQUEST_SUBMITTED_SUCCESSFULLY: 'Your Service Request has been successfully submitted.',
            MORE_INFORMATION_ABOUT_THE_UPCOMING_TO_ACKNOWLEDGE_IT:
                'Use this field to give context or add more information about the upcoming, in order to acknowledge it.',
            UPDATE_CLEANED_REPLACED_DATE: 'Update Cleaned/Replaced Date',
            UPDATE_REPLACED_DATE_DESC: 'To edit the replacement date, please select a new date on the dropdown below.',
            ALL_TIMES_ET_NOTE: 'Note: All times are displayed in ET time',
            COMPONENT_PROPERTIES_TITLE: 'Component Properties',
            BATTERY_ALGORITHM_TITLE: 'Battery Algorithm',
            BATTERY_ALGORITHM_VOLTAGE: 'Voltage',
            BATTERY_ALGORITHM_CONFIDENCE_LOWER_LIMIT: '95% Confidence Lower Limit',
            BATTERY_ALGORITHM_RECENT_EVENT: 'Recent Event',
            BATTERY_ALGORITHM_DEGRADATION_DETECTED: 'Degradation Detected',
            BATTERY_ALGORITHM_COMING_UP: 'Coming Up',
            BATTERY_ALGORITHM_SIXTY_DAYS_LEFT_WARNING: '60 Days Left Warning',
            BATTERY_ALGORITHM_IMMINENT_ALARM: 'Imminent Alarm',
            BATTERY_ALGORITHM_BATTERY_END_OF_LIFE: 'Battery End of Life',
            BATTERY_ALGORITHM_UPPER_REFERENCE: 'Upper Reference',
            DESCRIPTION_TITLE: 'Description',
            CREATED: 'Created',
            ADDRESS_WITHIN: 'Address Within',
            TYPE_LABEL: 'Type',
            WITHIN_DAYS: 'Within {{count}} days',
            IMMEDIATELY: 'Immediately',
            CSE_RECOMMENDATION: 'CSE Recommendation',
            VIEW_PREDICTION_DETAILS: 'View Prediction Details',
            DAYS: 'Days',
            PARAMETER: 'Parameter',
            RESULT: 'Result',
            HOUR: 'Hour',
            LOADS: 'Loads',
            SERVICE_REQUEST_REFERENCE_NUMBER: 'Your Service Request with a Reference Number: ',
            SERVICE_REQUEST_SUBMITTED_FOR: ' has been successfully submitted for ',
            UPDATE_STATUS: 'Update Status',
            STATUS_OPEN: 'Open',
            STATUS_ACKNOWLEDGED: 'Acknowledged',
            STATUS_PENDING: 'Pending',
            STATUS_CLOSED: 'Closed',
            STATUS_CHANGE_SUCCESS: 'Status changed successfully',
            STATUS_CHANGE_FAILED: 'Unable to change the status. Please try again.',
            CONFIRM_STATUS_CHANGE_TITLE: 'Change Event Status',
            CONFIRM_STATUS_CHANGE_MESSAGE: 'Are you sure you want to change the status of {{event}} to {{status}}?',
            UPCOMING_NAME: 'Upcoming Name',
            UPCOMING_RECEIVED: 'Upcoming Received',
            NO_RESPONSE_FROM_EXPORT_DOWNLOAD_PREDICTION_MSG:
                'No response received from the export service. Please try again.',
        },
        CUSTOMER_VALIDATION: {
            VERIFY_BUTTON: 'Verify',
            OVERRIDE_BUTTON: 'Override',
            VALIDATE: 'Validate',
            VIEW_ORGANIZATION: 'View Organization',
            TAB_TITLE: 'Organization Management',
            EMAIL: 'Email',
            PHONE: 'Phone',
            PREFERENCE: 'Preference',
            PHONE_CALL: 'Phone Call',
            USER_NAME: 'User Name',
            MAP: {
                VIEW_FULL_MAP: 'View Full map',
            },
            NO_USERS_FOUND: 'No User(s) found',
        },
        ROOTED_SCREEN: {
            TITLE: 'Rooted Device Alert!',
            SUB_TITLE:
                'Brighlatyer Remote Monitoring cannot be installed on rooted devices for security purposes. Please try installing it on a device with a licensed OS.',
        },
        USER_PRIVILEGES: {
            REALMS: 'Realms',
            REALM: 'Realm',
            ORGANIZATIONS: 'Organizations',
            ORGANIZATION: 'Organization',
            USERS_AND_ROLES: 'Users & Roles',
            ROLES: 'Roles',
            USERS: 'Users',
            DASHBOARDS_AND_WIDGETS: 'Dashboards & Widgets',
            SYSTEM_DASHBOARDS: 'System Dashboards',
            SYSTEM_WIDGETS: 'System Widgets',
            USER_DASHBOARDS: 'User Dashboards',
            USER_WIDGETS: 'User Widgets',
            GROUPS_AND_DEVICES: 'Groups & Devices',
            GROUPS: 'Groups',
            DEVICES: 'Devices',
            AUTOMATIONS_AND_NOTIFICATIONS: 'Automations & Notifications',
            AUTOMATIONS: 'Automations',
            NOTIFICATIONS: 'Notifications',
            SCHEDULING: 'Scheduling',
            REPORTS_AND_DIGESTS: 'Reports & Digests',
            REPORTS: 'Reports',
            DIGESTS: 'Digests',
            ACCOUNTING_LOG: 'Accounting Log',
            LOGS: 'Logs',
            PREDICTIONS: 'Predictions',
            DEVICE_TREE: 'Device Tree',
            DEVICE_TREES: 'Device Trees',
            ERPS: 'Erps',
            VIEW_REALM: 'View Realm',
            CREATE_REALM: 'Create Realm',
            EDIT_REALM: 'Edit Realm',
            DELETE_REALM: 'Delete Realm',
            MANAGE_REALM_CUSTOMIZATION: 'Manage Realm Customization',
            MANAGE_REALM_URL: 'Manage Realm Url',
            EDIT_ORGANIZATION: 'Edit Organization',
            DELETE_ORGANIZATION: 'Delete Organization',
            MANAGE_SERVICE_CONTACT: 'Manage Service Contact',
            VIEW_USERS: 'View Users',
            ADD_USERS: 'Add Users',
            EDIT_USERS: 'Edit Users',
            DELETE_USERS: 'Delete Users',
            VIEW_ROLES: 'View Roles',
            ADD_ROLES: 'Add Roles',
            EDIT_ROLES: 'Edit Roles',
            DELETE_ROLES: 'Delete Roles',
            VIEW_GROUP_MANAGEMENT: 'View Group Management',
            ADD_GROUPS: 'Add Groups',
            DELETE_GROUPS: 'Delete Groups',
            EDIT_GROUPS: 'Edit Groups',
            VIEW_DEVICES: 'View Devices',
            ADD_DEVICES: 'Add Devices',
            EDIT_DEVICES: 'Edit Devices',
            DELETE_DEVICES: 'Delete Devices',
            SNOOZE_DEVICES: 'Snooze Devices',
            ACKNOWLEDGE_ALARMS: 'Acknowledge Alarms',
            MANAGE_DEVICE_TAGS: 'Manage Device Tags',
            VIEW_AUTOMATIONS: 'View Automations',
            CREATE_AUTOMATIONS: 'Create Automations',
            EDIT_AUTOMATIONS: 'Edit Automations',
            DELETE_AUTOMATIONS: 'Delete Automations',
            VIEW_NOTIFICATIONS: 'View Notifications',
            CREATE_NOTIFICATIONS: 'Create Notifications',
            EDIT_NOTIFICATIONS: 'Edit Notifications',
            DELETE_NOTIFICATIONS: 'Delete Notifications',
            VIEW_SYSTEM_DASHBOARDS: 'View System Dashboards',
            CREATE_SYSTEM_DASHBOARDS: 'Create System Dashboards',
            EDIT_SYSTEM_DASHBOARDS: 'Edit System Dashboards',
            DELETE_SYSTEM_DASHBOARDS: 'Delete System Dashboards',
            VIEW_SYSTEM_WIDGETS: 'View System Widgets',
            CREATE_SYSTEM_WIDGETS: 'Create System Widgets',
            EDIT_SYSTEM_WIDGETS: 'Edit System Widgets',
            DELETE_SYSTEM_WIDGETS: 'Delete System Widgets',
            VIEW_USER_DASHBOARDS: 'View User Dashboards',
            CREATE_USER_DASHBOARDS: 'Create User Dashboards',
            EDIT_USER_DASHBOARDS: 'Edit User Dashboards',
            DELETE_USER_DASHBOARDS: 'Delete User Dashboards',
            VIEW_USER_WIDGETS: 'View User Widgets',
            CREATE_USER_WIDGETS: 'Create User Widgets',
            EDIT_USER_WIDGETS: 'Edit User Widgets',
            DELETE_USER_WIDGETS: 'Delete User Widgets',
            VIEW_SCHEDULES: 'View Schedules',
            CREATE_SCHEDULES: 'Create Schedules',
            EDIT_SCHEDULES: 'Edit Schedules',
            DELETE_SCHEDULES: 'Delete Schedules',
            VIEW_REPORTS: 'View Reports',
            DELETE_REPORTS: 'Delete Reports',
            VIEW_DIGESTS: 'View Digests',
            VIEW_LOGS: 'View Logs',
            SAVE_VRL_INSIGHT: 'Save Vrl Insight',
            READ_EXECUTION_CONTEXT: 'Read Execution Context',
            READ_EXECUTION_CONTEXTS: 'Read Execution Contexts',
            SAVE_NOTIFICATION_CAPACITOR: 'Save Notification Capacitor',
            SAVE_NOTIFICATION_TIMER: 'Save Notification Timer',
            SAVE_NOTIFICATION_VRLA: 'Save Notification Vrla',
            READ_SUMMARY: 'Read summary',
            READ_GROUP_SUMMARY: 'Read group summary',
            SAVE_COMMENT: 'Save comment',
            READ_COMMENT: 'Read comment',
            UPDATE_PREDICTION_STATUS: 'Update prediction status',
            SAVE_AIRFILTER: 'Save airfilter',
            DOWNLOAD_SUMMARY: 'Download summary',
            READ_FILTERED_PREDICTIONS: 'Read filtered predictions',
            DOWNLOAD_PREDICTIONS: 'Download predictions',
            DELETE_PREDICTION_NOTIFICATION: 'delete prediction notification',
            INSIGHTS_SEARCH: 'Insights search',
            MOCK_PREDICTION_NOTIFICATION: 'Mock prediction notification',
            SAVE_SERVICE_REQUEST: 'Save service request',
            DELETE_SERVICE_REQUEST: 'Delete service request',
            VIEW_PREDICTION: 'View Prediction',
            READ_AIRFILTER_EVIDENCE: 'Read airfilter evidence',
            READ_ALUMINIUM_CAPACITOR_EVIDENCE: 'Read aluminium capacitor evidence',
            READ_SERVICE_FANS_EVIDENCE: 'Read service fans evidence',
            READ_DEVICE_TREE: 'Read Device Tree',
            SAVE_ERPS_CONTRACT_DATA: 'Save Erps Contract Data',
            GET_ERPS_BATCH_DATA: 'Get Erps Batch Data',
            GET_ERPS_SERIAL_DATA: 'Get Erps Serial Data',
            GET_ERPS_INFO: 'Get Erps Info',
            GET_BATTERY_METADATA: 'Get battery-metadata',
            READ_BATTERY_SERVICE_INFO: 'Read Battery Service Info',
            GET_AIRFILTER_SERVICE_DATA: 'Get airfilter service data',
            GET_BATTERY_SERVICE_DATA: 'Get battery service data',
            GET_DEVICE_ADDRESS_DATA: 'Get device address data',
            GET_DEVICE_SERVICE_DATA: 'Get device service data',
            GET_ELECTROLYTIC_CAPACITOR_DATA: 'Get electrolytic capacitor data',
            GET_FAN_SERVICE_DATA: 'Get fan service data',
            GET_FILM_CAPACITOR_DATA: 'Get film capacitor data',
            GET_VALID_DEVICE_DATA: 'Get valid device data',
            GET_SERVICE_REQUEST_DATA: 'Get service request data',
            GET_ERPS_CONTRACT_DATA: 'Get erps contract data',
        },
        features: {
            SELF_REGISTRATION: 'Self Registration',
            JOIN_ORGANIZATION: 'Join Organization',
            REALM_MANAGEMENT: 'Realm Management',
            REALM_CUSTOMIZATION: 'Realm Customization',
            CUSTOM_URL_MANAGEMENT: 'Custom URL Management',
            USER_MANAGEMENT: 'User Management',
            ROLE_MANAGEMENT: 'Role Management',
            ALERT_DIGEST: 'Alert Digest',
            AUTOMATIONS: 'Automations',
            CUSTOM_NOTIFICATIONS: 'Custom Notifications',
            ACCOUNTING_LOG: 'Accounting (Audit) Log',
            TELEMETRY_THRESHOLDS: 'Telemetry Thresholds',
            DOCUMENT_MANAGEMENT: 'Document Management',
            GROUP_MANAGEMENT: 'Group Management',
            ACKNOWLEDGE_ALARM: 'Acknowledge Alarm',
            CREATE_ORGANIZATION: 'Create Organization',
            SNOOZE_DEVICE: 'Snooze Device',
            DASHBOARD_AND_WIDGET_MANAGEMENT: 'Dashboard & Widget Management',
            SCHEDULING: 'Scheduling',
            DISPLAY_ALERTS: 'Display Alerts',
            ACKNOWLEDGEMENT: 'Acknowledgement',
            DISPLAY_DEVICE_STATUS: 'Display Device Status',
            SNOOZE: 'Snooze',
            AUTOMATION_MANAGEMENT: 'Automation Management',
            MANAGE_CHANNEL_CADENCE_GROUPS: 'Manage Channel Cadence Groups',
            MANAGE_CHANNEL_CATEGORIES: 'Manage Channel Categories',
            MANAGE_CHANNEL_NAMES: 'Manage Channel Names',
            TELEMETRY_CHARTS: 'Telemetry Charts',
            EXPORT_TELEMETRY_CHARTS: 'Export Telemetry Charts',
            TELEMETRY_GAUGES: 'Telemetry Gauges',
            DASHBOARD_MANAGEMENT: 'Dashboard Management',
            WIDGET_MANAGEMENT: 'Widget Management',
            BULK_DEVICE_REGISTRATION: 'Bulk Device Registration',
            DEVICE_COMPONENTS: 'Device Components',
            DEVICE_CONTROLS: 'Device Controls',
            DEVICE_DETAILS: 'Device Details',
            DEVICE_LOADS: 'Device Loads',
            DEVICE_PROPERTIES: 'Device Properties',
            DEVICE_SETTINGS: 'Device Settings',
            VIRTUAL_LOADS: 'Virtual Loads',
            DOWNLOAD_DOCUMENTS: 'Download Documents',
            ENERGY_CONSUMPTION: 'Energy Consumption',
            ENERGY_FLOW: 'Energy Flow',
            ENERGY_METRICS: 'Energy Metrics',
            HEALTH_SCORE: 'Health Score',
            HEALTH_SCORE_SUMMARY: 'Health Score Summary',
            HEALTH_SCORE_INSIGHTS_REQUIRES_HEALTH_SCORE_SUMMARY:
                'Health Score Insights <i>(Requires Health Score Summary)</i>',
            ACCOUNTING_AUDIT_LOG: 'Accounting (Audit) Log',
            EXPORT_ACCOUNTING_AUDIT_LOG: 'Export Accounting (Audit) Log',
            MAP_DETAILS: 'Map Details',
            MAP_SUMMARY: 'Map Summary',
            ALERT_NOTIFICATIONS: 'Alert Notifications',
            ALERT_DIGEST_NOTIFICATIONS: 'Alert Digest Notifications',
            CUSTOM_NOTIFICATIONS_EXT: 'Custom Notifications <i>(Requires User Management)</i>',
            DELAY_INTERVAL_SETTINGS: 'Delay/Interval Settings',
            PREDICTION_NOTIFICATIONS: 'Prediction Notifications',
            UPCOMING_SUMMARY: 'Upcoming Summary',
            AIR_FILTER: 'Air Filter',
            ALUMINUM_ELECTROLYTIC_CAPACITOR: 'Aluminum Electrolytic Capacitor',
            BATTERY: 'Battery',
            FAN: 'Fan',
            MESHBLOCK: 'Mesh is Blocked Try After 5 min.',
            FILM_CAPACITOR: 'Film Capacitor',
            CUSTOM_URL: 'Custom Url',
            CUSTOMIZATION: 'Customization',
            REPORT_MANAGEMENT: 'Report Management',
            REPORT_NOTIFICATIONS: 'Report Notifications',
            SCHEDULING_DETAILS: 'Scheduling Details',
            SCHEDULING_SUMMARY: 'Scheduling Summary',
            TIMELINE_DETAILS: 'Timeline Details <i>(Requires Display Alerts)</i>',
            EXPORT_TIMELINE: 'Export Timeline',
            TIMELINE_SUMMARY: 'Timeline Summary <i>(Requires Display Alerts)</i>',
            AGGREGATED_TRENDS_DETAILS: 'Aggregated Trends Details',
            AGGREGATED_TRENDS_DETAILS_EXPORT_TRENDS: 'Aggregated Trends Details Export Trends',
            AGGREGATED_TRENDS_SUMMARY: 'Aggregated Trends Summary',
            AGGREGATED_TRENDS_SUMMARY_EXPORT_TRENDS: 'Aggregated Trends Summary Export Trends',
            LOAD_TRENDS_DETAILS: 'Load Trends Details',
            LOAD_TRENDS_SUMMARY: 'Load Trends Summary',
            TRENDS_DETAILS: 'Trends Details',
            TRENDS_DETAILS_EXPORT_TRENDS: 'Trends Details Export Trends',
            TRENDS_SUMMARY: 'Trends Summary',
            TRENDS_SUMMARY_EXPORT_TRENDS: 'Trends Summary Export Trends',
            WEATHER_DETAILS: 'Weather Details',
            WEATHER_SUMMARY: 'Weather Summary',
            FEATURES: 'Features',
            ALERTS: 'Alerts',
            CHANNELS: 'Channels',
            DASHBOARDS: 'Dashboards',
            DEVICES: 'Devices',
            DOCUMENTS: 'Documents',
            ENERGY: 'Energy',
            GROUPS: 'Groups',
            LOGS: 'Logs',
            MAPS: 'Maps',
            NOTIFICATIONS: 'Notifications',
            PREDICTIONS: 'Predictions',
            REALMS: 'Realms',
            TIMELINE: 'Timeline',
            TRENDS: 'Trends',
            USERS: 'Users',
            WEATHER: 'Weather',
            EXPORT_TRENDS: 'Export Trends',
            TIMELINE_DETAILS_REQUIRES_DISPLAY_ALERTS: 'Timeline Details <i>(Requires Display Alerts)</i>',
            CUSTOM_NOTIFICATIONS_REQUIRES_USER_MANAGEMENT: 'Custom Notifications <i>(Requires User Management)</i>',
            SET_AS_BASE_FEATURE_PACKAGE: 'Set As Base Feature Package',
            ACTIVE_SERVICE_CONTRACT: 'Active Service Contract',
            REVENERA_SUPPORTED: 'Revenera Supported',
            DEVICE_MODELS_LABEL: 'Device Models',
            TIMELINE_SUMMARY_REQUIRES_DISPLAY_ALERTS: 'Timeline Summary <i>(Requires Display Alerts)</i>',
            LICENSES_SUBSCRIPTIONS: 'Licenses Subscriptions',
        },
        BSSRM_NOTIFICATION_LOCALIZATION: {
            ALARMS: 'Alarms',
            WARNING_EVENTS: 'Warning Events',
            DEVICE_EVENTS: 'Device Events',
            ACCOUNT_ORGANIZATION: 'Account and Organization',
            ALARMS_INCIDENTS_DEVICE_FAULTS: 'Alarms Incidents Device Faults',
            THRESHOLD_DEVICE_WARNINGS: 'Threshold Warnings Device Warnings',
            STATUS_CHANGE_INFO_EVENT: 'Status Changes Informational Events',
            CHANGES_TO_ACCOUNT_ORGANIZATION: 'Changes to Your Account Organization',
            EMAIL_NOTIFICATIONS: 'Email Notifications',
            TEXT_NOTIFICATIONS: 'Text Notifications(SMS)',
            PUSH_NOTIFICATIONS: 'Push Notifications',
            INCLUDE_IN_DAILY_DIGEST: 'Include in Daily Digest',
            INCLUDE_IN_WEEKLY_DIGEST: 'Include in Weekly Digest',
            PHONE_SUPPORT: 'Phone Support',
            REPORTS: 'Reports',
            REPORTS_DESCRIPTION: 'Periodic Digests Generated Reports Service Reports',
        },
        ROGUE_DEVICES: {
            REMOVE_QUARANTINE: 'Remove Quarantine',
            REMOVE_QUARANTINE_BTN: 'Remove Quarantine?',
            REMOVE_QUARANTINE_DESCRIPTION: 'Would you like to remove {{deviceName}} from its quarantine?',
            QUARANTINE_DESCRIPTION: 'Are you sure you would  like to quarantine {{deviceName}}?',
            QUARANTINE_DEVICE: 'Quarantine Device',
            QUARANTINE_DEVICE_BTN: 'Quarantine Device?',
            QUARANTINE_DEVICE_NAME: 'Quarantine {{deviceName}}',
            QUARANTINED_DEVICE_NAME: 'Quarantine {{deviceName}}?',
            DEVICE_QUARANTINED_SUCCESS_MSG: 'Device Quarantined Successfully.',
            DEVICE_UNQUARANTINED_SUCCESSS_MSG: 'Device Unquarantined Successfully.',
        },
        SESSION_TIMEOUT: {
            TIMEOUT_TITLE: 'Session Timed Out',
            TIMEOUT_DESCRIPTION:
                'Your session timed out. To return to the application please reauthenticate your user session.',
            RE_LOGIN_BTN: 'Log In with Okta',
            NOT_FOUND_TITLE: 'Not Found',
            NOT_FOUND_DESCRIPTION: 'Resource not found',
            LOGOUT_BTN: 'Logout',
        },
        SCANNING: {
            SCANNING_RESULTS: 'Scanning Results',
            DEVICES_FOUND: '{{count}} Devices Found',
            REQUEST_FAILED_TITLE: 'Request Failed',
            REQUEST_FAILED_DESCRIPTION: 'Process could not be completed due to an API error, try again later.',
            TRUSTED_TAB: 'Trusted',
            TRUSTED_TAB_DESCRIPTION: 'Below devices are ready to be added.',
            UNTRUSTED_TAB: 'Untrusted',
            UNTRUSTED_TAB_DESCRIPTION:
                'These are devices picked up in the scan but are not a Eaton device. No action is needed for these devices.',
            READY_TO_ADD_WITH_COUNT: 'Ready to Add ({{count}})',
            UNTRUSTED_WITH_COUNT: 'Untrusted ({{count}})',
            ORPHAN_DEVICES_WITH_COUNT: 'Orphan Devices ({{count}})',
            NO_TRUSTED_DEVICES_FOUND: 'No trusted devices found',
            MAX_DEVICES_REACHED_TITLE: 'Maximum devices reached',
            MAX_DEVICES_REACHED_MESSAGE: 'You can only select {{count}} devices',
            NO_ORPHAN_SELECTED_TITLE: 'No orphan devices selected',
            NO_ORPHAN_SELECTED_MESSAGE: 'Please select at least one orphan device to delete',
            NO_DEVICES_SELECTED_TITLE: 'No devices selected',
            NO_DEVICES_SELECTED_MESSAGE: 'Please select at least one device',
            WEAK_SIGNAL_TITLE: 'Weak Signal',
            WEAK_SIGNAL_MESSAGE: 'Signal strength is too weak to blink this device',
            BLINK_SUCCESS: '{{name}} blink successfully.',
            ORPHAN_DELETE_FAILED: 'Failed to delete orphan devices. Please try again.',
            DELETE_ORPHAN_ACCESSIBILITY: 'Delete orphan devices',
            ORPHAN_WARNING_BELONGS:
                '{{deviceLabel}} belongs to {{deviceGroupName}}, unable to add in {{currentGroupName}}',
            ORPHAN_WARNING_BELONG:
                '{{deviceLabel}} belong to {{deviceGroupName}}, unable to add in {{currentGroupName}}',
            POOR_NETWORK_TAB: 'Low Signal Strength',
            POOR_NETWORK_TAB_DESCRIPTION:
                'You can try to connect to these devices but it may fail because you are too far away.',
            LIGHT_NAME: 'Name',
            ADD_LIGHT: '+ Add To Zone',
            NEW_DEVICE: 'New Device',
            SCAN_LIGHT_INFO_BLINK: 'Tap the Light Icon to blink light and identify the fixture in your location.',
            READY_TO_ADD: 'Ready to Add',
            RETRY_DEVICE_NOT_FOUND: 'Devices Not Re-acquired',
            RETRY_SCAN_AGAIN: 'Scan Again',
            RETRY_DEVICE_FOUND: 'Failed Devices Re-acquired',
            RETRY_MODE_ACTIVE: 'Retry Mode Active',
            RETRY_DEVICE_FOUND_DESC:
                'Re-identified {{matchedCount}} of {{totalCount}} failed device(s). Select Next to resume.',
            RETRY_MODE_DESC: 'Re-scanning for {{totalCount}} failed device(s)...',
            TAB_BAR_ACCESSIBILITY: 'Tab Bar',
            TAB_ACCESSIBILITY_SUFFIX: 'Tab',
            EXPAND_ACCESSIBILITY_LABEL: 'Expand',
            COLLAPSE_ACCESSIBILITY_LABEL: 'Collapse',
            BACK_ICON_ACCESSIBILITY: 'Back',
            NEXT_ICON_ACCESSIBILITY: 'Next',
            BACK_CHEVRON_ICON_ACCESSIBILITY: 'Back chevron icon',
            NEXT_CHEVRON_ICON_ACCESSIBILITY: 'Forward chevron icon',
            BLUETOOTH_REQUIRED_TITLE: 'Bluetooth Required',
            BLUETOOTH_REQUIRED_MESSAGE:
                'Bluetooth must be turned on to scan for devices. Please enable Bluetooth in your device settings.',
            BLUETOOTH_ACCESS_DENIED_TITLE: 'Bluetooth Access Denied',
            BLUETOOTH_ACCESS_DENIED_MESSAGE:
                'This app does not have permission to use Bluetooth. Please enable Bluetooth access in your device settings.',
            BLUETOOTH_NOT_SUPPORTED_TITLE: 'Bluetooth Not Supported',
            BLUETOOTH_NOT_SUPPORTED_MESSAGE:
                'This device does not support Bluetooth functionality required for scanning.',
            BLUETOOTH_RESETTING_TITLE: 'Bluetooth Resetting',
            BLUETOOTH_RESETTING_MESSAGE: 'Bluetooth is currently resetting. Please wait a moment and try again.',
            NO_DEVICE_FOUND_TITLE: 'No Device Found',
            NO_DEVICE_FOUND_RETRY_MESSAGE: 'Scan again or Abort to return to retry options.',
            NO_DEVICE_FOUND_ZONE_MESSAGE: 'Scan again or Abort to go back on Zone Details.',
            PERMISSIONS_REQUIRED_TITLE: 'Permissions Required',
            PERMISSIONS_REQUIRED_MESSAGE:
                'Bluetooth permissions are required to scan for devices. Please grant the permissions and try again.',
            VALIDATION_ERROR_TITLE: 'Validation Error',
            VALIDATION_ERROR_MESSAGE: 'Cannot identify mesh context. Please return to the zone and try again.',
            SCAN_AGAIN_BUTTON: 'Scan Again',
            RETRY_BUTTON: 'Retry',
            OK_BUTTON: 'OK',
            NAVIGATION_STEPPER_ACCESSIBILITY_LABEL: 'Scanning Navigation Stepper',
            NAVIGATION_STEPPER_ACCESSIBILITY_HINT: 'Stepper to navigate between scanning steps',
            BACK_BUTTON_ACCESSIBILITY_LABEL: 'Back Button',
            BACK_BUTTON_ACCESSIBILITY_HINT: 'Go to previous step',
            NEXT_BUTTON_ACCESSIBILITY_LABEL: 'Next Button',
            NEXT_BUTTON_ACCESSIBILITY_HINT: 'Go to next step or continue',
            PROGRESS_BAR_ACCESSIBILITY_HINT: 'Shows the progress of provisioning',
            ICON_LIGHT_BLINK_ACCESSIBILITY_LABEL: 'Icon Light Blink',
            ICON_LIGHT_ACCESSIBILITY_LABEL: 'Icon Light',
            ICON_LIGHT_ACCESSIBILITY_HINT: 'Icon Light',
            SCANNED_DEVICES_LIST_ACCESSIBILITY_LABEL: 'Scanned devices list',
            SCANNED_DEVICES_LIST_ACCESSIBILITY_HINT: 'List of {{count}} scanned devices',
            DEVICE_POSITION_ACCESSIBILITY_LABEL: 'Device {{position}}: {{name}}',
            DEVICE_POSITION_ACCESSIBILITY_HINT:
                'Device in list position {{position}}. Tap to interact with device options',
            CHECKBOX_ACCESSIBILITY_LABEL: 'Checkbox for {{name}}, {{state}}',
            SIGNAL_STRENGTH_ACCESSIBILITY_LABEL: 'Signal strength: {{value}} dBm',
            BLINK_DEVICE_ACCESSIBILITY_LABEL_WITH_NAME: 'Blink device {{name}}',
            BLINK_DEVICE_ACCESSIBILITY_HINT: 'Press to blink the light on this device for identification. {{status}}',
            BLINK_DISABLED_WEAK_SIGNAL: 'Disabled due to weak signal',
            DEVICE_ACCESSIBILITY_LABEL: '{{name}} device',
            ORPHAN_DEVICE_ACCESSIBILITY_LABEL: '{{name}} orphan device',
            DELETE_ORPHAN_DEVICES_ACCESSIBILITY_LABEL: 'Delete {{count}} orphan {{deviceLabel}}',
            WIFI_SIGNAL_INDICATOR_ACCESSIBILITY_HINT: 'WiFi signal indicator',
            UNKNOWN_DEVICE_NAME: 'Unknown',
            UNKNOWN_DEVICE_MODEL: 'Unknown Model',
            SELECTED_STATE: 'Selected',
            NOT_SELECTED_STATE: 'Not selected',
            BLINKING_STATE_ACTIVE: 'Currently blinking',
            BLINKING_STATE_INACTIVE: 'Not blinking',
            TRUSTED_INFO_READY_TO_ADD: 'Below devices are ready to be added.',
            TRUSTED_INFO_SINGLE_ORPHAN: '{{deviceName}} has lost connection to the mesh network.',
            TRUSTED_INFO_MULTIPLE_ORPHANS: '{{count}} devices have lost connection to the mesh network.',
            DEVICE_LABEL: 'Device',
        },
        ORPHAN_DEVICE: {
            DELETE_WARNING_TITLE: 'Deletion Warning!',
            DELETE_WARNING_SUBTITLE:
                'Selecting "Continue" will permanently delete these orphan devices from the subscription details/ database. Please note that all historical data associated with these devices will be lost.',
            DELETE_CONFIRM_TITLE: 'Delete Device?',
            DELETE_CONFIRM_SUBTITLE:
                'Entrance devices and its data will be deleted forever. To proceed deleting these devices and it’s associated data,  type "<b>delete</b>" in the text box below and select the \'Delete\' button.',
            HEADER_SINGLE:
                'There is 1 orphan device that has lost connection to the mesh network. Tap, "Retry" to add it back to the mesh. Tap, "Dismiss" to see all devices in the device scan.',
            HEADER_PLURAL:
                'There are {{count}} orphan devices that have lost connection to the mesh network. Tap, "Retry" to add them back to the mesh. Tap, "Dismiss" to see all devices in the device scan.',
            NO_ORPHAN_DEVICES_MESSAGE: 'No orphan devices detected.',
            ORPHAN_SINGLE_MESSAGE:
                '1 device is no longer connected to the mesh network. Select Retry to attempt reconnection, or Dismiss to view all scanned devices.',
            ORPHAN_MULTIPLE_MESSAGE:
                '{{count}} devices are no longer connected to the mesh network. Select Retry to attempt reconnection, or Dismiss to view all scanned devices.',
            UNKNOWN_ZONE: 'Unknown Zone',
            DIFFERENT_GROUP_WARNING: 'This device was previously configured in another group: "{{zoneName}}"',
            DELETE_FAILED_MESSAGE: 'Failed to delete devices. Please try again.',
            ORPHAN_DEVICES: 'Orphan Devices',
            RETRY: 'Retry',
            WARNING_ICON_ACCESSIBILITY_LABEL: 'Warning Icon',
            ORPHAN_SECTION_TOGGLE_ACCESSIBILITY_HINT: 'Double tap to expand or collapse orphan devices section',
            SUBHEADER_SINGLE_SUFFIX: 'device is no longer connected to the mesh network',
            SUBHEADER_PLURAL_SUFFIX: 'devices are no longer connected to the mesh network',
            BLINK_DEVICE_ACCESSIBILITY_HINT: 'Double tap to blink this device',
            PREVIOUSLY_IN_ZONE: 'Previously in {{zoneName}}',
            GROUP_LABEL: 'Group: {{groupName}}',
            DELETE_ALL_ORPHAN_ACCESSIBILITY_HINT: 'Double tap to delete all same-group orphan devices',
            ORPHAN_DEVICES_LABEL: 'Orphan Devices',
            TYPE_DELETE: 'Type "delete"',
            TYPE_DELETE_PLACEHOLDER: 'Type "delete" to continue',
            TYPE_DELETE_ACCESSIBILITY: 'Type delete to confirm',
            TYPE_DELETE_HELPER_SINGLE: 'Type "Delete" to continue deleting\nthis light.',
            TYPE_DELETE_HELPER_PLURAL: 'Type "Delete" to continue deleting\nthese lights.',
            CANCEL: 'Cancel',
            CONTINUE: 'Continue',
            DELETE: 'Delete',
            DISMISS: 'Dismiss',
            DONT_SHOW_AGAIN: "Don't Show Again",
        },
        SYNC_UNSYNC: {
            SYNC: 'Sync',
            UNSYNC_INFO: 'There are multiple devices that need to be synced in order to continue working properly.',
            SYNC_REQUIRED: 'Sync Required',
            SYNCED: 'Synced',
            DEVICES_NOT_SYNCED: 'Devices Not Synced',
            RETRY_FIRMWARE_UPGRADE: 'Retry Firmware Upgrade',
            TAB_ENTITLEMENT_SYNC: 'Entitlements',
            TAB_FIRMWARE_VERSION: 'Firmware',
            TAB_DAYLIGHT_SAVING: 'Daylight Saving',
            GET_LATEST_STATUS: 'Get Latest Status',
            DAYLIGHT_SAVING_SUCCESS: 'Daylight Saving updated successfully',
            DAYLIGHT_SAVING_API_ERROR: 'Failed to sync Daylight Saving to server',
            DEVICE_SYNC: 'Device Sync',
            UNKNOWN_DEVICE: 'Unknown',
            UNKNOWN_ZONE: 'Unknown',
        },
        ZONE_DETAILS: {
            DEVICES: 'Devices',
            SCHEDULES: 'Control Profile',
            ACTIVE_SCHEDULE: 'Active',
            UNHEALTHY: 'Unhealthy',
            UNKNOWN: 'Unknown',
            HEALTHY: 'Healthy',
            TOTAL: 'Total',
            SEARCH: 'Search',
            SUMMARY: 'Summary',
            CONTROLS: 'Controls',
            SYNC: 'Sync',
            LAST_SYNC: 'Last Synced',
            NEW_DEVICE: 'New Device',
            MIN_AGO: 'm ago',
            HOUR_AGO: 'h ago',
            TODAY_AT: 'Today at',
            EDIT_ZONE_DETAILS: 'Edit Zone Details',
            DELETE_ZONE: 'Delete Zone',
            ADD_DEVICES: 'Add Devices',
            NO_DEVICES_LABEL: 'No Device Have Been Added',
            ADD_DEVICES_INSTRUCTION: 'Add devices via Bluetooth.',
            OVERGEATING_PROTECTION: 'Overheating Protection',
            OVERGEATING_PROTECTION_DETAIL: 'Dim the light to avoid over heating the device',
            HIGH_TRIM: 'High Trim',
            HIGH_TRIM_DETAILS: 'Maximum allowable brightness',
            BRIGHTNESS_LEVEL: 'Brightness Level',
            BRIGHTNESS_LEVELS: 'Brightness Level',
            LEVEL: 'Level',
            TIME_PERIOD: 'Schedule',
            TIME: 'Time',
            DAY_OF_WEEK: 'Day Of Week',
            ALL_OKAY: 'All OK',
            UNABLE_TO_RETRY: 'Unable to Retry, Please Try after 5 minutes',
            MESH_LIMIT_TITLE: 'Mesh Device Limit Reached',
            MESH_LIMIT_FULL_BODY: 'This mesh has reached its maximum capacity of {{max}} devices.',
            MESH_LIMIT_FULL_WITH_SUBSCRIPTION:
                'This mesh has reached its maximum capacity of {{max}} devices. Your subscription still has available capacity — create a new mesh to continue adding devices.',
            MESH_LIMIT_REMAINING_TITLE: 'Selection Limit Reached',
            MESH_LIMIT_REMAINING_BODY:
                'This mesh can only accommodate {{remaining}} more device(s). Please reduce your selection to continue.',
            CREATE_NEW_MESH: 'Create New Mesh',
            ZONE_CREATE_SUCCESSFULLY: ' has been added successfully.',
            ZONE_UPDATE_SUCCESSFULLY: ' has been updated successfully.',
            MESH_RTC_UPDATE_SUCCESSFULLY: 'RTC set successfully.',
            DELETE_ZONE_QUESTION: 'Delete Zone?',
            DELETE_ZONE_SUCCESSFULLY: ' deleted successfully',
            HOUR: 'Hour',
            MINUTES: 'Minutes',
            SET_TIMER: 'Set Timer',
            MANUAL_DIMMING: 'Manual Dimming',
            START_TIME: 'Start Time',
            MIN: 'Min',
            MAX: 'Max',
            END_TIME: 'End Time',
            DELETE_ZONE_WITH_DEVICES_ERROR:
                'Zone cannot be deleted if it has devices under it. To delete the zone, you need to delete all devices under this zone first.',
            DELETE_CONFIRM_MESSAGE:
                'The {{zoneName}} and its data will be permanently deleted. To proceed, type "<b>delete</b>" in the text box below and select the \'Delete\' button.',
            ALL_DAY_OF_WEEK: 'All Days of Week',
            WHEN_ZONE_OCCUPIED: 'When Zone Occupied',
            WHEN_ZONE_NOT_OCCUPIED: 'When Zone Not Occupied',
            FIXTURE_FILTER: {
                TYPE: 'Type',
                SORT: 'Sort',
                SORT_ASC: 'Sort Ascending (A → Z)',
                SORT_DESC: 'Sort Descending (Z → A)',
                OPTION_A11Y: 'Option {{label}}',
            },
            TIME_REMAINING_AT: 'time remaining at',
            DIMMING_LEVEL: 'dimming level',
            ALL_TIME: 'All Time',
            OCCUPANCY_ONLY_MODE_INFO:
                'Occupancy mode is enabled. Light levels are controlled based on occupancy detection.',
            OCCUPANCY_DETECTION_MODE_DESCRIPTION: 'Set Min & Max brightness level based on detected motion.',
            OCCUPANCY_DETECTION: 'Occupancy Detection',
            ZONE_SUMMARY_CONTAINER_ACCESSIBILITY_LABEL: 'Zone Summary Container',
            ZONE_SUMMARY_CONTAINER_ACCESSIBILITY_HINT: 'Main container for zone summary content',
            SCHEDULE_INFORMATION_SECTION_ACCESSIBILITY_LABEL: 'Schedule Information Section',
            SCHEDULE_INFORMATION_SECTION_ACCESSIBILITY_HINT: 'Contains schedule details and manual dimming information',
            STICKY_HEADER_SECTION_ACCESSIBILITY_LABEL: 'Sticky Header Section',
            STICKY_HEADER_SECTION_ACCESSIBILITY_HINT: 'Contains search controls',
            SEARCH_FILTER_SECTION_ACCESSIBILITY_LABEL: 'Search and Filter Section',
            SEARCH_FILTER_SECTION_ACCESSIBILITY_HINT: 'Contains search bar and multi-select controls',
            SEARCH_BAR_ACCESSIBILITY_LABEL: 'Search devices',
            SEARCH_BAR_ACCESSIBILITY_HINT: 'Search devices by name or identifier',
            TOGGLE_SELECT_ALL_ACCESSIBILITY_HINT: 'Toggles selection of all items',
            SELECT_ALL_ICON_ACCESSIBILITY_LABEL: 'Select All Icon',
            SELECT_ALL_ICON_ACCESSIBILITY_HINT: 'Indicates the select all action',
            CANCEL_SELECTION_ACCESSIBILITY_LABEL: 'Cancel Selection',
            CANCEL_SELECTION_ACCESSIBILITY_HINT: 'Cancels multi-select mode and clears all selections',
            DELETE_SELECTED_DEVICES_ACCESSIBILITY_LABEL: 'Delete Selected Devices',
            DELETE_SELECTED_DEVICES_ACCESSIBILITY_HINT: 'Deletes {{count}} selected devices from the zone',
            EMPTY_ZONE_STATE_ACCESSIBILITY_LABEL: 'Empty Zone State',
            EMPTY_ZONE_STATE_ACCESSIBILITY_HINT: 'No devices found in this zone, shows add device option',
            NO_DEVICES_EMPTY_STATE_ACCESSIBILITY_LABEL: 'No Devices Empty State',
            NO_DEVICES_EMPTY_STATE_ACCESSIBILITY_HINT:
                'Displays message and add device button when no devices are in zone',
            ADD_DEVICE_TO_ZONE_ACCESSIBILITY_LABEL: 'Add Device to Zone',
            ADD_DEVICE_TO_ZONE_ACCESSIBILITY_HINT: 'Navigate to device scanning screen to add new devices',
            DEVICE_LIST_CONTENT_ACCESSIBILITY_LABEL: 'Device List Content',
            DEVICE_LIST_CONTENT_ACCESSIBILITY_HINT: 'Main content area containing device list or empty state',
            DEVICE_LIST_CONTAINER_ACCESSIBILITY_LABEL: 'Device List Container',
            DEVICE_LIST_CONTAINER_ACCESSIBILITY_HINT: 'Contains filtered device list or no results message',
            NO_SEARCH_RESULTS_ACCESSIBILITY_LABEL: 'No Search Results',
            NO_SEARCH_RESULTS_ACCESSIBILITY_HINT: 'No devices match the current search or filter criteria',
            NO_SEARCH_RESULTS_MESSAGE_ACCESSIBILITY_LABEL: 'No Search Results Message',
            NO_SEARCH_RESULTS_MESSAGE_ACCESSIBILITY_HINT:
                'Displays message when search or filter returns no matching devices',
            DEVICE_LIST_ACCESSIBILITY_LABEL: 'Device List',
            DEVICE_LIST_ACCESSIBILITY_HINT: 'List of {{count}} devices in this zone',
            HEALTH_STATUS_ACCESSIBILITY_HINT: 'Shows {{count}} {{status}} devices',
            HEALTH_STATUS_ACCESSIBILITY_LABEL: '{{status}} devices',
            BRIGHTNESS_VALUE_ACCESSIBILITY_LABEL: 'Brightness {{value}}',
            TIME_RANGE_ACCESSIBILITY_LABEL: 'Time {{startHour}}:{{startMinute}} to {{endHour}}:{{endMinute}}',
            BRIGHTNESS_LEVEL_ACCESSIBILITY_LABEL: 'Brightness {{value}}',
            BRIGHTNESS_LEVEL_AXIS_LABEL: 'Brightness Level',
            APPLY_BUTTON_VIEW_ACCESSIBILITY_LABEL: 'Apply Button Container',
            APPLY_BUTTON_VIEW_ACCESSIBILITY_HINT: 'Container for apply and reset filter actions',
            APPLY_BUTTON_ACCESSIBILITY_LABEL: 'Apply Filters',
            APPLY_BUTTON_ACCESSIBILITY_HINT: 'Applies the selected filter and sort options',
            RESET_BUTTON_ACCESSIBILITY_LABEL: 'Reset Filters',
            RESET_BUTTON_ACCESSIBILITY_HINT: 'Clears selected filter and sort options',
            DELETE_DEVICE_ACCESSIBILITY_LABEL: 'Delete Device',
            BLINK_DEVICE_ACCESSIBILITY_LABEL: 'Blink Device',
            SELECT_DEVICE_ACCESSIBILITY_LABEL: 'Select Device',
            UNSELECT_DEVICE_ACCESSIBILITY_LABEL: 'Unselect Device',
            TOTAL_DEVICES_ACCESSIBILITY_LABEL: 'Total Devices',
            TOTAL_DEVICES_ACCESSIBILITY_HINT: 'Shows total number of devices',
            DEFAULT_PROFILE: 'Default Profile',
            CURRENT_SCHEDULE: 'current schedule',
        },
        ADD_ZONE: {
            SCREEN_ACCESSIBILITY_LABEL: 'Add Zone Screen',
            ACTION_BUTTONS_ACCESSIBILITY_LABEL: 'Add Zone Action Buttons',
            UPDATE_ZONE_SCREEN_ACCESSIBILITY_LABEL: 'Update Zone Screen',
            UPDATE_ZONE_SCREEN_ACCESSIBILITY_HINT:
                'Main screen for editing zone configuration with input fields and action buttons',
            UPDATE_ZONE_ACTION_BUTTONS_ACCESSIBILITY_LABEL: 'Action Buttons',
            UPDATE_ZONE_ACTION_BUTTONS_ACCESSIBILITY_HINT:
                'Buttons to save changes or cancel the zone update operation',
            UPDATE_ZONE_BUTTONS_STATE_DISABLED: 'Disabled',
            UPDATE_ZONE_BUTTONS_STATE_ENABLED: 'Enabled',
            EDIT_ZONE_ACTION_BUTTONS_ACCESSIBILITY_LABEL: 'Edit Zone Action Buttons',
            EDIT_ZONE_ACTION_BUTTONS_ACCESSIBILITY_HINT: 'Container with save zone and cancel buttons for form actions',
            MESH_INPUT_ACCESSIBILITY_LABEL: 'Mesh Input Container',
            MESH_INPUT_ACCESSIBILITY_HINT: 'Container for mesh text input',
            SCHEDULE_INPUT_ACCESSIBILITY_LABEL: 'Schedule Input Container',
            TEXT_INPUT_CONTAINER_ACCESSIBILITY_LABEL: 'Text Input Container',
            TEXT_INPUT_CONTAINER_ACCESSIBILITY_HINT: 'Container for text inputs',
            INPUT_HELPER_ACCESSIBILITY_LABEL: 'Input Helper Information',
            INPUT_HELPER_ACCESSIBILITY_HINT: 'Contains character count information for zone name field',
            ZONE_NAME_ERROR_ACCESSIBILITY_LABEL: 'Zone Name Error',
            ZONE_NAME_ERROR_ACCESSIBILITY_HINT: 'Validation error message for zone name field',
            CHARACTER_COUNT_ACCESSIBILITY_LABEL: 'Character Count: {{current}} of {{max}} characters used',
            CHARACTER_COUNT_ACCESSIBILITY_HINT: 'Shows current character count for zone name input field',
            EDIT_FIELDS_REQUIRED_ACCESSIBILITY_HINT: 'Section title indicating required fields for zone editing',
            SELECTED_MESH_ACCESSIBILITY_HINT: 'Selected mesh network for this zone',
            ZONE_NAME_INPUT_WRAPPER_ACCESSIBILITY_LABEL: 'Zone Name Input Wrapper',
            ZONE_NAME_INPUT_WRAPPER_ACCESSIBILITY_HINT: 'Container for zone name input field and validation messages',
            SELECT_AN_OPTION: 'Select an option',
            DONE_ACCESSIBILITY_LABEL: 'Done',
            SCHEDULE_SELECTOR_ACCESSIBILITY_LABEL: 'Select schedule',
            ADD_ZONE_HEADER: 'Add Zone',
            EDIT_ZONE_HEADER: 'Edit Zone',
            ZONE_ADDED_HEADER: 'Zone Added',
            FIELDS_REQUIRED: 'Fields marked with an asterisk(*) are required when adding a Zone',
            EDIT_FIELDS_REQUIRED: 'Fields marked with an asterisk(*) are required when editing a Zone.',
            MIC_BLE_MESH: 'Eaton BLE Mesh*',
            SCHEDULE: 'Schedule*',
            ZONE_NAME: 'Zone Name*',
            SETTINGS: 'Settings',
            OVERHEATING_PROTECTION: 'Overheating Protection',
            OVERHEATING_INFO: 'Dim the light to avoid overheating the device',
            VIRTUAL_SENSING: 'Virtual Sensing',
            VIRTUAL_SENSING_INFO: 'Virtual Sensing allows this device’s sensor to speak with the entire group.',
            HIGH_TRIM: 'High Trim',
            HIGH_TRIM_INFO: 'Maximum allowable brightness',
            ADD_ZONE_BUTTON: 'Add Zone',
            EDIT_ZONE_BUTTON: 'Save Zone',
            CANCEL_BUTTON: 'Cancel',
            ZONE_NAME_REQUIRED: 'Zone Name is required',
            HIGH_TRIM_REQUIRED: 'High Trim value is required',
            HIGH_TRIM_INVALID: 'High Trim must be a number between 0 and 100',
            ZONE_SUCCESS: '‘{{text}}’ was added successfully.',
            ZONE_SUCCESS_INFO: 'Continue by adding devices to this zone. Tap “Later” if done.',
            ADD_DEVICES: 'Add Devices',
            LATER: 'Later',
            ZONE_CREATE_FAILED: 'Zone creation failed',
            EMPTY_VALUE: 'Empty',
            NOT_SELECTED: 'Not selected',
            DEFAULT_MESH: 'Default Mesh',
            NO_DEVICES_CONTROL_PROFILE_UPDATE: 'Control profile cannot be updated when no devices are present',
        },
        PROVISIONING_CONFIGURATION: {
            FAILED: 'Failed',
            PENDING: 'Pending',
            DEVICE_ADDED: 'Device Added',
            PROCESS_COMPLETED: 'Process Complete',
            LIGHT_FAILED: '{{count}} Light Failed to connect',
            LIGHTS_FAILED: '{{count}} Lights Failed to connect',
            DEVICE_FAILED: '{{count}} Device failed to connect',
            DEVICES_FAILED: '{{count}} Devices failed to connect',
            ADDING_LIGHT: 'Adding Devices',
            DEVICE_SUCCESS: '{{count}} Light Successfully Added.',
            INFO: 'You can retry again to add these lights\nPlease ensure you are within range of\nthe device.',
            RETRY: 'Retry',
            PROCEED_WITHOUT_LIGHT: 'Proceed Without Failed Lights',
            ENSURE: 'Please Ensure the Following:',
            ENSURE_TEXT_ONE: '• In range of BLE Mesh Network',
            ENSURE_TEXT_TWO: '• Cloud connected',
            ENSURE_TEXT_THREE: '• Remain on page',
            ENSURE_TEXT_FOUR: '• Battery is at least 20%',
            ESTIMATED_TIME: 'Estimated time remaining: {{time}}',
            NOSHOW: 'Don’t Show Again',
            DISMISS: 'Dismiss',
            ENSURE_CONTENT:
                'This mobile device must remain connected to the cloud and within range of BLE mesh network. Ensure Mobile phone battery is greater than 20%. Do not minimize the app, or use other app, while any execution is in progress.',
            SEND_DATA: 'Sending to cloud',
            SCAN_DEVICE_AFTERWARDS: 'Please scan and add these devices again after 5 minutes.',
            PROGRESS_BAR_ACCESSIBILITY: 'Progress bar',
            UNKNOWN_DEVICE: 'Unknown Device',
        },
        MESH_ACTIVITY: {
            STAY_IN_PLACE: 'Stay In Place',
            REFRESH: 'Refresh',
            CANCEL: 'Cancel',
            WEAK_CONNECTION: 'Weak Connection',
            CHECKING_BLUETOOTH: 'Checking Bluetooth',
            CHECKING_BLUETOOTH_CONNECTION: 'Check Bluetooth connection',
            BLUETOOTH_CONNECTION_STABLE: 'Bluetooth connection stable',
            BLUETOOTH_CONNECTION_FAILED: 'Bluetooth Connection Failed',
            UNABLE_TO_CONNECT_BLUETOOTH: 'Unable to connect to Bluetooth',
            BLUETOOTH_SETTINGS_MESSAGE:
                'Ensure Bluetooth is enabled and the mobile app is granted Bluetooth access in phone settings.',
            RETRY: 'Retry',
            ESTABLISHING_CONNECTION: 'Establishing Connection',
            CONNECTION_FAILED: 'Connection Failed',
            ESTABLISH_DEVICE_CONNECTION: 'Establish device connection',
            DEVICE_CONNECTION_ESTABLISHED: 'Device connection established',
            UNABLE_TO_ESTABLISH_CONNECTION: 'Unable to establish device connection',
            MOVE_CLOSER_MESSAGE:
                'Move closer to the device and try again. If it keeps failing, try moving closer to another device in the same Mesh / Zone.',
            MESH_COMMAND_REQUESTED: 'Mesh Command Requested',
            STAY_IN_FIXED_POSITION:
                'A mesh command has been requested. Stay in a fixed position until the request is complete.',
            ESTIMATED_TIME_15_30: 'The scan will take an estimated 15-30 seconds depending on the size of the Mesh.',
            REMAIN_NEAR_BLUETOOTH_MESH: 'This mobile device must remain near the Bluetooth mesh.',
            REQUEST_COMPLETED: 'Request Completed',
            REQUEST_FAILED: 'Request Failed',
            CONNECTION_FAILURE: 'Connection Failure',
            PROFILE_SYNC:
                ' The device was unable to connect at this time. Please wait a few minutes  and try again or Sync your profile data.',
            CONNECTING_BLUETOOTH_DEVICE: 'Connecting to Bluetooth Device',
            OK: 'Ok',
            WEAK_CONNECTION_TEXT_DELAYED: 'This device must stay close to the Bluetooth Mesh.',
            WEAK_CONNECTION_TEXT:
                'This request is taking longer than expected. Please move closer to the device you need and try again',
            FIXED_POSITION: 'This mobile device must remain connected to the Bluetooth Mesh',
            CONTINUE: 'Continue',
            ESTIMATED_TIME:
                'You have requested a Mesh Command. Please stay in place while the scan is in progress. It should take an estimated 15-30 seconds.',
            ACTIVITY_COMPLETED: 'Mesh command successfully completed.',
            COMPLETING_YOUR_REQUEST: 'Completing Your Request',
            OPERATION_SUCCESS:
                'Operation getting success, next operation has been started, please be connected to the current Bluetooth Mesh..',
            ACTIVITY_FAILED: 'You have encountered an error during the activity.',
            MESH_UNAVAILABLE_TITLE: 'Mesh is unavailable',
            MESH_UNAVAILABLE_MESSAGE:
                'This mesh is currently unavailable or it is being used by another user, so you will not be able to perform this action at the moment.',
            LOCATION_UPDATED_TITLE: 'Location Updated',
            LOCATION_UPDATED_MESSAGE:
                'As the location has been updated, the daylight saving dates will be adjusted accordingly. Please proceed with the mesh operation.',
            BLUETOOTH_ACCESS_MESSAGE:
                'Ensure Bluetooth is enabled and the mobile app is granted Bluetooth access in phone settings.',
            DEVICE_CONNECTION_FAILED_MESSAGE:
                'Move closer to the device and try again. If it keeps failing, try moving closer to another device in the same Mesh / Zone.',
            COMMAND_CONFIRMATION_MESSAGE:
                'A mesh command has been requested. Stay in a fixed position until the request is complete. The scan will take an estimated 15-30 seconds depending on the size of the Mesh.',
            REMAIN_NEAR_MESH: 'This mobile device must remain near the Bluetooth mesh.',
            REQUEST_FAILED_TITLE: 'Request Failed',
        },
        FIXTURE_DETAILS: {
            FIXTURE_COMMANDS_TITLE: 'Commands',
            HOURS: 'hours',
            CONNECTED: 'CONNECTED',
            NOT_CONNECTED: 'NOT CONNECTED',
            FIXTURE_COMMANDS: {
                SUCCESS: 'Last Commands retrieved successfully',
            },
            SYNC_BUTTON_TITLE: 'Sync',
            FIXTURE_EDIT_DEVICE: 'Edit Device Name',
            FIXTURE_DELETE_DEVICE: 'Delete Device',
            FIXTURE_LIFE_CYCLE_MANAGEMENT: {
                TITLE: 'Life Cycle Management',
                SUBTITLE: '',
                SYNC_TO_FETCH: 'sync to fetch latest values',
                EFFECTIVE_DEVICE_HEALTH: 'Effective Device Health',
                DEVICE_NEAR_REPLACEMENT: 'Device Near Replacement',
                EFFECTIVE_DEVICE_HEALTH_DESCRIPTION:
                    'This device has {{percentage}}% of its effective device health left. Next service is projected to be on {{projectedServiceDate}}.',
                DEVICE_NEAR_REPLACEMENT_DESCRIPTION:
                    'This device has {{percentage}}% of its effective device health left. Next replacement is projected to be on {{projectedServiceDate}}.',
                EFFECTIVE_DEVICE_HEALTH_ALERT_DESCRIPTION:
                    'This device has {{percentage}}% of its effective device health remaining. Effective device health is a calculation based on operating environment, device in service, and many other factors. It gives you a prediction of when the device should be serviced. Operating beyond its designed environment will deplete its health faster. \n\nWe recommend replacing your device periodically. ',
                DEVICE_IN_SERVICE: 'Device in Service',
                DEVICE_IN_SERVICE_DESCRIPTION: 'Total time device is powered',
                LED_RUN_TIME: 'LED Run Time',
                LED_RUN_TIME_DESCRIPTION: 'Total time LED light is on',
            },
            FIXTURE_FIRMWARE: {
                TITLE: 'Firmware',
                SUBTITLE: '',
                SYNC_TO_FETCH: 'sync to fetch latest values',
                CURRENT_VERSION: 'Current Version',
                FALLBACK_VERSION: 'Application Fallback Version',
                MCU_BOOT_VERSION: 'MCU Boot Version',
                FALLBACK_MCU_BOOT_VERSION: 'Fallback MCU Boot Version',
            },
            FIRMWARE_PROPERTIES: {
                TITLE: 'Properties',
                BLE_MESH_COMMISSIONED: 'BLE Mesh Commissioned On',
                DEVICE_CATALOG_NAME: 'Device Catalog Name',
                DEVICE_SERIAL_NUMBER: 'Device Serial Number',
                DRIVER_SERIAL_NUMBER: 'Driver Serial Number',
                MAC_ADDRESS: 'MAC Address',
                MIC_SERIAL_NUMBER: 'MIC Serial Number',
            },
            FIXTURE_CONTROLS: {
                TITLE: 'Sensors',
                SUBTITLE: '',
                SYNC_TO_FETCH: 'sync to fetch latest values',
                DETECT_OCCUPANCY: 'Detect Occupancy',
                DETECT_OCCUPANCY_DESCRIPTION: 'Cannot be disabled',
                DETECT_BRIGHTNESS: 'Detect Brightness',
                DETECT_BRIGHTNESS_DESCRIPTION: 'Required for daylight harvesting \nCannot be disabled',
                DETECT_TEMPERATURE: 'Detect Temperature',
                DETECT_TEMPERATURE_DESCRIPTION: 'Cannot be disabled',
                VIRTUAL_SENSING: 'Virtual Sensing',
                VIRTUAL_SENSING_DESCRIPTION: 'Virtual Sensing enables this sensor to communicate with the entire zone.',
                VIRTUAL_SENSING_ENABLED: 'Virtual Sensing enabled',
                VIRTUAL_SENSING_DISABLED: 'Virtual Sensing disabled',
                OVERHEATING_PROTECTION: 'Overheating Protection',
                OVERHEATING_PROTECTION_DESCRIPTION: 'Dim the light to avoid over heating the device',
                OVERHEATING_PROTECTION_ENABLED: 'Overheating Protection enabled',
                OVERHEATING_PROTECTION_DISABLED: 'Overheating Protection disabled',
                HIGH_TRIM: 'High Trim',
                HIGH_TRIM_DESCRIPTION: 'Maximum allowable brightness',
            },
            FIXTURE_EVENTS: {
                TITLE: 'Diagnostics',
                SUBTITLE: '',
                SYNC_TO_FETCH: 'sync to fetch latest values',
                TOTAL_EVENTS: 'Only the last 10 events are listed.',
                NO_DIAGNOSTIC_EVENTS: 'No diagnostic events recorded. Sync to fetch the latest device status.',
                ERROR_STATUS_WORD_SUCCESS: 'Diagnostics retrieved successfully',
                RTC_TITLE: 'Get RTC',
                RTC_SUBTITLE: 'Sync to fetch current RTC',
                RTC_CURRENT_TIME: 'Current RTC: {{time}}',
                RTC_SUCCESS: 'RTC retrieved successfully',
                RTC_PARSE_FAILED: 'Failed to parse RTC data',
            },
            FIXTURE_SUMMARY: {
                VIEW_ALL_DETAILS: 'View All Device Details',
                MAJOR_EVENTS: 'Major Events',
                HEALTH_STATUS: 'Health',
                UP_TO_DATE: 'Up To Date',
                FIRMWARE_VERSION: 'Firmware Version',
                NO_EVENTS: 'No Events',
                OPERATION: 'Operation',
                ERROR: 'Error',
                DEVICE_NEAR_REPLACEMENT: 'Device Near Replacement',
                DEVICE_NEAR_REPLACEMENT_DESCRIPTION:
                    'Device health is at {{percentage}}%. Next replacement is projected to be on {{projectedServiceDate}}.',
            },
            FIXTURE_TRENDS: {
                BY_TIME: 'By Time',
                BY_DEVICE_RUNTIME: 'By Device Runtime',
                BACKEND_TIMEOUT: 'Backend Timeout',
                BACKEND_TIMEOUT_DESCRIPTION:
                    'The channels API is not responding. The backend service may be overloaded.',
                RETRY: 'Retry',
                LOADING: 'Loading trend data...',
                NO_DATA: 'No Data Available',
                NO_DATA_DESCRIPTION: 'No trend data available for the selected date range.',
                NO_DATA_HINT: 'Try selecting a different date range or parameters.',
                SHIFT_DATE_LEFT_ACCESSIBILITY: 'Previous date range',
                SHIFT_DATE_RIGHT_ACCESSIBILITY: 'Next date range',
                POWER: 'Power',
                VOLTAGE: 'Voltage',
                CURRENT: 'Current',
                AMBIENT_TEMPERATURE: 'Ambient Temperature',
                DRIVER_INTERNAL_TEMPERATURE: 'Driver Internal Temperature',
                LED_RUN_TIME: 'LED Run Time',
                DEVICE_HOURS_IN_SERVICE: 'Device Hours in Service',
            },
            LAST_RECEIVED_COMMANDS: {
                RSSI: 'RSSI -',
                OPCODE: 'Opcode -',
                SNR_VALUE: 'SNR value -',
                DEVICE_HOURS_IN_SERVICE: 'Device in Service -',
                SOURCE: 'Source address -',
                DESTINATION: 'Destination address -',
            },
        },
        VIEW_COPY_SCHEDULE: {
            FINISH: 'Finish',
            MODEL_STEP_1_HEADER: 'Custom Dimming Schedule',
            MODEL_STEP_1_SUB_HEADER: 'Select the creation method.',
            NEW_SCHEDULE: 'Create a New Schedule',
            NEW_SCHEDULE_DESCRIPTION: 'Manually configure schedule',
            COPY_SCHEDULE: 'Copy an Existing Schedule',
            COPY_SCHEDULE_DESCRIPTION: 'Duplicate dimming schedule from existing list',
            NEW_SCHEDULE_TITLE: 'New Schedule',
            MANUAL_OVERRIDE: 'Manually Override Dimming',
            MANUAL_OVERRIDE_ACTIVE: 'Manually Override Dimming - Active',
            LOADING_SCHEDULES: 'Loading schedules...',
            ERROR_LOADING_SCHEDULES: 'Failed to load schedules. Please try again.',
            NO_SCHEDULES_AVAILABLE: 'No schedules Available',
            CREATE_FROM_EXISTING: 'Create from Existing',
            CONTROL_PROFILE: 'Control Profile',
            CREATE_CONTROL_PROFILE: 'Create Control Profile',
            CREATE_FROM_EXISTING_PROFILE: 'Create from existing control profile',
            DUPLICATE_EXISTING_PROFILE: 'Duplicate an existing control profile.',
            COPY_SECTION_ACCESSIBILITY_LABEL: 'Create from existing control profile',
            DUPLICATE_OPTION_ACCESSIBILITY_LABEL: 'Duplicate an existing control profile',
            DUPLICATE_OPTION_ACCESSIBILITY_HINT: 'Option 1 in create from existing control profile',
            DUPLICATE_RADIO_ACCESSIBILITY_LABEL: 'Duplicate an existing control profile radio button',
            UPDATE_LIGHT_MODE: 'Update Light Mode',
            SELECT_LIGHT_MODE: 'Select Light Mode',
            PHOTO_CONTROL: 'Photo Control',
            PHOTO_CONTROL_ONLY: 'Photo Control Only',
            PHOTO_CONTROL_ONLY_DESC: 'Set Min & Max brightness level based on ambient light.',
            PHOTO_CONTROL_OCCUPANCY: 'Photo Control + Occupancy',
            PHOTO_CONTROL_OCCUPANCY_DESC: 'Set min and max brightness based on ambient light and detected motion.',
            TIME_SCHEDULE: 'Time Schedule',
            TIME_SCHEDULE_ONLY: 'Time Schedule Only',
            TIME_SCHEDULE_ONLY_DESC: 'Set brightness level based on time of day.',
            TIME_SCHEDULE_OCCUPANCY: 'Time Schedule + Occupancy',
            TIME_SCHEDULE_OCCUPANCY_DESC: 'Set brightness level based on time of day and detected motion.',
            OCCUPANCY_DETECTION: 'Occupancy Detection',
            OCCUPANCY_DETECTION_ONLY: 'Occupancy Detection Only',
            OCCUPANCY_DETECTION_ONLY_DESC: 'Set brightness level based on detected motion.',
            LIGHT_MODE_MODAL_ACCESSIBILITY_HINT: 'Modal for selecting light mode',
            LIGHT_MODE_MODAL_ACCESSIBILITY_LABEL: 'Light Mode Selection Modal',
            SCHEDULE_MODAL_ACCESSIBILITY_HINT: 'Modal for selecting and confirming a schedule',
            SCHEDULE_MODAL_ACCESSIBILITY_LABEL: 'Schedule Selection Modal',
            MODAL_OVERLAY_ACCESSIBILITY_HINT: 'Overlay background for the modal',
            MODAL_OVERLAY_ACCESSIBILITY_LABEL: 'Modal Overlay',
            MODAL_CONTENT_ACCESSIBILITY_HINT: 'Container holding modal content',
            MODAL_CONTENT_ACCESSIBILITY_LABEL: 'Modal Content Container',
            CLOSE_MODAL_ACCESSIBILITY_HINT: 'Close modal',
            SCROLLABLE_CONTENT_ACCESSIBILITY_HINT: 'Scrollable content area',
            CONTENT_AREA_ACCESSIBILITY_LABEL: 'Content Area',
            FOOTER_ACTION_ACCESSIBILITY_HINT: 'Footer section with action button',
            FOOTER_CONTAINER_ACCESSIBILITY_LABEL: 'Footer Container',
            UPDATE_LIGHT_MODE_ACCESSIBILITY_HINT: 'Update light mode selection',
            NEXT_BUTTON_ACCESSIBILITY_HINT: 'Continue to next step',
            UNNAMED_SCHEDULE: 'Unnamed schedule',
        },
        SCHEDULE_PROFILE: {
            SAVE_AND_ACTIVATE: 'Save and Activate',
            SAVE_AND_APPLY_CHANGES: 'Save & Apply Changes',
            NOTES: 'Notes (Optional)',
            OCCUPANCY_DETECTION: 'Occupancy Detection',
            WAIT_TIME: 'Wait Time',
            DLH: 'Daylight Harvesting Mode',
            DAYLIGHT_HARVESTING: 'Daylight Harvesting',
            GAIN_VALUE: 'Sensitivity',
            PHOTOCELL: 'Photo Cell Based Dimming',
            TARGET_LIGHT: 'Target Light',
            TG_INGO: '1 fc to 100 fc',
            MIN_MAX: 'Min and Max Dimming with Ambient Light',
            PHOTO_CONTROL: 'Photo Control',
            WAIT_TIME_INFO: 'Wait Time (From 2 to 10)',
            SCHEDULE_NAME: 'Schedule Name',
            TIME_SCHEDULE: 'Time Scheduling Dimming',
            LIGHT_MODE: 'Light Mode',
            TIME_SCHEDULE_ONLY: 'Time Schedule Only',
            TIME_SCHEDULE_OCCUPANCY: 'Time Schedule + Occupancy',
            PHOTO_CONTROL_OCCUPANCY: 'Photo control + Occupancy',
            PHOTO_CONTROL_ONLY: 'Photo Control Only',
            OCCUPANCY_DETECTION_ONLY: 'Occupancy Detection',
            TIME_SCHEDULING: 'Time Scheduling',
            OCCUPANCY_DETECTION_WAIT_TIME: 'Occupancy Detection Wait time',
            PHOTO_CONTROL_WAIT_TIME: 'Photo Control Wait Time',
            PHOTO_CONTROL_SECTION_ACCESSIBILITY_LABEL: 'Photo control section header',
            PHOTO_CONTROL_SECTION_ACCESSIBILITY_HINT: 'Contains light mode title and target light information',
            HEADER_CONTENT_ACCESSIBILITY_LABEL: 'Header content',
            LIGHT_MODE_TITLE_ACCESSIBILITY_LABEL: 'Light mode title',
            LIGHT_MODE_TITLE_ACCESSIBILITY_HINT: 'Shows the current light control mode type',
            TARGET_LIGHT_ACCESSIBILITY_LABEL: 'Target light: {{value}}',
            TARGET_LIGHT_ACCESSIBILITY_HINT: 'Displays the target light level for photo control',
            NOT_SET: 'Not set',
            HIGH_TRIM_ACCESSIBILITY_HINT: 'Input for high trim percentage',
            BRIGHTNESS_SLIDER_ACCESSIBILITY_LABEL: '{{mode}} brightness slider, level {{value}} percent',
            OCCUPIED_BRIGHTNESS_MODE: 'Occupied',
            NOT_OCCUPIED_BRIGHTNESS_MODE: 'Not occupied',
            DAY_BRIGHTNESS_MODE: 'Day',
            NIGHT_BRIGHTNESS_MODE: 'Night',
            DAY_NOT_OCCUPIED_BRIGHTNESS_MODE: 'Day when not occupied',
            NIGHT_NOT_OCCUPIED_BRIGHTNESS_MODE: 'Night when not occupied',
            ENTER_SETTING_ACCESSIBILITY_HINT: 'Enter {{title}}',
            TOGGLE_SETTING_ACCESSIBILITY_HINT: 'Toggle {{title}}',
            OPTION_ACCESSIBILITY_HINT: 'Option {{position}} in {{title}}',
            RADIO_OPTION_ACCESSIBILITY_LABEL: '{{title}} radio button',
            ZONE_OCCUPIED_STATE_INFO: 'Zone occupied state information',
            ZONE_NOT_OCCUPIED_STATE_INFO: 'Zone not occupied state information',
            OCCUPIED_BRIGHTNESS_HINT: 'Brightness level when zone has occupancy',
            NOT_OCCUPIED_BRIGHTNESS_HINT: 'Brightness level when zone has no occupancy',
            ADJUST_OCCUPIED_BRIGHTNESS: 'Adjust brightness when zone is occupied',
            ADJUST_NOT_OCCUPIED_BRIGHTNESS: 'Adjust brightness when zone is not occupied',
            ADJUST_DAYTIME_BRIGHTNESS: 'Adjust brightness level during daytime',
            ADJUST_NIGHTTIME_BRIGHTNESS: 'Adjust brightness level during nighttime',
            PHOTO_CONTROL_NOT_OCCUPIED_STATE: 'Photo control - not occupied state',
            NOT_OCCUPIED_UNOCCUPIED_LEVELS: 'Day and night brightness levels for unoccupied state',
            ADJUST_DAY_UNOCCUPIED_BRIGHTNESS: 'Adjust day brightness when zone is unoccupied',
            ADJUST_NIGHT_UNOCCUPIED_BRIGHTNESS: 'Adjust night brightness when zone is unoccupied',
            PHOTO_CONTROL_WITH_OCCUPANCY_OCCUPIED: 'Photo control with occupancy - occupied state',
            OCCUPIED_DAY_NIGHT_LEVELS: 'Day and night brightness levels for occupied state',
            FULL_BRIGHTNESS_TIME_SYNC_LOST: 'Full brightness when time sync is lost',
            TARGET_LIGHT_VALUE: '10 fc',
            FULL_BRIGHTNESS_EMERGENCY_HELP: 'Helpful during emergency evacuations',
            MIN_BRIGHTNESS_LEVEL: 'Min. Brightness Level',
            HIGH_TRIM: 'High Trim',
            OVERHEATING_PROTECTION: 'Overheating Protection',
            SCHEDULE_NAME_REQUIRED: 'Schedule name is required.',
            WAIT_TIME_REQUIRED: 'Occupancy Detection Wait time is required.',
            WAIT_TIME_INVALID_NUMBER: 'Please enter a valid number.',
            WAIT_TIME_MIN_RANGE: 'Occupancy Detection Wait time must be at least 2 minutes.',
            WAIT_TIME_MAX_RANGE: 'Occupancy Detection Wait time cannot exceed 60 minutes.',
            DAYLIGHT_HARVESTING_REQUIRED: 'Daylight harvesting value is required.',
            DAY: 'Day',
            NIGHT: 'Night',
            TARGET_LIGHT_REQUIRED: 'Target light is required.',
            TARGET_LIGHT_LOW: 'Low',
            TARGET_LIGHT_MIN: 'Min',
            TARGET_LIGHT_TYPICAL: 'Typical',
            TARGET_LIGHT_MAX: 'Max',
            TARGET_LIGHT_HIGH: 'High',
            GAIN_VALUE_MIN: 'Min',
            GAIN_VALUE_TYPICAL: 'Typical',
            GAIN_VALUE_MAX: 'Max',
            PHOTO_CONTROL_WAIT_TIME_REQUIRED: 'Photo control wait time is required.',
            PHOTO_CONTROL_WAIT_TIME_RANGE: 'Photo control wait time must be between 120 and 3600.',
            PHOTO_WAIT_TIME_REQUIRED: 'Photo wait time is required.',
            HIGH_TRIM_REQUIRED: 'High Trim value is required.',
            HIGH_TRIM_INVALID_NUMBER: 'High Trim must be a valid number.',
            HIGH_TRIM_INVALID_RANGE: 'High Trim must be between 0 and 100.',
            FULL_BRIGHTNESS_REQUIRED: 'Full brightness setting is required.',
            OTP_REQUIRED: 'Overheating protection setting is required.',
            VIRTUAL_SENSING_REQUIRED: 'Virtual sensing setting is required.',
            MIN_BRIGHTNESS_REQUIRED: 'Minimum brightness is required.',
            MIN_BRIGHTNESS_INVALID_NUMBER: 'Minimum brightness must be a valid number.',
            MIN_BRIGHTNESS_INVALID_RANGE: 'Minimum brightness must be between 0 and 100.',
            ZONE_OCCUPIED_REQUIRED: 'Zone occupied brightness is required.',
            ZONE_OCCUPIED_INVALID_NUMBER: 'Zone occupied brightness must be a valid number.',
            ZONE_OCCUPIED_INVALID_RANGE: 'Zone occupied brightness must be between 0 and 100.',
            ZONE_NOT_OCCUPIED_REQUIRED: 'Zone not occupied brightness is required.',
            ZONE_NOT_OCCUPIED_INVALID_NUMBER: 'Zone not occupied brightness must be a valid number.',
            ZONE_NOT_OCCUPIED_INVALID_RANGE: 'Zone not occupied brightness must be between 0 and 100.',
            DAYLIGHT_HARVESTING_INVALID_RANGE: 'Daylight harvesting value must be between 10 and 200.',
            START_HOUR_REQUIRED: 'Start hour is required.',
            END_HOUR_REQUIRED: 'End hour is required.',
            NEXT_SCHEDULE_BRIGHTNESS_CHANGE: 'Next scheduled brightness change',
            NEXT_SCHEDULE_BRIGHTNESS_CHANGE_DESCRIPTION: 'Will switch back to {{scheduleName}} after schedule.',
            NEXT_SCHEDULE_BRIGHTNESS_CHANGE_AFTER_TIMER_DESCRIPTION: 'Will switch back to {{scheduleName}} at ',
            NEW: ' New',
            AFTER: 'After',
            MANUAL_DIMMING_OVERRIDE_MESSAGE: 'Manual Dimming overrides brightness temporarily.',
            OVERRIDE_UNTIL: 'Override Until',
            MINUTES: 'Minutes',
            HOUR: 'Hour',
            SET_TIMER: 'Set Timer',
            TEMPORARILY_OVERRIDE: 'Temporarily override current schedule',
            TIME_REMAINING: 'Time Remaining',
            BRIGHTNESS: 'Brightness',
            END_NOW: 'End Now',
            SCHEDULED_TIME: 'Scheduled time',
            SET_TIMER_HELP_TEXT: 'Ensure the selected time is at least 2 minutes and does not exceed 8 hours.',
            MANUAL_DIMMING_12_HOURS: '12 Hours',
            MANUAL_DIMMING_FIXED_SESSION_DURATION_SECONDS: '43200',
            PROFILE_SUCCESS: 'Control profile created successfully.',
            PROFILE_UPDATE: 'Control profile updated successfully.',
            PROFILE_ERROR: 'Control profile creation failed.',
            PROFILE_SOMETHING_WENT_WRONG: 'Something went wrong while creating the control profile.',
            SUCCESS_TITLE: 'Success',
            PROFILE_SUCCESS_MESSAGE: 'Profile has been saved and activated successfully.',
            PROFILE_ACTIVATED: 'Profile has been activated successfully.',
            NO_CHANGES_DETECTED: 'No changes detected.',
            DUPLICATE_NAME_ERROR_TITLE: 'Duplicate Name',
            DUPLICATE_NAME_ERROR_MESSAGE: 'A profile with this name already exists. Please use a different name.',
            MIN_BRIGHTNESS_ALERT_TITLE: 'Brightness Conflict',
            MIN_BRIGHTNESS_ALERT_MESSAGE:
                'DLH min brightness level is {{minBrightnessValue}}%, but selected dimming is {{conflictingValue}}%.\n\nUpdate DLH brightness or ignore and keep dimming brightness {{conflictingValue}}%.',
            IGNORE: 'Ignore',
            UPDATE_BRIGHTNESS: 'Update Brightness',
            MANUAL_DIMMING_SUCCESS_MESSAGE: 'Manual Dimming has been successfully Applied.',
            MANUAL_DIMMING_FAILED_MESSAGE: 'Manual Dimming application failed',
            SCHEDULE_DETAILS_TITLE: 'Schedule Details',
            CREATE_SCHEDULE: 'Create Schedule',
            CREATE_CONTROL_PROFILE: 'Create Control Profile',
            PROTECTED_PROFILE_TITLE: 'Cannot Modify Protected Profile',
            PROTECTED_PROFILE_MESSAGE:
                'This control profile is protected and cannot be modified. Please create a new profile with your desired settings instead.',
            SAVE_PROFILE_FAILED: 'Failed to save the profile',
            NO_VALID_SCHEDULE_DATA: 'No valid schedule data available',
            OPTIONAL: 'Optional',
            NOTES_INPUT_ACCESSIBILITY_LABEL: 'Notes',
            NOTES_INPUT_ACCESSIBILITY_HINT: 'Enter notes for the schedule',
            SCHEDULE_LIST_CONTAINER_ACCESSIBILITY_HINT: 'Container for the schedule list',
            SCHEDULE_ITEM_ACCESSIBILITY_HINT: 'Select {{name}}',
            SCHEDULE_ITEM_ACCESSIBILITY_LABEL: '{{name}} schedule item',
            SCHEDULE_ITEM_ROW_ACCESSIBILITY_HINT: 'Row for {{name}}',
            SCHEDULE_ITEM_ROW_ACCESSIBILITY_LABEL: '{{name}} row',
            SCHEDULE_LIST_MODAL_ACCESSIBILITY_HINT: 'Modal for selecting a schedule to duplicate',
            MODAL_OVERLAY_ACCESSIBILITY_HINT: 'Overlay background for the modal',
            MODAL_CONTENT_CONTAINER_ACCESSIBILITY_HINT: 'Container holding modal content',
            CLOSE_BUTTON_ACCESSIBILITY_HINT: 'Close modal',
            CONTENT_AREA_ACCESSIBILITY_HINT: 'Scrollable content area',
            FOOTER_CONTAINER_ACCESSIBILITY_HINT: 'Footer section with action buttons',
            BACK_BUTTON_ACCESSIBILITY_HINT: 'Go back to previous screen',
            NEXT_BUTTON_ACCESSIBILITY_HINT: 'Continue with selected schedule',
            MIN_BRIGHTNESS_INPUT_ACCESSIBILITY_LABEL: 'Minimum Brightness Level Input',
            MIN_BRIGHTNESS_INPUT_ACCESSIBILITY_HINT: 'Input for minimum brightness level percentage',
            EXPAND_SETTINGS_ACCESSIBILITY_LABEL: 'Expand Settings',
            COLLAPSE_SETTINGS_ACCESSIBILITY_LABEL: 'Collapse Settings',
            SCHEDULE_SETTINGS_CONTAINER_ACCESSIBILITY_HINT: 'Container for schedule settings',
            SCHEDULE_NAME_CONTAINER_ACCESSIBILITY_HINT: 'Container for schedule name input and length display',
            SCHEDULE_NAME_INPUT_ACCESSIBILITY_HINT: 'Enter a name for the schedule',
            SCHEDULE_NAME_TEXT_LENGTH_ACCESSIBILITY_HINT:
                'Displays the current and maximum character count for the schedule name',
            DELETE_PROFILE_QUESTION: 'Delete Schedule?',
            WEEKEND: 'Weekend',
            WEEKDAYS: 'Weekdays',
            ALL_DAYS: 'All Days',
            NO_DAYS_SELECTED: 'No Days Selected',
            DIMMING_SCHEDULE: 'Dimming Schedules',
            DIMMING_SCHEDULES: 'Dimming Schedules',
            DELETE_SCHEDULE: 'Delete',
            DELETE_ALERT_MESSAGE:
                "Selecting 'Continue' will permanently delete the schedule and remove it from the zone.",
            CONTROL_PROFILE_DELETED_SUCCESSFULLY: 'Control profile deleted successfully.',
            DELETE_SCHEDULE_FAILED: 'Failed to delete schedule. Please try again.',
            SCHEDULE_LIST_MODAL_ACCESSIBILITY: 'Schedule List Modal',
            MODAL_OVERLAY_ACCESSIBILITY: 'Modal Overlay',
            MODAL_CONTENT_CONTAINER_ACCESSIBILITY: 'Modal Content Container',
            CLOSE_BUTTON_ACCESSIBILITY: 'Close',
            CONTENT_AREA_ACCESSIBILITY: 'Content Area',
            FOOTER_CONTAINER_ACCESSIBILITY: 'Footer Container',
            BACK_BUTTON_ACCESSIBILITY: 'Back Button',
            NEXT_BUTTON_ACCESSIBILITY: 'Next Button',
            BACK_BUTTON_TEXT: 'Back',
            NEXT_BUTTON_TEXT: 'Next',
            SCHEDULE_LIST_CONTAINER_ACCESSIBILITY: 'Schedule List Container',
            LIGHT_MODE_SELECTION_MODAL_ACCESSIBILITY: 'Light Mode Selection Modal',
            UPDATE_BUTTON_ACCESSIBILITY: 'Update Button',
            SCHEDULE_SELECTION_MODAL_ACCESSIBILITY: 'Schedule Selection Modal',
            CREATE_CONTROL_PROFILE_ACCESSIBILITY: 'Create Control Profile',
            NEXTBUTTON_ACCESSIBILITY: 'Next button',
            CREATE_FROM_EXISTING_PROFILE_ACCESSIBILITY: 'Create from existing control profile',
            DUPLICATE_EXISTING_PROFILE_ACCESSIBILITY: 'Duplicate an existing control profile',
            DUPLICATE_EXISTING_PROFILE_RADIO_ACCESSIBILITY: 'Duplicate an existing control profile radio button',
            PHOTO_CONTROL_SECTION_HEADER_ACCESSIBILITY: 'Photo control section header',
            HEADER_CONTENT_ACCESSIBILITY: 'Header content',
            LIGHT_MODE_TITLE_ACCESSIBILITY: 'Light mode title',
            NOTES_INPUT_ACCESSIBILITY: 'Notes',
            SCHEDULE_SETTINGS_HEADER_ACCESSIBILITY: 'Schedule settings header right component',
            SCHEDULE_SETTINGS_CONTAINER_ACCESSIBILITY: 'Schedule settings container',
            SCHEDULE_SETTINGS_EXPANDED_CONTENT_ACCESSIBILITY: 'Schedule settings expanded content',
            ACTIVE_SCHEDULE_ROW_ACCESSIBILITY_HINT: 'Active schedule row {{index}}',
            SCHEDULE_ROW_ACCESSIBILITY_HINT: 'Schedule row {{index}}',
            SCHEDULE_NAME_TEXT_LENGTH_ACCESSIBILITY: 'Schedule name text length view',
            TARGET_LIGHT_ACCESSIBILITY: 'Target Light',
            ZONE_OCCUPIED_STATE_INFORMATION_ACCESSIBILITY: 'Zone occupied state information',
            TIME_SCHEDULE_MODE_DESCRIPTION: 'Set Min & Max brightness level based on time of day and day of week.',
            TIME_SCHEDULE_OCCUPANCY_MODE_DESCRIPTION:
                'Set Min & Max brightness level based on time of day, day of week, and detected motion.',
            CONTROL_PROFILE_NAME: 'Control Profile Name*',
            MIN_BRIGHTNESS_MUST_BE_0_TO_100: 'Minimum brightness must be between 0 and 100',
            HIGH_TRIM_MUST_BE_0_TO_100: 'High Trim must be between 0 and 100',
            PHOTO_CONTROL_ONLY_MODE_DESCRIPTION:
                'Set min and max brightness based on ambient light and detected motion.',
            PHOTO_CELL_MODE_DESCRIPTION: 'Set min and max brightness based on ambient light.',
            OCCUPANCY_DETECTION_ONLY_MODE_DESCRIPTION: 'Set min and max brightness based on detected motion.',
            MIN: 'min',
            DISCARD_CHANGES_SWITCH_LIGHT_MODE: 'Discard changes and\nswitch light modes?',
            SWITCH_LIGHT_MODE_WARNING:
                'Switching light modes will reset all current control profile parameters. This action cannot be undone.',
            DISCARD_AND_SWITCH: 'Discard & Switch',
            DISCARD_CHANGES: 'Discard Changes',
            DISCARD_CHANGES_MESSAGE: 'You have unsaved changes. If you\ndiscard now, all changes will be\nlost.',
            KEEP_EDITING: 'Keep Editing',
            DISCARD_CHANGES_BTN: 'Discard Changes',
            NO_DEVICES_MODAL_TITLE: 'Save and Activate',
            NO_DEVICES_MODAL_MESSAGE:
                'As no devices under this zone.\n\nThe control profile can be saved and will be automatically applied when devices are added.',
            TIME_SCHEDULE_ONLY_MODE: 'Time Schedule Only',
            TIME_SCHEDULE_OCCUPANCY_MODE: 'Time Schedule + Occupancy',
            PHOTO_CONTROL_OCCUPANCY_MODE: 'Photo Control + Occupancy',
            PHOTO_CONTROL_ONLY_MODE: 'Photo Control Only',
            OCCUPANCY_DETECTION_ONLY_MODE: 'Occupancy Detection',
            APPLY_TO_ZONE_AND_SAVE: 'Apply to Zone and Save',
            NOT_OCCUPIED_BRIGHTNESS_LESS_THAN:
                'Not-occupied brightness ({{value}}%) must be less than occupied brightness ({{maxConstraint}}%)',
            MUST_BE_LESS_THAN_OCCUPIED: 'Must be less than occupied brightness ({{maxConstraint}}%)',
            START_END_TIME_SAME_ERROR: 'Start time and end time cannot be the same',
            FIRST_SLOT_START_ERROR: 'First time slot must start at 00:00',
            MAX_TIME_PERIOD_ERROR: 'Max time period of current slot cannot be greater than {{maxHour}} hr',
            MIN_TIME_DIFFERENCE_ERROR: 'Time slot must have at least 1 hour difference',
            SUCCESS_MODAL_TITLE_WITH_NAME: '"{{profileName}}" was successfully saved.',
            SUCCESS_MODAL_TITLE_WITHOUT_NAME: 'Profile was successfully saved.',
            SUCCESS_MODAL_TITLE_SAVED_WITH_NAME: '"{{profileName}}" was successfully saved.',
            SUCCESS_MODAL_TITLE_ACTIVATED_WITH_NAME: '"{{profileName}}" was successfully applied.',
            SUCCESS_MODAL_TITLE_ACTIVATED_WITHOUT_NAME: 'Profile was successfully applied.',
            SUCCESS_MODAL_LIGHT_MODE_LABEL: 'Light Mode: {{lightModeText}}',
        },
        FIRMWARE_UPGRADE: {
            WARNING_TEXT: 'WARNING',
            WARNING_BANNER_TEXT:
                'This device must stay cloud-connected and within mesh range during the update to prevent failure.',
            CLOSE: 'Close',
            INITIATING_CONFIGURATION: 'Initiating configuration',
            TRANSFERRING_DATA: 'Transferring data',
            REBOOTING: 'Rebooting',
            SYNCING: ' Syncing RTC Time',
            FETCHING_FW_VERSION: 'Fetching FW version',
            SYNCING_TO_LATEST_TIME: 'Syncing to latest time',
            SENDING_DATA_TO_CLOUD: 'Sending data to cloud',
            PROCESSING: 'Processing',
            PREPARING: 'Preparing for Firmware Upgrade',
            UPLOADING: 'Firmware upgrade is in progress',
            FETCHING: 'Fetching FW version',
            SEND_CLOUD: 'Sending to cloud',
            COMPLETED: 'Firmware upgrade completed',
            UPDATE_REQUIRED: 'Update Required',
            EMPTY: '',
            UP_TO_DATE: 'UP TO DATE',
            SCHEDULE_DESCRIPTION:
                'The current firmware is out of date. Schedule an update to avoid conflicting with your maintenance schedule.',
            SCHEDULE_DESCRIPTION_AFTER: 'Allow at least another {{hours}} hours for the update to complete.',
            START: 'Start',
            NOW: 'Now',
            ESTIMATED_FINISH: 'Estimated Finish',
            BASED_ON_MESH_SIZE: 'Based on mesh size',
            CHANGE_START_TIME: 'Change Start Time',
            SCHEDULE_UPDATE: 'Next',
            SCHEDULE_DATE_EXPIRED: 'The scheduled time has passed. Select a future date and time to continue.',
            SCHEDULE_DATE_EXPIRED_MODAL: {
                TITLE: 'Schedule Expired',
                OK: 'OK',
            },
            UPDATE_NOW: 'Update Now',
            FIRMWARE_UPGRADE_HEADER: 'Firmware Upgrade',
            FAILED_MESSAGE: 'First device firmware upgrade failed.',
            FIRMWARE_STATUS: 'Firmware Status',
            FIRMWARE_VERSION: 'Ver.',
            FIRMWARE_UPDATE: 'Firmware Update',
            MESH_OPERATION_NOT_PERMITTED: 'The mesh operation are not be permitted during the update.',
            FILE_DOWNLOAD_FAILED: 'Firmware file download failed.',
            FIRST_DEVICE_UPDATE: 'First Device Update:',
            ESTIMATED_TIME_PREFIX: 'Estimated time is ',
            ESTIMATED_TIME_DURATION: '5 minutes',
            ESTIMATED_TIME_SUFFIX:
                '. Please stay within range of the device during the update to ensure a successful process.',
            CALENDAR: {
                CANCEL: 'Cancel',
                SAVE: 'Save',
                START: 'Start',
                DESCRIPTION: 'The earliest time the firmware update can start is  ',
            },
            CANCEL_UPGRADE: {
                TITLE: 'Cancel Upgrade',
                MESSAGE: 'The operation was interrupted and could not be completed.',
                OK: 'OK',
                CANCEL: 'CANCEL',
            },
            SCHEDULE_UPGRADE: {
                TITLE: 'Proceed With update?',
                MESSAGE: 'This action cannot be modified later',
                ESTIMATED_FINISH: 'Estimated Finish:',
                START_UPDATE: 'Start Update',
                CANCEL: 'Cancel',
            },
            UPDATE_SCHEDULE: {
                TITLE: 'Firmware Status',
                MESSAGE:
                    'The mesh is locked for a scheduled firmware update, and no operations are permitted until <b>{{date}}</b>, at <b>{{time}}</b>.\n\nUnlocking it now will stop the firmware update  ',
                OK: 'OK',
            },
            UPTO_DATE: {
                TITLE: 'Up to Date',
                MESSAGE:
                    'Mesh is Up-To-Date with the latest firmware version {{firmwareversion}}.\n\n Mesh edits are available now.',
                OK: 'OK',
            },
            PROCESS_INTERRUPTED: {
                TITLE: 'Process Interrupted',
                MESSAGE:
                    'Ensure the app stays open and in range until the update completes.Incoming calls and notifications will interrupt the process.',
                CANCEL: 'Cancel',
                RETRY: 'Retry',
                OK: 'OK',
            },
            STAY_IN_PLACE: 'Stay In Place',
            WEAK_CONNECTION: 'Weak Connection',
            WEAK_CONNECTION_TEXT:
                'This request is taking longer than expected. Please move closer to the device you need and try again',

            DEVICE_FOUND_DESCRIPTION: 'Device connected.',
            DEVICE_UPDATE_TIME:
                'This process will take ~5 minutes. Keep the app open and stay in range until the update completes to avoid failure.',
            SELECT_OTHER_DEVICE_TITLE: 'Proceed With Update?',
            SELECT_OTHER_DEVICE_TEXT:
                'This device is already running firmware version {{version}}. And To proceed with the mesh update,move closer to another device in the same mesh and try again. ',
            DEVICE_ALREADY_UPDATED_TITLE: 'Device Already updated',
            CONNECTING_BLUETOOTH_DEVICE: 'Connecting to Bluetooth Device',
            CHECKING_BLUETOOTH_CONNECTION: 'Checking Bluetooth Connection',
            TURN_ON_BLUETOOTH_TITLE: 'Bluetooth Connection',
            TURN_ON_BLUETOOTH_TEXT:
                'Ensure Bluetooth is enabled and the mobile app is granted Bluetooth access in phone settings.',
            ENABLE_BLUETOOTH_PERMISSION_TITLE: 'Enable Bluetooth Permission',
            ENABLE_BLUETOOTH_PERMISSION_TEXT:
                'Bluetooth permission is disabled. Please grant permission in Settings to proceed.',
            DEVICE_NOT_FOUND_TEXT:
                'Move closer to same device and try again. If it keeps failing, try moving closer to another device in the same mesh/ group.',
            OK: 'Ok',
            CONTINUE: 'Continue',
            CANCEL: 'Cancel',
            FW_UPGRADE_SUCCESS: 'First device Firmware upgrade successfully.',
            FW_UPGRADE_FAIL: 'First device firmware upgrade failed.',
            FILE_NOT_FOUND: 'Firmware file not found. Please try again.',
            LOW_BATTERY: {
                TITLE: 'Low Battery',
                MESSAGE: 'Phone battery is below 20%. Charge the device and restart the update.',
                OK: 'Ok',
            },
            FIRST_DEVICE_OTA_FAILED: {
                TITLE: 'Update Failed',
                MESSAGE: 'First device firmware update failed.\n\nRetry firmware update after <b>{{retryTime}}</b>',
                OK: 'OK',
            },
            DOWNLOAD_STEP_IN_PROGRESS: 'Downloading code pack file',
            DOWNLOAD_STEP_SUCCESS: 'Downloaded code pack file',
            DOWNLOAD_STEP_ERROR_TITLE: 'Unable to download code pack file',
            CODEPACK_DOWNLOAD_FAILED: 'The code pack file couldn’t be downloaded. Tap to retry again',
            BLUETOOTH_STEP_IN_PROGRESS: 'Check Bluetooth connection',
            BLUETOOTH_STEP_SUCCESS: 'Bluetooth connection stable',
            BLUETOOTH_STEP_ERROR_TITLE: 'Unable to connect to Bluetooth',
            CONNECTION_STEP_LABEL: 'Establish device connection',
            CONNECTION_STEP_ERROR_TITLE: 'Unable to establish device connection',
            CONNECTION_STEP_ERROR_MESSAGE:
                'Move closer to the device and try again. If it keeps failing, try moving closer to another device in the same Mesh / Zone.',
            MESH_LOCK_TITLE: 'Mesh Locked',
            UNLOCK_MESH: 'Unlock Mesh',
            MESH_LOCK_DESCRIPTION:
                'Mesh is locked because another operation is currently in progress. A new update cannot be initiated at this time.',
            MESH_LOCK_RETRY_PREFIX: 'Retry the operation after mesh unlocks at ',
            MESH_LOCK_RETRY_SUFFIX: '.',
            MESH_LOCK_TEXT:
                'Mesh is locked because another operation is currently in progress. A new update cannot be initiated at this time.<br/><br/>Retry the operation after mesh unlocks at <b>{{unlockTime}}</b>.',
            SCHEDULED_PAGE_TITLE: 'Schedule Firmware Update',
            FIRMWRE_PAGE_TITLE: 'Start Firmware Update',
            NEXT: 'Next',
            STEP_SINGLE: 'Step 1 of 2',
            STEP_ONE: 'Step 1 of 1',
            STEP_MULTIPLE: 'Step 2 of 2',
            DEVICE_LEVEL_CONFIRMATION_MODAL: {
                TITLE: 'Version {{version}} Available. Update now?',
                MESSAGE: 'A new one-to-one OTA update is ready for this device.?',
                CONFIRM: 'Update',
                CANCEL: 'Later',
            },
            SCHEDULED_OTA_ALERT: {
                TITLE: 'Mesh OTA schedule in progress',
                MESSAGE: 'Mesh OTA schedule in progress.\nRetry the operation after mesh unlocks.',
            },
            COMPATIBILITY: {
                NON_COMPATIBLE: {
                    TITLE: 'Update Cannot be Initiated',
                    MESSAGE_BEFORE:
                        'Firmware update cannot be initiated as some devices have incompatible firmware version. Click on ',
                    MESSAGE_BOLD: '"View Device List"',
                    MESSAGE_AFTER: ' and remove those devices to proceed.',
                    VIEW_DEVICE_LIST: 'View Device List',
                    FIRMWARE_UPGRADE: 'Firmware Upgrade',
                },
                DELETE_DEVICE: {
                    TITLE: 'Delete device?',
                    MESSAGE_BEFORE: 'The device is now running on ',
                    MESSAGE_BOLD: 'Firmware Version {{version}}',
                    MESSAGE_AFTER: ', which is incompatible.',
                    MESSAGE_EXTRA: 'Delete this device to proceed with the update.',
                    CONFIRM: 'Delete',
                },
                DELETE_DEVICE_FAILED: {
                    TITLE: 'Firmware Version',
                    MESSAGE: 'Firmware connection failed.',
                    MESSAGE_EXTRA:
                        'Move closer to same device and try again. If it keeps failing, try moving closer to another device in the same mesh/ zone.',
                },
                VALID_FW_VERSION: {
                    TITLE: 'Firmware Version',
                    MESSAGE: 'The devices are now running on firmware version {{version}}, which is fully compatible.',
                    CONFIRM: 'Continue',
                },
                CONFIGURATION_FAILED: {
                    TITLE: 'Configuration Failed',
                    MESSAGE:
                        'Device configuration cannot be proceed as this device running on incompatible version.\n\nThis device will be removed from the mesh network. Click "<b>Delete</b>" to confirm.',
                    CONFIRM: 'Delete',
                },
                NON_COMPATIBLE_SCREEN: {
                    WARNING_TEXT:
                        'To proceed with the firmware update, devices running on firmware versions below {{minVersion}} must be deleted from the mesh.',
                    SECTION_HEADER: 'Incompatible Devices ({{count}})',
                    FIRMWARE_VERSION: 'Firmware Ver. {{version}}',
                },
            },
        },
        SELECT_DEVICE_TYPE: {
            SELECT_DEVICE_TYPE_TITLE: 'Select Device Type',
            ADD_DEVICE_TYPE: 'Unknown devices needs to add device type.',
            MISSING_INFORMATION_TITLE: 'Missing Information',
            MISSING_INFORMATION_SUBTITLE: 'Please select a device type for unknown devices to proceed next.',
        },
    },
    WIDGETS: {
        BALANCING: {
            SELECT_ASSET_S: 'Select Asset(s)',
            EMPTY_LOAD_GROUPS: 'No load groups found',
            MULTIPLE_DEVICES: 'Multiple Devices',
            DELETE_AUTOMATIONS_DESCRIPTION:
                "To continue deleting {{count}} load balancing automation(s) select the 'Delete' button or select cancel to go back.",
            DELETE_SUCCESS: '{{count}} load balancing Automation(s) have been deleted',
            DELETE_AUTOMATIONS_DESCRIPTION_COUNT:
                "To continue deleting {{count}} load balancing automation(s) select the 'Delete' button or select cancel to go back.",
            DELETE_SUCCESS_COUNT: '{{count}} load balancing Automation(s) have been deleted',
        },
    },
    RAMP_SHED: {
        HEADERS: {
            RAMP: 'Ramp',
            SHED: 'Shed',
            DELAY: 'Delay',
            RAMPSHED: 'Ramp Shed',
        },
        LABELS: {
            SEC: 'sec',
            NAME_FILTER: 'Name',
            RAMP: 'Ramp',
            SHED: 'Shed',
            RAMPING: 'ramping',
            SHEDDING: 'shedding',
            IN_PROGRESS: 'in Progress',
            BEGIN_ACTION_TITLE: 'Begin {{actionVerb}} selected loads?',
            ACTION_STARTED: '{{actionLabel}} has started.',
            ACTION_COMPLETE: '{{actionLabel}} complete',
            PULLING_DEVICE_STATE: 'Pulling Device for Ramp Shed Settings',
            NO_LOADS_MATCH: 'No loads match your search',
            DISCARD_CHANGES_TITLE: 'Discard Changes?',
            PLANNED: 'Planned',
            CHANGES_SAVED: 'Changes have been saved.',
            ACTION_FAILED: '{{actionLabel}} action failed.',
            RAMP_STARTED: 'Ramp has started.',
            SHED_STARTED: 'Shed has started.',
            RAMP_COMPLETE: 'Ramp complete.',
            SHED_COMPLETE: 'Shed complete.',
            SYNC_IN_PROGRESS:
                'Device configuration changes are temporarily unavailable because a ramp/shed synchronization is currently in progress.',
            RAMP_TIMEOUT: 'Ramp Timed Out',
            SHED_TIMEOUT: 'Shed Timed Out',
        },
        BUTTONS: {
            CANCEL: 'Cancel',
            SAVE: 'Save',
            DISCARD_CHANGES: 'Discard Changes',
            BEGIN_RAMP: 'Begin Ramp',
            BEGIN_SHED: 'Begin Shed',
            EDIT: 'Edit',
            BEGIN_ACTION: 'Begin {{actionLabel}}',
        },
        PLACEHOLDERS: {
            SEARCH: 'Search',
        },
        DESCRIPTIONS: {
            DISCARD_CHANGES: 'This cannot be undone.',
            LOAD_ERROR: 'Failed to load ramp shed data. Please try again later.',
        },
    },
    SEPARATOR_FORMAT: {
        POINT: '.(Point)',
        COMMA: ',(Comma)',
    },
    EXPORT_DOWNLOAD_DATA: {
        TITLE: 'Export & Download Data',
        DESCRIPTION:
            'The EU Data Act is a European law designed to give you more control over the data generated when you use connected products and digital services. It ensures that you can easily access, download, and reuse your data in a clear and secure way, without unnecessary delays or obstacles. This page lets you exercise that right by downloading your data in a commonly used, machine-readable format, so you can review it for your own use or share it with another service if you choose.',
        COLLECT_BUTTON: 'Collect Data for Export',
        COLLECTION_STARTED:
            'Data collection for export began {{dateTime}}. The data export process can take a while, please come back later to this page to download the file once processing is ready.',
        ERROR_MESSAGE: 'There was an error with your most recent data export. Please try again.',
        DOWNLOAD_BUTTON: 'Download Most Recent CSV Export',
        DATE_TIME_LABEL: 'Date and Time:',
        FILE_SIZE_LABEL: 'File Size:',
        FAILED_FETCH_URL: 'Failed to fetch download URL',
        // CollectData page strings
        COLLECT_DATA_HEADER: 'Collect Data for Export',
        STEP_DEVICE_SELECTION: 'Device Selection',
        STEP_DATE_RANGE: 'Date Range',
        STEP_SUMMARY: 'Summary',
        DEVICE_SELECTION_TITLE: 'Device Selection',
        DEVICE_SELECTION_DESCRIPTION: 'Select devices to include in the data export.',
        DEVICES_SELECTED: '{{selected}} of {{total}} devices selected',
        CHOOSE_DATE_RANGE: 'Choose date range',
        DATE_RANGE_DESCRIPTION: 'Select the date range (in days) for your data export.',
        SUMMARY_TITLE: 'Summary Export Data',
        SUMMARY_DESCRIPTION: 'Review and confirm your data summary for CSV export.',
        DEVICES_SELECTED_LABEL: 'Devices Selected:',
        DATE_RANGE_LABEL: 'Date Range:',
        ESTIMATED_FILE_SIZE: 'Estimated File Size:',
        COLLECTION_BEGUN: 'Data collection for export has begun',
        FAILED_START_COLLECTION: 'Failed to start data collection for export',
        FAILED_LOAD_HIERARCHY: 'Failed to load hierarchy data. Please try again.',
    },
};
export default resources;
